unit View.Itens_Saida.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewItens_SaidaEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbvenda_id: TLabel;
    edvenda_id: TDBEdit;
    lbproduto_id: TLabel;
    edproduto_id: TDBEdit;
    lbunidade_id: TLabel;
    edunidade_id: TDBEdit;
    lbitem: TLabel;
    editem: TDBEdit;
    lbcfop_cfop: TLabel;
    edcfop_cfop: TDBEdit;
    lbquantidade: TLabel;
    edquantidade: TDBEdit;
    lbproduto_preco: TLabel;
    edproduto_preco: TDBEdit;
    lbmargem_acrescimo: TLabel;
    edmargem_acrescimo: TDBEdit;
    lbvalor_acrescimo: TLabel;
    edvalor_acrescimo: TDBEdit;
    lbmargem_desconto: TLabel;
    edmargem_desconto: TDBEdit;
    lbvalor_desconto: TLabel;
    edvalor_desconto: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbaliquota_icms: TLabel;
    edaliquota_icms: TDBEdit;
    lbvalor_icms: TLabel;
    edvalor_icms: TDBEdit;
    lbaliquota_icms_red: TLabel;
    edaliquota_icms_red: TDBEdit;
    lbvalor_icms_red: TLabel;
    edvalor_icms_red: TDBEdit;
    lbaliquota_icms_st: TLabel;
    edaliquota_icms_st: TDBEdit;
    lbvalor_icms_st: TLabel;
    edvalor_icms_st: TDBEdit;
    lbaliquota_ipi: TLabel;
    edaliquota_ipi: TDBEdit;
    lbvalor_ipi: TLabel;
    edvalor_ipi: TDBEdit;
    lbvalor_base_calculo_icms: TLabel;
    edvalor_base_calculo_icms: TDBEdit;
    lbvalor_base_calculo_st: TLabel;
    edvalor_base_calculo_st: TDBEdit;
    lbcst_id: TLabel;
    edcst_id: TDBEdit;
    lbvalor_frete: TLabel;
    edvalor_frete: TDBEdit;
    lbvalor_seguro: TLabel;
    edvalor_seguro: TDBEdit;
    lbvalor_despesas_acessorias: TLabel;
    edvalor_despesas_acessorias: TDBEdit;
    lbvalor_outras: TLabel;
    edvalor_outras: TDBEdit;
    lbvalor_base_calculo_ipi: TLabel;
    edvalor_base_calculo_ipi: TDBEdit;
    lbvalor_base_calculo_pis: TLabel;
    edvalor_base_calculo_pis: TDBEdit;
    lbvalor_pis: TLabel;
    edvalor_pis: TDBEdit;
    lbvalor_base_calculo_cofins: TLabel;
    edvalor_base_calculo_cofins: TDBEdit;
    lbvalor_cofins: TLabel;
    edvalor_cofins: TDBEdit;
    lbquantidade_selo_ipi: TLabel;
    edquantidade_selo_ipi: TDBEdit;
    lbcst_ipi_id: TLabel;
    edcst_ipi_id: TDBEdit;
    lbcsosn_id: TLabel;
    edcsosn_id: TDBEdit;
    lbvalor_ipi_unitario: TLabel;
    edvalor_ipi_unitario: TDBEdit;
    lbaliquota_pis: TLabel;
    edaliquota_pis: TDBEdit;
    lbaliquota_cofins: TLabel;
    edaliquota_cofins: TDBEdit;
    lbcst_pis_id: TLabel;
    edcst_pis_id: TDBEdit;
    lbcst_cofins_id: TLabel;
    edcst_cofins_id: TDBEdit;
    lbvalor_base_calculo_st_retida: TLabel;
    edvalor_base_calculo_st_retida: TDBEdit;
    lbvalor_st_retida: TLabel;
    edvalor_st_retida: TDBEdit;
    lbvalor_pis_retido: TLabel;
    edvalor_pis_retido: TDBEdit;
    lbvalor_cofins_retido: TLabel;
    edvalor_cofins_retido: TDBEdit;
    lbcodigo_natureza_pis_cofins_id: TLabel;
    edcodigo_natureza_pis_cofins_id: TDBEdit;
    lbaliquota_id: TLabel;
    edaliquota_id: TDBEdit;
    lbvalor_isentas: TLabel;
    edvalor_isentas: TDBEdit;
    lbproduto_preco_custo: TLabel;
    edproduto_preco_custo: TDBEdit;
    lbcodigo_produto_movimenta_estoque: TLabel;
    edcodigo_produto_movimenta_estoque: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbvalor_total_impostos: TLabel;
    edvalor_total_impostos: TDBEdit;
    lbquantidade_embalagem: TLabel;
    edquantidade_embalagem: TDBEdit;
    lbitem_movimenta_estoque: TLabel;
    editem_movimenta_estoque: TDBEdit;
    lbgrade_produto_id: TLabel;
    edgrade_produto_id: TDBEdit;
    lbproduto_nome: TLabel;
    edproduto_nome: TDBEdit;
    lbaliquota_interna: TLabel;
    edaliquota_interna: TDBEdit;
    lbaliquota_interestadual: TLabel;
    edaliquota_interestadual: TDBEdit;
    lbvalor_base_calculo_icms_interestadual: TLabel;
    edvalor_base_calculo_icms_interestadual: TDBEdit;
    lbaliquota_icms_interestadual_destino: TLabel;
    edaliquota_icms_interestadual_destino: TDBEdit;
    lbvalor_icms_interestadual_destino: TLabel;
    edvalor_icms_interestadual_destino: TDBEdit;
    lbvalor_icms_interestadual_remetente: TLabel;
    edvalor_icms_interestadual_remetente: TDBEdit;
    lbaliquota_fcp: TLabel;
    edaliquota_fcp: TDBEdit;
    lbvalor_fcp: TLabel;
    edvalor_fcp: TDBEdit;
    lbnumero_pedido_compra: TLabel;
    ednumero_pedido_compra: TDBEdit;
    lbitem_pedido_compra: TLabel;
    editem_pedido_compra: TDBEdit;
    lbitem_quantidade_movimenta_estoque: TLabel;
    editem_quantidade_movimenta_estoque: TDBEdit;
    lbicms_st_recuperado: TLabel;
    edicms_st_recuperado: TDBEdit;
    lborigem_csosn_id: TLabel;
    edorigem_csosn_id: TDBEdit;
    lbpercentual_gnn: TLabel;
    edpercentual_gnn: TDBEdit;
    lbpercentual_gni: TLabel;
    edpercentual_gni: TDBEdit;
    lbpercentual_glp: TLabel;
    edpercentual_glp: TDBEdit;
    lbvalor_partida: TLabel;
    edvalor_partida: TDBEdit;
    lbaliquota_st: TLabel;
    edaliquota_st: TDBEdit;
    lbvalor_icms_st_reducao: TLabel;
    edvalor_icms_st_reducao: TDBEdit;
    lbaliquota_st_retida: TLabel;
    edaliquota_st_retida: TDBEdit;
    lbvalor_icms_proprio: TLabel;
    edvalor_icms_proprio: TDBEdit;
    lbaliquota_icms_simples_nacional: TLabel;
    edaliquota_icms_simples_nacional: TDBEdit;
    lbvalor_icms_simples_nacional: TLabel;
    edvalor_icms_simples_nacional: TDBEdit;
    lbvalor_icms_desonerado: TLabel;
    edvalor_icms_desonerado: TDBEdit;
    lbdesoneracao_icms_id: TLabel;
    eddesoneracao_icms_id: TDBEdit;
    lbaliquota_ipi_devolvido: TLabel;
    edaliquota_ipi_devolvido: TDBEdit;
    lbvalor_ipi_devolvido: TLabel;
    edvalor_ipi_devolvido: TDBEdit;
    lbmotivo_devolucao_ipi: TLabel;
    edmotivo_devolucao_ipi: TDBEdit;
    lbdesoneracao_icms_st_id: TLabel;
    eddesoneracao_icms_st_id: TDBEdit;
    lbvalor_icms_st_desonerado: TLabel;
    edvalor_icms_st_desonerado: TDBEdit;
    lbobservacoes_contribuinte_identificacao: TLabel;
    edobservacoes_contribuinte_identificacao: TDBEdit;
    lbobservacoes_contribuinte: TLabel;
    edobservacoes_contribuinte: TDBEdit;
    lbobservacoes_fisco_identificacao: TLabel;
    edobservacoes_fisco_identificacao: TDBEdit;
    lbobservacoes_fisco: TLabel;
    edobservacoes_fisco: TDBEdit;
    lbcodigo_produto_anvisa: TLabel;
    edcodigo_produto_anvisa: TDBEdit;
    lbmotivo_isencao_anvisa: TLabel;
    edmotivo_isencao_anvisa: TDBEdit;
    lbpreco_maximo_consumidor: TLabel;
    edpreco_maximo_consumidor: TDBEdit;
    lbrastreabilidade_numero_lote: TLabel;
    edrastreabilidade_numero_lote: TDBEdit;
    lbrastreabilidade_data_fabricacao: TLabel;
    edrastreabilidade_data_fabricacao: TDBEdit;
    lbrastreabilidade_data_validade: TLabel;
    edrastreabilidade_data_validade: TDBEdit;
    lbrastreabilidade_codigo_agregacao: TLabel;
    edrastreabilidade_codigo_agregacao: TDBEdit;
    lbvalor_base_calculo_fcp_icms: TLabel;
    edvalor_base_calculo_fcp_icms: TDBEdit;
    lbaliquota_fcp_icms: TLabel;
    edaliquota_fcp_icms: TDBEdit;
    lbvalor_fcp_icms: TLabel;
    edvalor_fcp_icms: TDBEdit;
    lbvalor_base_calculo_fcp_st: TLabel;
    edvalor_base_calculo_fcp_st: TDBEdit;
    lbaliquota_fcp_st: TLabel;
    edaliquota_fcp_st: TDBEdit;
    lbvalor_fcp_st: TLabel;
    edvalor_fcp_st: TDBEdit;
    lbvalor_base_calculo_fcp_retida: TLabel;
    edvalor_base_calculo_fcp_retida: TDBEdit;
    lbaliquota_fcp_retida: TLabel;
    edaliquota_fcp_retida: TDBEdit;
    lbvalor_fcp_retida: TLabel;
    edvalor_fcp_retida: TDBEdit;
    lbinformacoes_adicionais: TLabel;
    edinformacoes_adicionais: TDBEdit;
    lbquantidade_monofasica: TLabel;
    edquantidade_monofasica: TDBEdit;
    lbaliquota_ad_rem: TLabel;
    edaliquota_ad_rem: TDBEdit;
    lbvalor_icms_monofasico: TLabel;
    edvalor_icms_monofasico: TDBEdit;
    lbquantidade_monofasica_retida: TLabel;
    edquantidade_monofasica_retida: TDBEdit;
    lbaliquota_ad_rem_retida: TLabel;
    edaliquota_ad_rem_retida: TDBEdit;
    lbvalor_icms_monofasico_retido: TLabel;
    edvalor_icms_monofasico_retido: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientItens_SaidaGet: TXDataWebClient;
    XDataClientItens_SaidaDelete: TXDataWebClient;
    Itens_SaidaDataset: TXDataWebDataSet;
    Itens_SaidaDatasetid: TIntegerField;
    Itens_SaidaDatasetaliado_id: TIntegerField;
    Itens_SaidaDatasetdata_base_id: TIntegerField;
    Itens_SaidaDatasetvenda_id: TIntegerField;
    Itens_SaidaDatasetproduto_id: TIntegerField;
    Itens_SaidaDatasetunidade_id: TIntegerField;
    Itens_SaidaDatasetitem: TIntegerField;
    Itens_SaidaDatasetcfop_cfop: TStringField;
    Itens_SaidaDatasetquantidade: TFloatField;
    Itens_SaidaDatasetproduto_preco: TFloatField;
    Itens_SaidaDatasetmargem_acrescimo: TFloatField;
    Itens_SaidaDatasetvalor_acrescimo: TFloatField;
    Itens_SaidaDatasetmargem_desconto: TFloatField;
    Itens_SaidaDatasetvalor_desconto: TFloatField;
    Itens_SaidaDatasetvalor_total: TFloatField;
    Itens_SaidaDatasetaliquota_icms: TFloatField;
    Itens_SaidaDatasetvalor_icms: TFloatField;
    Itens_SaidaDatasetaliquota_icms_red: TFloatField;
    Itens_SaidaDatasetvalor_icms_red: TFloatField;
    Itens_SaidaDatasetaliquota_icms_st: TFloatField;
    Itens_SaidaDatasetvalor_icms_st: TFloatField;
    Itens_SaidaDatasetaliquota_ipi: TFloatField;
    Itens_SaidaDatasetvalor_ipi: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_icms: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_st: TFloatField;
    Itens_SaidaDatasetcst_id: TStringField;
    Itens_SaidaDatasetvalor_frete: TFloatField;
    Itens_SaidaDatasetvalor_seguro: TFloatField;
    Itens_SaidaDatasetvalor_despesas_acessorias: TFloatField;
    Itens_SaidaDatasetvalor_outras: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_ipi: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_pis: TFloatField;
    Itens_SaidaDatasetvalor_pis: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_cofins: TFloatField;
    Itens_SaidaDatasetvalor_cofins: TFloatField;
    Itens_SaidaDatasetquantidade_selo_ipi: TIntegerField;
    Itens_SaidaDatasetcst_ipi_id: TStringField;
    Itens_SaidaDatasetcsosn_id: TStringField;
    Itens_SaidaDatasetvalor_ipi_unitario: TFloatField;
    Itens_SaidaDatasetaliquota_pis: TFloatField;
    Itens_SaidaDatasetaliquota_cofins: TFloatField;
    Itens_SaidaDatasetcst_pis_id: TStringField;
    Itens_SaidaDatasetcst_cofins_id: TStringField;
    Itens_SaidaDatasetvalor_base_calculo_st_retida: TFloatField;
    Itens_SaidaDatasetvalor_st_retida: TFloatField;
    Itens_SaidaDatasetvalor_pis_retido: TFloatField;
    Itens_SaidaDatasetvalor_cofins_retido: TFloatField;
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id: TStringField;
    Itens_SaidaDatasetaliquota_id: TIntegerField;
    Itens_SaidaDatasetvalor_isentas: TFloatField;
    Itens_SaidaDatasetproduto_preco_custo: TFloatField;
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque: TIntegerField;
    Itens_SaidaDatasetfuncionario_id: TIntegerField;
    Itens_SaidaDatasetvalor_total_impostos: TFloatField;
    Itens_SaidaDatasetquantidade_embalagem: TIntegerField;
    Itens_SaidaDatasetitem_movimenta_estoque: TBooleanField;
    Itens_SaidaDatasetgrade_produto_id: TIntegerField;
    Itens_SaidaDatasetproduto_nome: TStringField;
    Itens_SaidaDatasetaliquota_interna: TFloatField;
    Itens_SaidaDatasetaliquota_interestadual: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual: TFloatField;
    Itens_SaidaDatasetaliquota_icms_interestadual_destino: TFloatField;
    Itens_SaidaDatasetvalor_icms_interestadual_destino: TFloatField;
    Itens_SaidaDatasetvalor_icms_interestadual_remetente: TFloatField;
    Itens_SaidaDatasetaliquota_fcp: TFloatField;
    Itens_SaidaDatasetvalor_fcp: TFloatField;
    Itens_SaidaDatasetnumero_pedido_compra: TStringField;
    Itens_SaidaDatasetitem_pedido_compra: TIntegerField;
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque: TFloatField;
    Itens_SaidaDataseticms_st_recuperado: TBooleanField;
    Itens_SaidaDatasetorigem_csosn_id: TIntegerField;
    Itens_SaidaDatasetpercentual_gnn: TFloatField;
    Itens_SaidaDatasetpercentual_gni: TFloatField;
    Itens_SaidaDatasetpercentual_glp: TFloatField;
    Itens_SaidaDatasetvalor_partida: TFloatField;
    Itens_SaidaDatasetaliquota_st: TFloatField;
    Itens_SaidaDatasetvalor_icms_st_reducao: TFloatField;
    Itens_SaidaDatasetaliquota_st_retida: TFloatField;
    Itens_SaidaDatasetvalor_icms_proprio: TFloatField;
    Itens_SaidaDatasetaliquota_icms_simples_nacional: TFloatField;
    Itens_SaidaDatasetvalor_icms_simples_nacional: TFloatField;
    Itens_SaidaDatasetvalor_icms_desonerado: TFloatField;
    Itens_SaidaDatasetdesoneracao_icms_id: TIntegerField;
    Itens_SaidaDatasetaliquota_ipi_devolvido: TFloatField;
    Itens_SaidaDatasetvalor_ipi_devolvido: TFloatField;
    Itens_SaidaDatasetmotivo_devolucao_ipi: TStringField;
    Itens_SaidaDatasetdesoneracao_icms_st_id: TIntegerField;
    Itens_SaidaDatasetvalor_icms_st_desonerado: TFloatField;
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao: TStringField;
    Itens_SaidaDatasetobservacoes_contribuinte: TStringField;
    Itens_SaidaDatasetobservacoes_fisco_identificacao: TStringField;
    Itens_SaidaDatasetobservacoes_fisco: TStringField;
    Itens_SaidaDatasetcodigo_produto_anvisa: TStringField;
    Itens_SaidaDatasetmotivo_isencao_anvisa: TStringField;
    Itens_SaidaDatasetpreco_maximo_consumidor: TFloatField;
    Itens_SaidaDatasetrastreabilidade_numero_lote: TStringField;
    Itens_SaidaDatasetrastreabilidade_data_fabricacao: TDateTimeField;
    Itens_SaidaDatasetrastreabilidade_data_validade: TDateTimeField;
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao: TStringField;
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms: TFloatField;
    Itens_SaidaDatasetaliquota_fcp_icms: TFloatField;
    Itens_SaidaDatasetvalor_fcp_icms: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_fcp_st: TFloatField;
    Itens_SaidaDatasetaliquota_fcp_st: TFloatField;
    Itens_SaidaDatasetvalor_fcp_st: TFloatField;
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida: TFloatField;
    Itens_SaidaDatasetaliquota_fcp_retida: TFloatField;
    Itens_SaidaDatasetvalor_fcp_retida: TFloatField;
    Itens_SaidaDatasetinformacoes_adicionais: TStringField;
    Itens_SaidaDatasetquantidade_monofasica: TFloatField;
    Itens_SaidaDatasetaliquota_ad_rem: TFloatField;
    Itens_SaidaDatasetvalor_icms_monofasico: TFloatField;
    Itens_SaidaDatasetquantidade_monofasica_retida: TFloatField;
    Itens_SaidaDatasetaliquota_ad_rem_retida: TFloatField;
    Itens_SaidaDatasetvalor_icms_monofasico_retido: TFloatField;
    Itens_SaidaDatasetcodigo_interno: TIntegerField;
    Itens_SaidaDatasetexcluido: TBooleanField;
    Itens_SaidaDatasetinclusao: TDateTimeField;
    Itens_SaidaDatasetalteracao: TDateTimeField;
    Itens_SaidaDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientItens_SaidaGetLoad(Response: TXDataClientResponse);
    procedure XDataClientItens_SaidaDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientItens_SaidaDeleteError(Error: TXDataClientError);
    procedure Itens_SaidaDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewItens_SaidaEdit: TFViewItens_SaidaEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewItens_SaidaEdit }

procedure TFViewItens_SaidaEdit.btSaveClick(Sender: TObject);
begin
  if Itens_SaidaDataset.State in dsEditModes then
  begin
        Itens_SaidaDataset.Post;
    Itens_SaidaDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewItens_SaidaEdit.btDeleteClick(Sender: TObject);
begin
  if Itens_SaidaDataset.State in dsEditModes then
    Itens_SaidaDataset.Post;
  XDataClientItens_SaidaDelete.Delete(Itens_SaidaDataset.EntitySetName,
    TJSObject(Itens_SaidaDataset.CurrentData));
end;


class function TFViewItens_SaidaEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewItens_SaidaEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewItens_SaidaEdit.InsertEntity;
begin
  Itens_SaidaDataset.Close;
  Itens_SaidaDataset.SetJsonData('{}');
  Itens_SaidaDataset.Open;
  Itens_SaidaDataset.Insert;
end;

class function TFViewItens_SaidaEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewItens_SaidaEdit(AForm).FInserting := AInserting;
    TFViewItens_SaidaEdit(AForm).FId := AId;
    TFViewItens_SaidaEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewItens_SaidaEdit(AForm).InsertEntity
    else
      TFViewItens_SaidaEdit(AForm).LoadEntity;
    TFViewItens_SaidaEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewItens_SaidaEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewItens_SaidaEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Itens_SaidaDataset.Connection.Model.DefaultSchema.FindEntityType(
      Itens_SaidaDataset.EntitySetName
    )
  );
  XDataClientItens_SaidaGet.Get(Itens_SaidaDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewItens_SaidaEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewItens_SaidaEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewItens_SaidaEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewItens_SaidaEdit.XDataClientItens_SaidaGetLoad(Response: TXDataClientResponse);
begin
  Itens_SaidaDataset.Close;
  Itens_SaidaDataset.SetJsonData(Response.Result);
  Itens_SaidaDataset.Open;
  
  Itens_SaidaDataset.Edit;  
end;

procedure TFViewItens_SaidaEdit.XDataClientItens_SaidaDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewItens_SaidaEdit.XDataClientItens_SaidaDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewItens_SaidaEdit.Itens_SaidaDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewItens_SaidaEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewItens_SaidaEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.itens_saida.form.message');
  lbMessage := TLabel.Create('view.itens_saida.form.message.label');
  btCloseMessage := TButton.Create('view.itens_saida.form.message.button');
  btCancel := TButton.Create('view.itens_saida.form.btBack');
  btSave := TButton.Create('view.itens_saida.form.btSave');
  btDelete := TButton.Create('view.itens_saida.form.btDelete');
  lbid := TLabel.Create('view.itens_saida.form.lbid');
  edid := TDBEdit.Create('view.itens_saida.form.edid');
  lbaliado_id := TLabel.Create('view.itens_saida.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.itens_saida.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.itens_saida.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.itens_saida.form.eddata_base_id');
  lbvenda_id := TLabel.Create('view.itens_saida.form.lbvenda_id');
  edvenda_id := TDBEdit.Create('view.itens_saida.form.edvenda_id');
  lbproduto_id := TLabel.Create('view.itens_saida.form.lbproduto_id');
  edproduto_id := TDBEdit.Create('view.itens_saida.form.edproduto_id');
  lbunidade_id := TLabel.Create('view.itens_saida.form.lbunidade_id');
  edunidade_id := TDBEdit.Create('view.itens_saida.form.edunidade_id');
  lbitem := TLabel.Create('view.itens_saida.form.lbitem');
  editem := TDBEdit.Create('view.itens_saida.form.editem');
  lbcfop_cfop := TLabel.Create('view.itens_saida.form.lbcfop_cfop');
  edcfop_cfop := TDBEdit.Create('view.itens_saida.form.edcfop_cfop');
  lbquantidade := TLabel.Create('view.itens_saida.form.lbquantidade');
  edquantidade := TDBEdit.Create('view.itens_saida.form.edquantidade');
  lbproduto_preco := TLabel.Create('view.itens_saida.form.lbproduto_preco');
  edproduto_preco := TDBEdit.Create('view.itens_saida.form.edproduto_preco');
  lbmargem_acrescimo := TLabel.Create('view.itens_saida.form.lbmargem_acrescimo');
  edmargem_acrescimo := TDBEdit.Create('view.itens_saida.form.edmargem_acrescimo');
  lbvalor_acrescimo := TLabel.Create('view.itens_saida.form.lbvalor_acrescimo');
  edvalor_acrescimo := TDBEdit.Create('view.itens_saida.form.edvalor_acrescimo');
  lbmargem_desconto := TLabel.Create('view.itens_saida.form.lbmargem_desconto');
  edmargem_desconto := TDBEdit.Create('view.itens_saida.form.edmargem_desconto');
  lbvalor_desconto := TLabel.Create('view.itens_saida.form.lbvalor_desconto');
  edvalor_desconto := TDBEdit.Create('view.itens_saida.form.edvalor_desconto');
  lbvalor_total := TLabel.Create('view.itens_saida.form.lbvalor_total');
  edvalor_total := TDBEdit.Create('view.itens_saida.form.edvalor_total');
  lbaliquota_icms := TLabel.Create('view.itens_saida.form.lbaliquota_icms');
  edaliquota_icms := TDBEdit.Create('view.itens_saida.form.edaliquota_icms');
  lbvalor_icms := TLabel.Create('view.itens_saida.form.lbvalor_icms');
  edvalor_icms := TDBEdit.Create('view.itens_saida.form.edvalor_icms');
  lbaliquota_icms_red := TLabel.Create('view.itens_saida.form.lbaliquota_icms_red');
  edaliquota_icms_red := TDBEdit.Create('view.itens_saida.form.edaliquota_icms_red');
  lbvalor_icms_red := TLabel.Create('view.itens_saida.form.lbvalor_icms_red');
  edvalor_icms_red := TDBEdit.Create('view.itens_saida.form.edvalor_icms_red');
  lbaliquota_icms_st := TLabel.Create('view.itens_saida.form.lbaliquota_icms_st');
  edaliquota_icms_st := TDBEdit.Create('view.itens_saida.form.edaliquota_icms_st');
  lbvalor_icms_st := TLabel.Create('view.itens_saida.form.lbvalor_icms_st');
  edvalor_icms_st := TDBEdit.Create('view.itens_saida.form.edvalor_icms_st');
  lbaliquota_ipi := TLabel.Create('view.itens_saida.form.lbaliquota_ipi');
  edaliquota_ipi := TDBEdit.Create('view.itens_saida.form.edaliquota_ipi');
  lbvalor_ipi := TLabel.Create('view.itens_saida.form.lbvalor_ipi');
  edvalor_ipi := TDBEdit.Create('view.itens_saida.form.edvalor_ipi');
  lbvalor_base_calculo_icms := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_icms');
  edvalor_base_calculo_icms := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_icms');
  lbvalor_base_calculo_st := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_st');
  edvalor_base_calculo_st := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_st');
  lbcst_id := TLabel.Create('view.itens_saida.form.lbcst_id');
  edcst_id := TDBEdit.Create('view.itens_saida.form.edcst_id');
  lbvalor_frete := TLabel.Create('view.itens_saida.form.lbvalor_frete');
  edvalor_frete := TDBEdit.Create('view.itens_saida.form.edvalor_frete');
  lbvalor_seguro := TLabel.Create('view.itens_saida.form.lbvalor_seguro');
  edvalor_seguro := TDBEdit.Create('view.itens_saida.form.edvalor_seguro');
  lbvalor_despesas_acessorias := TLabel.Create('view.itens_saida.form.lbvalor_despesas_acessorias');
  edvalor_despesas_acessorias := TDBEdit.Create('view.itens_saida.form.edvalor_despesas_acessorias');
  lbvalor_outras := TLabel.Create('view.itens_saida.form.lbvalor_outras');
  edvalor_outras := TDBEdit.Create('view.itens_saida.form.edvalor_outras');
  lbvalor_base_calculo_ipi := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_ipi');
  edvalor_base_calculo_ipi := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_ipi');
  lbvalor_base_calculo_pis := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_pis');
  edvalor_base_calculo_pis := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_pis');
  lbvalor_pis := TLabel.Create('view.itens_saida.form.lbvalor_pis');
  edvalor_pis := TDBEdit.Create('view.itens_saida.form.edvalor_pis');
  lbvalor_base_calculo_cofins := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_cofins');
  edvalor_base_calculo_cofins := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_cofins');
  lbvalor_cofins := TLabel.Create('view.itens_saida.form.lbvalor_cofins');
  edvalor_cofins := TDBEdit.Create('view.itens_saida.form.edvalor_cofins');
  lbquantidade_selo_ipi := TLabel.Create('view.itens_saida.form.lbquantidade_selo_ipi');
  edquantidade_selo_ipi := TDBEdit.Create('view.itens_saida.form.edquantidade_selo_ipi');
  lbcst_ipi_id := TLabel.Create('view.itens_saida.form.lbcst_ipi_id');
  edcst_ipi_id := TDBEdit.Create('view.itens_saida.form.edcst_ipi_id');
  lbcsosn_id := TLabel.Create('view.itens_saida.form.lbcsosn_id');
  edcsosn_id := TDBEdit.Create('view.itens_saida.form.edcsosn_id');
  lbvalor_ipi_unitario := TLabel.Create('view.itens_saida.form.lbvalor_ipi_unitario');
  edvalor_ipi_unitario := TDBEdit.Create('view.itens_saida.form.edvalor_ipi_unitario');
  lbaliquota_pis := TLabel.Create('view.itens_saida.form.lbaliquota_pis');
  edaliquota_pis := TDBEdit.Create('view.itens_saida.form.edaliquota_pis');
  lbaliquota_cofins := TLabel.Create('view.itens_saida.form.lbaliquota_cofins');
  edaliquota_cofins := TDBEdit.Create('view.itens_saida.form.edaliquota_cofins');
  lbcst_pis_id := TLabel.Create('view.itens_saida.form.lbcst_pis_id');
  edcst_pis_id := TDBEdit.Create('view.itens_saida.form.edcst_pis_id');
  lbcst_cofins_id := TLabel.Create('view.itens_saida.form.lbcst_cofins_id');
  edcst_cofins_id := TDBEdit.Create('view.itens_saida.form.edcst_cofins_id');
  lbvalor_base_calculo_st_retida := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_st_retida');
  edvalor_base_calculo_st_retida := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_st_retida');
  lbvalor_st_retida := TLabel.Create('view.itens_saida.form.lbvalor_st_retida');
  edvalor_st_retida := TDBEdit.Create('view.itens_saida.form.edvalor_st_retida');
  lbvalor_pis_retido := TLabel.Create('view.itens_saida.form.lbvalor_pis_retido');
  edvalor_pis_retido := TDBEdit.Create('view.itens_saida.form.edvalor_pis_retido');
  lbvalor_cofins_retido := TLabel.Create('view.itens_saida.form.lbvalor_cofins_retido');
  edvalor_cofins_retido := TDBEdit.Create('view.itens_saida.form.edvalor_cofins_retido');
  lbcodigo_natureza_pis_cofins_id := TLabel.Create('view.itens_saida.form.lbcodigo_natureza_pis_cofins_id');
  edcodigo_natureza_pis_cofins_id := TDBEdit.Create('view.itens_saida.form.edcodigo_natureza_pis_cofins_id');
  lbaliquota_id := TLabel.Create('view.itens_saida.form.lbaliquota_id');
  edaliquota_id := TDBEdit.Create('view.itens_saida.form.edaliquota_id');
  lbvalor_isentas := TLabel.Create('view.itens_saida.form.lbvalor_isentas');
  edvalor_isentas := TDBEdit.Create('view.itens_saida.form.edvalor_isentas');
  lbproduto_preco_custo := TLabel.Create('view.itens_saida.form.lbproduto_preco_custo');
  edproduto_preco_custo := TDBEdit.Create('view.itens_saida.form.edproduto_preco_custo');
  lbcodigo_produto_movimenta_estoque := TLabel.Create('view.itens_saida.form.lbcodigo_produto_movimenta_estoque');
  edcodigo_produto_movimenta_estoque := TDBEdit.Create('view.itens_saida.form.edcodigo_produto_movimenta_estoque');
  lbfuncionario_id := TLabel.Create('view.itens_saida.form.lbfuncionario_id');
  edfuncionario_id := TDBEdit.Create('view.itens_saida.form.edfuncionario_id');
  lbvalor_total_impostos := TLabel.Create('view.itens_saida.form.lbvalor_total_impostos');
  edvalor_total_impostos := TDBEdit.Create('view.itens_saida.form.edvalor_total_impostos');
  lbquantidade_embalagem := TLabel.Create('view.itens_saida.form.lbquantidade_embalagem');
  edquantidade_embalagem := TDBEdit.Create('view.itens_saida.form.edquantidade_embalagem');
  lbitem_movimenta_estoque := TLabel.Create('view.itens_saida.form.lbitem_movimenta_estoque');
  editem_movimenta_estoque := TDBEdit.Create('view.itens_saida.form.editem_movimenta_estoque');
  lbgrade_produto_id := TLabel.Create('view.itens_saida.form.lbgrade_produto_id');
  edgrade_produto_id := TDBEdit.Create('view.itens_saida.form.edgrade_produto_id');
  lbproduto_nome := TLabel.Create('view.itens_saida.form.lbproduto_nome');
  edproduto_nome := TDBEdit.Create('view.itens_saida.form.edproduto_nome');
  lbaliquota_interna := TLabel.Create('view.itens_saida.form.lbaliquota_interna');
  edaliquota_interna := TDBEdit.Create('view.itens_saida.form.edaliquota_interna');
  lbaliquota_interestadual := TLabel.Create('view.itens_saida.form.lbaliquota_interestadual');
  edaliquota_interestadual := TDBEdit.Create('view.itens_saida.form.edaliquota_interestadual');
  lbvalor_base_calculo_icms_interestadual := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_icms_interestadual');
  edvalor_base_calculo_icms_interestadual := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_icms_interestadual');
  lbaliquota_icms_interestadual_destino := TLabel.Create('view.itens_saida.form.lbaliquota_icms_interestadual_destino');
  edaliquota_icms_interestadual_destino := TDBEdit.Create('view.itens_saida.form.edaliquota_icms_interestadual_destino');
  lbvalor_icms_interestadual_destino := TLabel.Create('view.itens_saida.form.lbvalor_icms_interestadual_destino');
  edvalor_icms_interestadual_destino := TDBEdit.Create('view.itens_saida.form.edvalor_icms_interestadual_destino');
  lbvalor_icms_interestadual_remetente := TLabel.Create('view.itens_saida.form.lbvalor_icms_interestadual_remetente');
  edvalor_icms_interestadual_remetente := TDBEdit.Create('view.itens_saida.form.edvalor_icms_interestadual_remetente');
  lbaliquota_fcp := TLabel.Create('view.itens_saida.form.lbaliquota_fcp');
  edaliquota_fcp := TDBEdit.Create('view.itens_saida.form.edaliquota_fcp');
  lbvalor_fcp := TLabel.Create('view.itens_saida.form.lbvalor_fcp');
  edvalor_fcp := TDBEdit.Create('view.itens_saida.form.edvalor_fcp');
  lbnumero_pedido_compra := TLabel.Create('view.itens_saida.form.lbnumero_pedido_compra');
  ednumero_pedido_compra := TDBEdit.Create('view.itens_saida.form.ednumero_pedido_compra');
  lbitem_pedido_compra := TLabel.Create('view.itens_saida.form.lbitem_pedido_compra');
  editem_pedido_compra := TDBEdit.Create('view.itens_saida.form.editem_pedido_compra');
  lbitem_quantidade_movimenta_estoque := TLabel.Create('view.itens_saida.form.lbitem_quantidade_movimenta_estoque');
  editem_quantidade_movimenta_estoque := TDBEdit.Create('view.itens_saida.form.editem_quantidade_movimenta_estoque');
  lbicms_st_recuperado := TLabel.Create('view.itens_saida.form.lbicms_st_recuperado');
  edicms_st_recuperado := TDBEdit.Create('view.itens_saida.form.edicms_st_recuperado');
  lborigem_csosn_id := TLabel.Create('view.itens_saida.form.lborigem_csosn_id');
  edorigem_csosn_id := TDBEdit.Create('view.itens_saida.form.edorigem_csosn_id');
  lbpercentual_gnn := TLabel.Create('view.itens_saida.form.lbpercentual_gnn');
  edpercentual_gnn := TDBEdit.Create('view.itens_saida.form.edpercentual_gnn');
  lbpercentual_gni := TLabel.Create('view.itens_saida.form.lbpercentual_gni');
  edpercentual_gni := TDBEdit.Create('view.itens_saida.form.edpercentual_gni');
  lbpercentual_glp := TLabel.Create('view.itens_saida.form.lbpercentual_glp');
  edpercentual_glp := TDBEdit.Create('view.itens_saida.form.edpercentual_glp');
  lbvalor_partida := TLabel.Create('view.itens_saida.form.lbvalor_partida');
  edvalor_partida := TDBEdit.Create('view.itens_saida.form.edvalor_partida');
  lbaliquota_st := TLabel.Create('view.itens_saida.form.lbaliquota_st');
  edaliquota_st := TDBEdit.Create('view.itens_saida.form.edaliquota_st');
  lbvalor_icms_st_reducao := TLabel.Create('view.itens_saida.form.lbvalor_icms_st_reducao');
  edvalor_icms_st_reducao := TDBEdit.Create('view.itens_saida.form.edvalor_icms_st_reducao');
  lbaliquota_st_retida := TLabel.Create('view.itens_saida.form.lbaliquota_st_retida');
  edaliquota_st_retida := TDBEdit.Create('view.itens_saida.form.edaliquota_st_retida');
  lbvalor_icms_proprio := TLabel.Create('view.itens_saida.form.lbvalor_icms_proprio');
  edvalor_icms_proprio := TDBEdit.Create('view.itens_saida.form.edvalor_icms_proprio');
  lbaliquota_icms_simples_nacional := TLabel.Create('view.itens_saida.form.lbaliquota_icms_simples_nacional');
  edaliquota_icms_simples_nacional := TDBEdit.Create('view.itens_saida.form.edaliquota_icms_simples_nacional');
  lbvalor_icms_simples_nacional := TLabel.Create('view.itens_saida.form.lbvalor_icms_simples_nacional');
  edvalor_icms_simples_nacional := TDBEdit.Create('view.itens_saida.form.edvalor_icms_simples_nacional');
  lbvalor_icms_desonerado := TLabel.Create('view.itens_saida.form.lbvalor_icms_desonerado');
  edvalor_icms_desonerado := TDBEdit.Create('view.itens_saida.form.edvalor_icms_desonerado');
  lbdesoneracao_icms_id := TLabel.Create('view.itens_saida.form.lbdesoneracao_icms_id');
  eddesoneracao_icms_id := TDBEdit.Create('view.itens_saida.form.eddesoneracao_icms_id');
  lbaliquota_ipi_devolvido := TLabel.Create('view.itens_saida.form.lbaliquota_ipi_devolvido');
  edaliquota_ipi_devolvido := TDBEdit.Create('view.itens_saida.form.edaliquota_ipi_devolvido');
  lbvalor_ipi_devolvido := TLabel.Create('view.itens_saida.form.lbvalor_ipi_devolvido');
  edvalor_ipi_devolvido := TDBEdit.Create('view.itens_saida.form.edvalor_ipi_devolvido');
  lbmotivo_devolucao_ipi := TLabel.Create('view.itens_saida.form.lbmotivo_devolucao_ipi');
  edmotivo_devolucao_ipi := TDBEdit.Create('view.itens_saida.form.edmotivo_devolucao_ipi');
  lbdesoneracao_icms_st_id := TLabel.Create('view.itens_saida.form.lbdesoneracao_icms_st_id');
  eddesoneracao_icms_st_id := TDBEdit.Create('view.itens_saida.form.eddesoneracao_icms_st_id');
  lbvalor_icms_st_desonerado := TLabel.Create('view.itens_saida.form.lbvalor_icms_st_desonerado');
  edvalor_icms_st_desonerado := TDBEdit.Create('view.itens_saida.form.edvalor_icms_st_desonerado');
  lbobservacoes_contribuinte_identificacao := TLabel.Create('view.itens_saida.form.lbobservacoes_contribuinte_identificacao');
  edobservacoes_contribuinte_identificacao := TDBEdit.Create('view.itens_saida.form.edobservacoes_contribuinte_identificacao');
  lbobservacoes_contribuinte := TLabel.Create('view.itens_saida.form.lbobservacoes_contribuinte');
  edobservacoes_contribuinte := TDBEdit.Create('view.itens_saida.form.edobservacoes_contribuinte');
  lbobservacoes_fisco_identificacao := TLabel.Create('view.itens_saida.form.lbobservacoes_fisco_identificacao');
  edobservacoes_fisco_identificacao := TDBEdit.Create('view.itens_saida.form.edobservacoes_fisco_identificacao');
  lbobservacoes_fisco := TLabel.Create('view.itens_saida.form.lbobservacoes_fisco');
  edobservacoes_fisco := TDBEdit.Create('view.itens_saida.form.edobservacoes_fisco');
  lbcodigo_produto_anvisa := TLabel.Create('view.itens_saida.form.lbcodigo_produto_anvisa');
  edcodigo_produto_anvisa := TDBEdit.Create('view.itens_saida.form.edcodigo_produto_anvisa');
  lbmotivo_isencao_anvisa := TLabel.Create('view.itens_saida.form.lbmotivo_isencao_anvisa');
  edmotivo_isencao_anvisa := TDBEdit.Create('view.itens_saida.form.edmotivo_isencao_anvisa');
  lbpreco_maximo_consumidor := TLabel.Create('view.itens_saida.form.lbpreco_maximo_consumidor');
  edpreco_maximo_consumidor := TDBEdit.Create('view.itens_saida.form.edpreco_maximo_consumidor');
  lbrastreabilidade_numero_lote := TLabel.Create('view.itens_saida.form.lbrastreabilidade_numero_lote');
  edrastreabilidade_numero_lote := TDBEdit.Create('view.itens_saida.form.edrastreabilidade_numero_lote');
  lbrastreabilidade_data_fabricacao := TLabel.Create('view.itens_saida.form.lbrastreabilidade_data_fabricacao');
  edrastreabilidade_data_fabricacao := TDBEdit.Create('view.itens_saida.form.edrastreabilidade_data_fabricacao');
  lbrastreabilidade_data_validade := TLabel.Create('view.itens_saida.form.lbrastreabilidade_data_validade');
  edrastreabilidade_data_validade := TDBEdit.Create('view.itens_saida.form.edrastreabilidade_data_validade');
  lbrastreabilidade_codigo_agregacao := TLabel.Create('view.itens_saida.form.lbrastreabilidade_codigo_agregacao');
  edrastreabilidade_codigo_agregacao := TDBEdit.Create('view.itens_saida.form.edrastreabilidade_codigo_agregacao');
  lbvalor_base_calculo_fcp_icms := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_fcp_icms');
  edvalor_base_calculo_fcp_icms := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_fcp_icms');
  lbaliquota_fcp_icms := TLabel.Create('view.itens_saida.form.lbaliquota_fcp_icms');
  edaliquota_fcp_icms := TDBEdit.Create('view.itens_saida.form.edaliquota_fcp_icms');
  lbvalor_fcp_icms := TLabel.Create('view.itens_saida.form.lbvalor_fcp_icms');
  edvalor_fcp_icms := TDBEdit.Create('view.itens_saida.form.edvalor_fcp_icms');
  lbvalor_base_calculo_fcp_st := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_fcp_st');
  edvalor_base_calculo_fcp_st := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_fcp_st');
  lbaliquota_fcp_st := TLabel.Create('view.itens_saida.form.lbaliquota_fcp_st');
  edaliquota_fcp_st := TDBEdit.Create('view.itens_saida.form.edaliquota_fcp_st');
  lbvalor_fcp_st := TLabel.Create('view.itens_saida.form.lbvalor_fcp_st');
  edvalor_fcp_st := TDBEdit.Create('view.itens_saida.form.edvalor_fcp_st');
  lbvalor_base_calculo_fcp_retida := TLabel.Create('view.itens_saida.form.lbvalor_base_calculo_fcp_retida');
  edvalor_base_calculo_fcp_retida := TDBEdit.Create('view.itens_saida.form.edvalor_base_calculo_fcp_retida');
  lbaliquota_fcp_retida := TLabel.Create('view.itens_saida.form.lbaliquota_fcp_retida');
  edaliquota_fcp_retida := TDBEdit.Create('view.itens_saida.form.edaliquota_fcp_retida');
  lbvalor_fcp_retida := TLabel.Create('view.itens_saida.form.lbvalor_fcp_retida');
  edvalor_fcp_retida := TDBEdit.Create('view.itens_saida.form.edvalor_fcp_retida');
  lbinformacoes_adicionais := TLabel.Create('view.itens_saida.form.lbinformacoes_adicionais');
  edinformacoes_adicionais := TDBEdit.Create('view.itens_saida.form.edinformacoes_adicionais');
  lbquantidade_monofasica := TLabel.Create('view.itens_saida.form.lbquantidade_monofasica');
  edquantidade_monofasica := TDBEdit.Create('view.itens_saida.form.edquantidade_monofasica');
  lbaliquota_ad_rem := TLabel.Create('view.itens_saida.form.lbaliquota_ad_rem');
  edaliquota_ad_rem := TDBEdit.Create('view.itens_saida.form.edaliquota_ad_rem');
  lbvalor_icms_monofasico := TLabel.Create('view.itens_saida.form.lbvalor_icms_monofasico');
  edvalor_icms_monofasico := TDBEdit.Create('view.itens_saida.form.edvalor_icms_monofasico');
  lbquantidade_monofasica_retida := TLabel.Create('view.itens_saida.form.lbquantidade_monofasica_retida');
  edquantidade_monofasica_retida := TDBEdit.Create('view.itens_saida.form.edquantidade_monofasica_retida');
  lbaliquota_ad_rem_retida := TLabel.Create('view.itens_saida.form.lbaliquota_ad_rem_retida');
  edaliquota_ad_rem_retida := TDBEdit.Create('view.itens_saida.form.edaliquota_ad_rem_retida');
  lbvalor_icms_monofasico_retido := TLabel.Create('view.itens_saida.form.lbvalor_icms_monofasico_retido');
  edvalor_icms_monofasico_retido := TDBEdit.Create('view.itens_saida.form.edvalor_icms_monofasico_retido');
  lbcodigo_interno := TLabel.Create('view.itens_saida.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.itens_saida.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.itens_saida.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.itens_saida.form.edexcluido');
  lbinclusao := TLabel.Create('view.itens_saida.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.itens_saida.form.edinclusao');
  lbalteracao := TLabel.Create('view.itens_saida.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.itens_saida.form.edalteracao');
  lbexclusao := TLabel.Create('view.itens_saida.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.itens_saida.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Itens_SaidaDataset := TXDataWebDataSet.Create(Self);
  Itens_SaidaDatasetid := TIntegerField.Create(Self);
  Itens_SaidaDatasetaliado_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetdata_base_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvenda_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetproduto_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetunidade_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetitem := TIntegerField.Create(Self);
  Itens_SaidaDatasetcfop_cfop := TStringField.Create(Self);
  Itens_SaidaDatasetquantidade := TFloatField.Create(Self);
  Itens_SaidaDatasetproduto_preco := TFloatField.Create(Self);
  Itens_SaidaDatasetmargem_acrescimo := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_acrescimo := TFloatField.Create(Self);
  Itens_SaidaDatasetmargem_desconto := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_desconto := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_total := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_red := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_red := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_st := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_ipi := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_ipi := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_st := TFloatField.Create(Self);
  Itens_SaidaDatasetcst_id := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_frete := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_seguro := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_despesas_acessorias := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_outras := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_ipi := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_pis := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_pis := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_cofins := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_cofins := TFloatField.Create(Self);
  Itens_SaidaDatasetquantidade_selo_ipi := TIntegerField.Create(Self);
  Itens_SaidaDatasetcst_ipi_id := TStringField.Create(Self);
  Itens_SaidaDatasetcsosn_id := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_ipi_unitario := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_pis := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_cofins := TFloatField.Create(Self);
  Itens_SaidaDatasetcst_pis_id := TStringField.Create(Self);
  Itens_SaidaDatasetcst_cofins_id := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_st_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_st_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_pis_retido := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_cofins_retido := TFloatField.Create(Self);
  Itens_SaidaDatasetcodigo_natureza_pis_cofins_id := TStringField.Create(Self);
  Itens_SaidaDatasetaliquota_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvalor_isentas := TFloatField.Create(Self);
  Itens_SaidaDatasetproduto_preco_custo := TFloatField.Create(Self);
  Itens_SaidaDatasetcodigo_produto_movimenta_estoque := TIntegerField.Create(Self);
  Itens_SaidaDatasetfuncionario_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvalor_total_impostos := TFloatField.Create(Self);
  Itens_SaidaDatasetquantidade_embalagem := TIntegerField.Create(Self);
  Itens_SaidaDatasetitem_movimenta_estoque := TBooleanField.Create(Self);
  Itens_SaidaDatasetgrade_produto_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetproduto_nome := TStringField.Create(Self);
  Itens_SaidaDatasetaliquota_interna := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_interestadual := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_icms_interestadual := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_interestadual_destino := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_interestadual_destino := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_interestadual_remetente := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp := TFloatField.Create(Self);
  Itens_SaidaDatasetnumero_pedido_compra := TStringField.Create(Self);
  Itens_SaidaDatasetitem_pedido_compra := TIntegerField.Create(Self);
  Itens_SaidaDatasetitem_quantidade_movimenta_estoque := TFloatField.Create(Self);
  Itens_SaidaDataseticms_st_recuperado := TBooleanField.Create(Self);
  Itens_SaidaDatasetorigem_csosn_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetpercentual_gnn := TFloatField.Create(Self);
  Itens_SaidaDatasetpercentual_gni := TFloatField.Create(Self);
  Itens_SaidaDatasetpercentual_glp := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_partida := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_st_reducao := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_st_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_proprio := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_icms_simples_nacional := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_simples_nacional := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_desonerado := TFloatField.Create(Self);
  Itens_SaidaDatasetdesoneracao_icms_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetaliquota_ipi_devolvido := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_ipi_devolvido := TFloatField.Create(Self);
  Itens_SaidaDatasetmotivo_devolucao_ipi := TStringField.Create(Self);
  Itens_SaidaDatasetdesoneracao_icms_st_id := TIntegerField.Create(Self);
  Itens_SaidaDatasetvalor_icms_st_desonerado := TFloatField.Create(Self);
  Itens_SaidaDatasetobservacoes_contribuinte_identificacao := TStringField.Create(Self);
  Itens_SaidaDatasetobservacoes_contribuinte := TStringField.Create(Self);
  Itens_SaidaDatasetobservacoes_fisco_identificacao := TStringField.Create(Self);
  Itens_SaidaDatasetobservacoes_fisco := TStringField.Create(Self);
  Itens_SaidaDatasetcodigo_produto_anvisa := TStringField.Create(Self);
  Itens_SaidaDatasetmotivo_isencao_anvisa := TStringField.Create(Self);
  Itens_SaidaDatasetpreco_maximo_consumidor := TFloatField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_numero_lote := TStringField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_data_fabricacao := TDateTimeField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_data_validade := TDateTimeField.Create(Self);
  Itens_SaidaDatasetrastreabilidade_codigo_agregacao := TStringField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_fcp_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp_icms := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_fcp_st := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp_st := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_base_calculo_fcp_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_fcp_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_fcp_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetinformacoes_adicionais := TStringField.Create(Self);
  Itens_SaidaDatasetquantidade_monofasica := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_ad_rem := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_monofasico := TFloatField.Create(Self);
  Itens_SaidaDatasetquantidade_monofasica_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetaliquota_ad_rem_retida := TFloatField.Create(Self);
  Itens_SaidaDatasetvalor_icms_monofasico_retido := TFloatField.Create(Self);
  Itens_SaidaDatasetcodigo_interno := TIntegerField.Create(Self);
  Itens_SaidaDatasetexcluido := TBooleanField.Create(Self);
  Itens_SaidaDatasetinclusao := TDateTimeField.Create(Self);
  Itens_SaidaDatasetalteracao := TDateTimeField.Create(Self);
  Itens_SaidaDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientItens_SaidaGet := TXDataWebClient.Create(Self);
  XDataClientItens_SaidaDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbvenda_id.BeforeLoadDFMValues;
  edvenda_id.BeforeLoadDFMValues;
  lbproduto_id.BeforeLoadDFMValues;
  edproduto_id.BeforeLoadDFMValues;
  lbunidade_id.BeforeLoadDFMValues;
  edunidade_id.BeforeLoadDFMValues;
  lbitem.BeforeLoadDFMValues;
  editem.BeforeLoadDFMValues;
  lbcfop_cfop.BeforeLoadDFMValues;
  edcfop_cfop.BeforeLoadDFMValues;
  lbquantidade.BeforeLoadDFMValues;
  edquantidade.BeforeLoadDFMValues;
  lbproduto_preco.BeforeLoadDFMValues;
  edproduto_preco.BeforeLoadDFMValues;
  lbmargem_acrescimo.BeforeLoadDFMValues;
  edmargem_acrescimo.BeforeLoadDFMValues;
  lbvalor_acrescimo.BeforeLoadDFMValues;
  edvalor_acrescimo.BeforeLoadDFMValues;
  lbmargem_desconto.BeforeLoadDFMValues;
  edmargem_desconto.BeforeLoadDFMValues;
  lbvalor_desconto.BeforeLoadDFMValues;
  edvalor_desconto.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  lbaliquota_icms.BeforeLoadDFMValues;
  edaliquota_icms.BeforeLoadDFMValues;
  lbvalor_icms.BeforeLoadDFMValues;
  edvalor_icms.BeforeLoadDFMValues;
  lbaliquota_icms_red.BeforeLoadDFMValues;
  edaliquota_icms_red.BeforeLoadDFMValues;
  lbvalor_icms_red.BeforeLoadDFMValues;
  edvalor_icms_red.BeforeLoadDFMValues;
  lbaliquota_icms_st.BeforeLoadDFMValues;
  edaliquota_icms_st.BeforeLoadDFMValues;
  lbvalor_icms_st.BeforeLoadDFMValues;
  edvalor_icms_st.BeforeLoadDFMValues;
  lbaliquota_ipi.BeforeLoadDFMValues;
  edaliquota_ipi.BeforeLoadDFMValues;
  lbvalor_ipi.BeforeLoadDFMValues;
  edvalor_ipi.BeforeLoadDFMValues;
  lbvalor_base_calculo_icms.BeforeLoadDFMValues;
  edvalor_base_calculo_icms.BeforeLoadDFMValues;
  lbvalor_base_calculo_st.BeforeLoadDFMValues;
  edvalor_base_calculo_st.BeforeLoadDFMValues;
  lbcst_id.BeforeLoadDFMValues;
  edcst_id.BeforeLoadDFMValues;
  lbvalor_frete.BeforeLoadDFMValues;
  edvalor_frete.BeforeLoadDFMValues;
  lbvalor_seguro.BeforeLoadDFMValues;
  edvalor_seguro.BeforeLoadDFMValues;
  lbvalor_despesas_acessorias.BeforeLoadDFMValues;
  edvalor_despesas_acessorias.BeforeLoadDFMValues;
  lbvalor_outras.BeforeLoadDFMValues;
  edvalor_outras.BeforeLoadDFMValues;
  lbvalor_base_calculo_ipi.BeforeLoadDFMValues;
  edvalor_base_calculo_ipi.BeforeLoadDFMValues;
  lbvalor_base_calculo_pis.BeforeLoadDFMValues;
  edvalor_base_calculo_pis.BeforeLoadDFMValues;
  lbvalor_pis.BeforeLoadDFMValues;
  edvalor_pis.BeforeLoadDFMValues;
  lbvalor_base_calculo_cofins.BeforeLoadDFMValues;
  edvalor_base_calculo_cofins.BeforeLoadDFMValues;
  lbvalor_cofins.BeforeLoadDFMValues;
  edvalor_cofins.BeforeLoadDFMValues;
  lbquantidade_selo_ipi.BeforeLoadDFMValues;
  edquantidade_selo_ipi.BeforeLoadDFMValues;
  lbcst_ipi_id.BeforeLoadDFMValues;
  edcst_ipi_id.BeforeLoadDFMValues;
  lbcsosn_id.BeforeLoadDFMValues;
  edcsosn_id.BeforeLoadDFMValues;
  lbvalor_ipi_unitario.BeforeLoadDFMValues;
  edvalor_ipi_unitario.BeforeLoadDFMValues;
  lbaliquota_pis.BeforeLoadDFMValues;
  edaliquota_pis.BeforeLoadDFMValues;
  lbaliquota_cofins.BeforeLoadDFMValues;
  edaliquota_cofins.BeforeLoadDFMValues;
  lbcst_pis_id.BeforeLoadDFMValues;
  edcst_pis_id.BeforeLoadDFMValues;
  lbcst_cofins_id.BeforeLoadDFMValues;
  edcst_cofins_id.BeforeLoadDFMValues;
  lbvalor_base_calculo_st_retida.BeforeLoadDFMValues;
  edvalor_base_calculo_st_retida.BeforeLoadDFMValues;
  lbvalor_st_retida.BeforeLoadDFMValues;
  edvalor_st_retida.BeforeLoadDFMValues;
  lbvalor_pis_retido.BeforeLoadDFMValues;
  edvalor_pis_retido.BeforeLoadDFMValues;
  lbvalor_cofins_retido.BeforeLoadDFMValues;
  edvalor_cofins_retido.BeforeLoadDFMValues;
  lbcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  edcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  lbaliquota_id.BeforeLoadDFMValues;
  edaliquota_id.BeforeLoadDFMValues;
  lbvalor_isentas.BeforeLoadDFMValues;
  edvalor_isentas.BeforeLoadDFMValues;
  lbproduto_preco_custo.BeforeLoadDFMValues;
  edproduto_preco_custo.BeforeLoadDFMValues;
  lbcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  edcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  lbvalor_total_impostos.BeforeLoadDFMValues;
  edvalor_total_impostos.BeforeLoadDFMValues;
  lbquantidade_embalagem.BeforeLoadDFMValues;
  edquantidade_embalagem.BeforeLoadDFMValues;
  lbitem_movimenta_estoque.BeforeLoadDFMValues;
  editem_movimenta_estoque.BeforeLoadDFMValues;
  lbgrade_produto_id.BeforeLoadDFMValues;
  edgrade_produto_id.BeforeLoadDFMValues;
  lbproduto_nome.BeforeLoadDFMValues;
  edproduto_nome.BeforeLoadDFMValues;
  lbaliquota_interna.BeforeLoadDFMValues;
  edaliquota_interna.BeforeLoadDFMValues;
  lbaliquota_interestadual.BeforeLoadDFMValues;
  edaliquota_interestadual.BeforeLoadDFMValues;
  lbvalor_base_calculo_icms_interestadual.BeforeLoadDFMValues;
  edvalor_base_calculo_icms_interestadual.BeforeLoadDFMValues;
  lbaliquota_icms_interestadual_destino.BeforeLoadDFMValues;
  edaliquota_icms_interestadual_destino.BeforeLoadDFMValues;
  lbvalor_icms_interestadual_destino.BeforeLoadDFMValues;
  edvalor_icms_interestadual_destino.BeforeLoadDFMValues;
  lbvalor_icms_interestadual_remetente.BeforeLoadDFMValues;
  edvalor_icms_interestadual_remetente.BeforeLoadDFMValues;
  lbaliquota_fcp.BeforeLoadDFMValues;
  edaliquota_fcp.BeforeLoadDFMValues;
  lbvalor_fcp.BeforeLoadDFMValues;
  edvalor_fcp.BeforeLoadDFMValues;
  lbnumero_pedido_compra.BeforeLoadDFMValues;
  ednumero_pedido_compra.BeforeLoadDFMValues;
  lbitem_pedido_compra.BeforeLoadDFMValues;
  editem_pedido_compra.BeforeLoadDFMValues;
  lbitem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  editem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  lbicms_st_recuperado.BeforeLoadDFMValues;
  edicms_st_recuperado.BeforeLoadDFMValues;
  lborigem_csosn_id.BeforeLoadDFMValues;
  edorigem_csosn_id.BeforeLoadDFMValues;
  lbpercentual_gnn.BeforeLoadDFMValues;
  edpercentual_gnn.BeforeLoadDFMValues;
  lbpercentual_gni.BeforeLoadDFMValues;
  edpercentual_gni.BeforeLoadDFMValues;
  lbpercentual_glp.BeforeLoadDFMValues;
  edpercentual_glp.BeforeLoadDFMValues;
  lbvalor_partida.BeforeLoadDFMValues;
  edvalor_partida.BeforeLoadDFMValues;
  lbaliquota_st.BeforeLoadDFMValues;
  edaliquota_st.BeforeLoadDFMValues;
  lbvalor_icms_st_reducao.BeforeLoadDFMValues;
  edvalor_icms_st_reducao.BeforeLoadDFMValues;
  lbaliquota_st_retida.BeforeLoadDFMValues;
  edaliquota_st_retida.BeforeLoadDFMValues;
  lbvalor_icms_proprio.BeforeLoadDFMValues;
  edvalor_icms_proprio.BeforeLoadDFMValues;
  lbaliquota_icms_simples_nacional.BeforeLoadDFMValues;
  edaliquota_icms_simples_nacional.BeforeLoadDFMValues;
  lbvalor_icms_simples_nacional.BeforeLoadDFMValues;
  edvalor_icms_simples_nacional.BeforeLoadDFMValues;
  lbvalor_icms_desonerado.BeforeLoadDFMValues;
  edvalor_icms_desonerado.BeforeLoadDFMValues;
  lbdesoneracao_icms_id.BeforeLoadDFMValues;
  eddesoneracao_icms_id.BeforeLoadDFMValues;
  lbaliquota_ipi_devolvido.BeforeLoadDFMValues;
  edaliquota_ipi_devolvido.BeforeLoadDFMValues;
  lbvalor_ipi_devolvido.BeforeLoadDFMValues;
  edvalor_ipi_devolvido.BeforeLoadDFMValues;
  lbmotivo_devolucao_ipi.BeforeLoadDFMValues;
  edmotivo_devolucao_ipi.BeforeLoadDFMValues;
  lbdesoneracao_icms_st_id.BeforeLoadDFMValues;
  eddesoneracao_icms_st_id.BeforeLoadDFMValues;
  lbvalor_icms_st_desonerado.BeforeLoadDFMValues;
  edvalor_icms_st_desonerado.BeforeLoadDFMValues;
  lbobservacoes_contribuinte_identificacao.BeforeLoadDFMValues;
  edobservacoes_contribuinte_identificacao.BeforeLoadDFMValues;
  lbobservacoes_contribuinte.BeforeLoadDFMValues;
  edobservacoes_contribuinte.BeforeLoadDFMValues;
  lbobservacoes_fisco_identificacao.BeforeLoadDFMValues;
  edobservacoes_fisco_identificacao.BeforeLoadDFMValues;
  lbobservacoes_fisco.BeforeLoadDFMValues;
  edobservacoes_fisco.BeforeLoadDFMValues;
  lbcodigo_produto_anvisa.BeforeLoadDFMValues;
  edcodigo_produto_anvisa.BeforeLoadDFMValues;
  lbmotivo_isencao_anvisa.BeforeLoadDFMValues;
  edmotivo_isencao_anvisa.BeforeLoadDFMValues;
  lbpreco_maximo_consumidor.BeforeLoadDFMValues;
  edpreco_maximo_consumidor.BeforeLoadDFMValues;
  lbrastreabilidade_numero_lote.BeforeLoadDFMValues;
  edrastreabilidade_numero_lote.BeforeLoadDFMValues;
  lbrastreabilidade_data_fabricacao.BeforeLoadDFMValues;
  edrastreabilidade_data_fabricacao.BeforeLoadDFMValues;
  lbrastreabilidade_data_validade.BeforeLoadDFMValues;
  edrastreabilidade_data_validade.BeforeLoadDFMValues;
  lbrastreabilidade_codigo_agregacao.BeforeLoadDFMValues;
  edrastreabilidade_codigo_agregacao.BeforeLoadDFMValues;
  lbvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  edvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  lbaliquota_fcp_icms.BeforeLoadDFMValues;
  edaliquota_fcp_icms.BeforeLoadDFMValues;
  lbvalor_fcp_icms.BeforeLoadDFMValues;
  edvalor_fcp_icms.BeforeLoadDFMValues;
  lbvalor_base_calculo_fcp_st.BeforeLoadDFMValues;
  edvalor_base_calculo_fcp_st.BeforeLoadDFMValues;
  lbaliquota_fcp_st.BeforeLoadDFMValues;
  edaliquota_fcp_st.BeforeLoadDFMValues;
  lbvalor_fcp_st.BeforeLoadDFMValues;
  edvalor_fcp_st.BeforeLoadDFMValues;
  lbvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  edvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  lbaliquota_fcp_retida.BeforeLoadDFMValues;
  edaliquota_fcp_retida.BeforeLoadDFMValues;
  lbvalor_fcp_retida.BeforeLoadDFMValues;
  edvalor_fcp_retida.BeforeLoadDFMValues;
  lbinformacoes_adicionais.BeforeLoadDFMValues;
  edinformacoes_adicionais.BeforeLoadDFMValues;
  lbquantidade_monofasica.BeforeLoadDFMValues;
  edquantidade_monofasica.BeforeLoadDFMValues;
  lbaliquota_ad_rem.BeforeLoadDFMValues;
  edaliquota_ad_rem.BeforeLoadDFMValues;
  lbvalor_icms_monofasico.BeforeLoadDFMValues;
  edvalor_icms_monofasico.BeforeLoadDFMValues;
  lbquantidade_monofasica_retida.BeforeLoadDFMValues;
  edquantidade_monofasica_retida.BeforeLoadDFMValues;
  lbaliquota_ad_rem_retida.BeforeLoadDFMValues;
  edaliquota_ad_rem_retida.BeforeLoadDFMValues;
  lbvalor_icms_monofasico_retido.BeforeLoadDFMValues;
  edvalor_icms_monofasico_retido.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Itens_SaidaDataset.BeforeLoadDFMValues;
  Itens_SaidaDatasetid.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliado_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetdata_base_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvenda_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetunidade_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem.BeforeLoadDFMValues;
  Itens_SaidaDatasetcfop_cfop.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_preco.BeforeLoadDFMValues;
  Itens_SaidaDatasetmargem_acrescimo.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_acrescimo.BeforeLoadDFMValues;
  Itens_SaidaDatasetmargem_desconto.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_desconto.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_total.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_red.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_red.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_frete.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_seguro.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_despesas_acessorias.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_outras.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_pis.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_pis.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_cofins.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_cofins.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_selo_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_ipi_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetcsosn_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_ipi_unitario.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_pis.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_cofins.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_pis_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetcst_cofins_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_st_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_st_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_pis_retido.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_cofins_retido.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_isentas.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_preco_custo.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  Itens_SaidaDatasetfuncionario_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_total_impostos.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_embalagem.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem_movimenta_estoque.BeforeLoadDFMValues;
  Itens_SaidaDatasetgrade_produto_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetproduto_nome.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_interna.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_interestadual.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_interestadual_destino.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_interestadual_destino.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_interestadual_remetente.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp.BeforeLoadDFMValues;
  Itens_SaidaDatasetnumero_pedido_compra.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem_pedido_compra.BeforeLoadDFMValues;
  Itens_SaidaDatasetitem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  Itens_SaidaDataseticms_st_recuperado.BeforeLoadDFMValues;
  Itens_SaidaDatasetorigem_csosn_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetpercentual_gnn.BeforeLoadDFMValues;
  Itens_SaidaDatasetpercentual_gni.BeforeLoadDFMValues;
  Itens_SaidaDatasetpercentual_glp.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_partida.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_st_reducao.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_st_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_proprio.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_icms_simples_nacional.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_simples_nacional.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_desonerado.BeforeLoadDFMValues;
  Itens_SaidaDatasetdesoneracao_icms_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ipi_devolvido.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_ipi_devolvido.BeforeLoadDFMValues;
  Itens_SaidaDatasetmotivo_devolucao_ipi.BeforeLoadDFMValues;
  Itens_SaidaDatasetdesoneracao_icms_st_id.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_st_desonerado.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_contribuinte_identificacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_contribuinte.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_fisco_identificacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetobservacoes_fisco.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_produto_anvisa.BeforeLoadDFMValues;
  Itens_SaidaDatasetmotivo_isencao_anvisa.BeforeLoadDFMValues;
  Itens_SaidaDatasetpreco_maximo_consumidor.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_numero_lote.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_data_fabricacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_data_validade.BeforeLoadDFMValues;
  Itens_SaidaDatasetrastreabilidade_codigo_agregacao.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp_icms.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_fcp_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp_st.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_fcp_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_fcp_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetinformacoes_adicionais.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_monofasica.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ad_rem.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_monofasico.BeforeLoadDFMValues;
  Itens_SaidaDatasetquantidade_monofasica_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetaliquota_ad_rem_retida.BeforeLoadDFMValues;
  Itens_SaidaDatasetvalor_icms_monofasico_retido.BeforeLoadDFMValues;
  Itens_SaidaDatasetcodigo_interno.BeforeLoadDFMValues;
  Itens_SaidaDatasetexcluido.BeforeLoadDFMValues;
  Itens_SaidaDatasetinclusao.BeforeLoadDFMValues;
  Itens_SaidaDatasetalteracao.BeforeLoadDFMValues;
  Itens_SaidaDatasetexclusao.BeforeLoadDFMValues;
  XDataClientItens_SaidaGet.BeforeLoadDFMValues;
  XDataClientItens_SaidaDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewItens_SaidaEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 3505;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 3445;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 3445;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 3445;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbvenda_id.SetParentComponent(Self);
    lbvenda_id.Name := 'lbvenda_id';
    lbvenda_id.Left := 24;
    lbvenda_id.Top := 273;
    lbvenda_id.Width := 14;
    lbvenda_id.Height := 13;
    lbvenda_id.Caption := 'venda_id:';
    lbvenda_id.Transparent := True;
    edvenda_id.SetParentComponent(Self);
    edvenda_id.Name := 'edvenda_id';
    edvenda_id.Left := 221;
    edvenda_id.Top := 270;
    edvenda_id.Width := 200;
    edvenda_id.Height := 21;
    edvenda_id.Enabled := True;
    edvenda_id.TabOrder := 9;
    edvenda_id.Text := 'edvenda_id';
    edvenda_id.DataField := 'venda_id';
    edvenda_id.DataSource := DataSource;
    lbproduto_id.SetParentComponent(Self);
    lbproduto_id.Name := 'lbproduto_id';
    lbproduto_id.Left := 24;
    lbproduto_id.Top := 300;
    lbproduto_id.Width := 14;
    lbproduto_id.Height := 13;
    lbproduto_id.Caption := 'produto_id:';
    lbproduto_id.Transparent := True;
    edproduto_id.SetParentComponent(Self);
    edproduto_id.Name := 'edproduto_id';
    edproduto_id.Left := 221;
    edproduto_id.Top := 297;
    edproduto_id.Width := 200;
    edproduto_id.Height := 21;
    edproduto_id.Enabled := True;
    edproduto_id.TabOrder := 10;
    edproduto_id.Text := 'edproduto_id';
    edproduto_id.DataField := 'produto_id';
    edproduto_id.DataSource := DataSource;
    lbunidade_id.SetParentComponent(Self);
    lbunidade_id.Name := 'lbunidade_id';
    lbunidade_id.Left := 24;
    lbunidade_id.Top := 327;
    lbunidade_id.Width := 14;
    lbunidade_id.Height := 13;
    lbunidade_id.Caption := 'unidade_id:';
    lbunidade_id.Transparent := True;
    edunidade_id.SetParentComponent(Self);
    edunidade_id.Name := 'edunidade_id';
    edunidade_id.Left := 221;
    edunidade_id.Top := 324;
    edunidade_id.Width := 200;
    edunidade_id.Height := 21;
    edunidade_id.Enabled := True;
    edunidade_id.TabOrder := 11;
    edunidade_id.Text := 'edunidade_id';
    edunidade_id.DataField := 'unidade_id';
    edunidade_id.DataSource := DataSource;
    lbitem.SetParentComponent(Self);
    lbitem.Name := 'lbitem';
    lbitem.Left := 24;
    lbitem.Top := 354;
    lbitem.Width := 14;
    lbitem.Height := 13;
    lbitem.Caption := 'item:';
    lbitem.Transparent := True;
    editem.SetParentComponent(Self);
    editem.Name := 'editem';
    editem.Left := 221;
    editem.Top := 351;
    editem.Width := 200;
    editem.Height := 21;
    editem.Enabled := True;
    editem.TabOrder := 12;
    editem.Text := 'editem';
    editem.DataField := 'item';
    editem.DataSource := DataSource;
    lbcfop_cfop.SetParentComponent(Self);
    lbcfop_cfop.Name := 'lbcfop_cfop';
    lbcfop_cfop.Left := 24;
    lbcfop_cfop.Top := 381;
    lbcfop_cfop.Width := 14;
    lbcfop_cfop.Height := 13;
    lbcfop_cfop.Caption := 'cfop_cfop:';
    lbcfop_cfop.Transparent := True;
    edcfop_cfop.SetParentComponent(Self);
    edcfop_cfop.Name := 'edcfop_cfop';
    edcfop_cfop.Left := 221;
    edcfop_cfop.Top := 378;
    edcfop_cfop.Width := 200;
    edcfop_cfop.Height := 21;
    edcfop_cfop.Enabled := True;
    edcfop_cfop.TabOrder := 13;
    edcfop_cfop.Text := 'edcfop_cfop';
    edcfop_cfop.DataField := 'cfop_cfop';
    edcfop_cfop.DataSource := DataSource;
    lbquantidade.SetParentComponent(Self);
    lbquantidade.Name := 'lbquantidade';
    lbquantidade.Left := 24;
    lbquantidade.Top := 408;
    lbquantidade.Width := 14;
    lbquantidade.Height := 13;
    lbquantidade.Caption := 'quantidade:';
    lbquantidade.Transparent := True;
    edquantidade.SetParentComponent(Self);
    edquantidade.Name := 'edquantidade';
    edquantidade.Left := 221;
    edquantidade.Top := 405;
    edquantidade.Width := 200;
    edquantidade.Height := 21;
    edquantidade.Enabled := True;
    edquantidade.TabOrder := 14;
    edquantidade.Text := 'edquantidade';
    edquantidade.DataField := 'quantidade';
    edquantidade.DataSource := DataSource;
    lbproduto_preco.SetParentComponent(Self);
    lbproduto_preco.Name := 'lbproduto_preco';
    lbproduto_preco.Left := 24;
    lbproduto_preco.Top := 435;
    lbproduto_preco.Width := 14;
    lbproduto_preco.Height := 13;
    lbproduto_preco.Caption := 'produto_preco:';
    lbproduto_preco.Transparent := True;
    edproduto_preco.SetParentComponent(Self);
    edproduto_preco.Name := 'edproduto_preco';
    edproduto_preco.Left := 221;
    edproduto_preco.Top := 432;
    edproduto_preco.Width := 200;
    edproduto_preco.Height := 21;
    edproduto_preco.Enabled := True;
    edproduto_preco.TabOrder := 15;
    edproduto_preco.Text := 'edproduto_preco';
    edproduto_preco.DataField := 'produto_preco';
    edproduto_preco.DataSource := DataSource;
    lbmargem_acrescimo.SetParentComponent(Self);
    lbmargem_acrescimo.Name := 'lbmargem_acrescimo';
    lbmargem_acrescimo.Left := 24;
    lbmargem_acrescimo.Top := 462;
    lbmargem_acrescimo.Width := 14;
    lbmargem_acrescimo.Height := 13;
    lbmargem_acrescimo.Caption := 'margem_acrescimo:';
    lbmargem_acrescimo.Transparent := True;
    edmargem_acrescimo.SetParentComponent(Self);
    edmargem_acrescimo.Name := 'edmargem_acrescimo';
    edmargem_acrescimo.Left := 221;
    edmargem_acrescimo.Top := 459;
    edmargem_acrescimo.Width := 200;
    edmargem_acrescimo.Height := 21;
    edmargem_acrescimo.Enabled := True;
    edmargem_acrescimo.TabOrder := 16;
    edmargem_acrescimo.Text := 'edmargem_acrescimo';
    edmargem_acrescimo.DataField := 'margem_acrescimo';
    edmargem_acrescimo.DataSource := DataSource;
    lbvalor_acrescimo.SetParentComponent(Self);
    lbvalor_acrescimo.Name := 'lbvalor_acrescimo';
    lbvalor_acrescimo.Left := 24;
    lbvalor_acrescimo.Top := 489;
    lbvalor_acrescimo.Width := 14;
    lbvalor_acrescimo.Height := 13;
    lbvalor_acrescimo.Caption := 'valor_acrescimo:';
    lbvalor_acrescimo.Transparent := True;
    edvalor_acrescimo.SetParentComponent(Self);
    edvalor_acrescimo.Name := 'edvalor_acrescimo';
    edvalor_acrescimo.Left := 221;
    edvalor_acrescimo.Top := 486;
    edvalor_acrescimo.Width := 200;
    edvalor_acrescimo.Height := 21;
    edvalor_acrescimo.Enabled := True;
    edvalor_acrescimo.TabOrder := 17;
    edvalor_acrescimo.Text := 'edvalor_acrescimo';
    edvalor_acrescimo.DataField := 'valor_acrescimo';
    edvalor_acrescimo.DataSource := DataSource;
    lbmargem_desconto.SetParentComponent(Self);
    lbmargem_desconto.Name := 'lbmargem_desconto';
    lbmargem_desconto.Left := 24;
    lbmargem_desconto.Top := 516;
    lbmargem_desconto.Width := 14;
    lbmargem_desconto.Height := 13;
    lbmargem_desconto.Caption := 'margem_desconto:';
    lbmargem_desconto.Transparent := True;
    edmargem_desconto.SetParentComponent(Self);
    edmargem_desconto.Name := 'edmargem_desconto';
    edmargem_desconto.Left := 221;
    edmargem_desconto.Top := 513;
    edmargem_desconto.Width := 200;
    edmargem_desconto.Height := 21;
    edmargem_desconto.Enabled := True;
    edmargem_desconto.TabOrder := 18;
    edmargem_desconto.Text := 'edmargem_desconto';
    edmargem_desconto.DataField := 'margem_desconto';
    edmargem_desconto.DataSource := DataSource;
    lbvalor_desconto.SetParentComponent(Self);
    lbvalor_desconto.Name := 'lbvalor_desconto';
    lbvalor_desconto.Left := 24;
    lbvalor_desconto.Top := 543;
    lbvalor_desconto.Width := 14;
    lbvalor_desconto.Height := 13;
    lbvalor_desconto.Caption := 'valor_desconto:';
    lbvalor_desconto.Transparent := True;
    edvalor_desconto.SetParentComponent(Self);
    edvalor_desconto.Name := 'edvalor_desconto';
    edvalor_desconto.Left := 221;
    edvalor_desconto.Top := 540;
    edvalor_desconto.Width := 200;
    edvalor_desconto.Height := 21;
    edvalor_desconto.Enabled := True;
    edvalor_desconto.TabOrder := 19;
    edvalor_desconto.Text := 'edvalor_desconto';
    edvalor_desconto.DataField := 'valor_desconto';
    edvalor_desconto.DataSource := DataSource;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 24;
    lbvalor_total.Top := 570;
    lbvalor_total.Width := 14;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'valor_total:';
    lbvalor_total.Transparent := True;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 221;
    edvalor_total.Top := 567;
    edvalor_total.Width := 200;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := True;
    edvalor_total.TabOrder := 20;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    lbaliquota_icms.SetParentComponent(Self);
    lbaliquota_icms.Name := 'lbaliquota_icms';
    lbaliquota_icms.Left := 24;
    lbaliquota_icms.Top := 597;
    lbaliquota_icms.Width := 14;
    lbaliquota_icms.Height := 13;
    lbaliquota_icms.Caption := 'aliquota_icms:';
    lbaliquota_icms.Transparent := True;
    edaliquota_icms.SetParentComponent(Self);
    edaliquota_icms.Name := 'edaliquota_icms';
    edaliquota_icms.Left := 221;
    edaliquota_icms.Top := 594;
    edaliquota_icms.Width := 200;
    edaliquota_icms.Height := 21;
    edaliquota_icms.Enabled := True;
    edaliquota_icms.TabOrder := 21;
    edaliquota_icms.Text := 'edaliquota_icms';
    edaliquota_icms.DataField := 'aliquota_icms';
    edaliquota_icms.DataSource := DataSource;
    lbvalor_icms.SetParentComponent(Self);
    lbvalor_icms.Name := 'lbvalor_icms';
    lbvalor_icms.Left := 24;
    lbvalor_icms.Top := 624;
    lbvalor_icms.Width := 14;
    lbvalor_icms.Height := 13;
    lbvalor_icms.Caption := 'valor_icms:';
    lbvalor_icms.Transparent := True;
    edvalor_icms.SetParentComponent(Self);
    edvalor_icms.Name := 'edvalor_icms';
    edvalor_icms.Left := 221;
    edvalor_icms.Top := 621;
    edvalor_icms.Width := 200;
    edvalor_icms.Height := 21;
    edvalor_icms.Enabled := True;
    edvalor_icms.TabOrder := 22;
    edvalor_icms.Text := 'edvalor_icms';
    edvalor_icms.DataField := 'valor_icms';
    edvalor_icms.DataSource := DataSource;
    lbaliquota_icms_red.SetParentComponent(Self);
    lbaliquota_icms_red.Name := 'lbaliquota_icms_red';
    lbaliquota_icms_red.Left := 24;
    lbaliquota_icms_red.Top := 651;
    lbaliquota_icms_red.Width := 14;
    lbaliquota_icms_red.Height := 13;
    lbaliquota_icms_red.Caption := 'aliquota_icms_red:';
    lbaliquota_icms_red.Transparent := True;
    edaliquota_icms_red.SetParentComponent(Self);
    edaliquota_icms_red.Name := 'edaliquota_icms_red';
    edaliquota_icms_red.Left := 221;
    edaliquota_icms_red.Top := 648;
    edaliquota_icms_red.Width := 200;
    edaliquota_icms_red.Height := 21;
    edaliquota_icms_red.Enabled := True;
    edaliquota_icms_red.TabOrder := 23;
    edaliquota_icms_red.Text := 'edaliquota_icms_red';
    edaliquota_icms_red.DataField := 'aliquota_icms_red';
    edaliquota_icms_red.DataSource := DataSource;
    lbvalor_icms_red.SetParentComponent(Self);
    lbvalor_icms_red.Name := 'lbvalor_icms_red';
    lbvalor_icms_red.Left := 24;
    lbvalor_icms_red.Top := 678;
    lbvalor_icms_red.Width := 14;
    lbvalor_icms_red.Height := 13;
    lbvalor_icms_red.Caption := 'valor_icms_red:';
    lbvalor_icms_red.Transparent := True;
    edvalor_icms_red.SetParentComponent(Self);
    edvalor_icms_red.Name := 'edvalor_icms_red';
    edvalor_icms_red.Left := 221;
    edvalor_icms_red.Top := 675;
    edvalor_icms_red.Width := 200;
    edvalor_icms_red.Height := 21;
    edvalor_icms_red.Enabled := True;
    edvalor_icms_red.TabOrder := 24;
    edvalor_icms_red.Text := 'edvalor_icms_red';
    edvalor_icms_red.DataField := 'valor_icms_red';
    edvalor_icms_red.DataSource := DataSource;
    lbaliquota_icms_st.SetParentComponent(Self);
    lbaliquota_icms_st.Name := 'lbaliquota_icms_st';
    lbaliquota_icms_st.Left := 24;
    lbaliquota_icms_st.Top := 705;
    lbaliquota_icms_st.Width := 14;
    lbaliquota_icms_st.Height := 13;
    lbaliquota_icms_st.Caption := 'aliquota_icms_st:';
    lbaliquota_icms_st.Transparent := True;
    edaliquota_icms_st.SetParentComponent(Self);
    edaliquota_icms_st.Name := 'edaliquota_icms_st';
    edaliquota_icms_st.Left := 221;
    edaliquota_icms_st.Top := 702;
    edaliquota_icms_st.Width := 200;
    edaliquota_icms_st.Height := 21;
    edaliquota_icms_st.Enabled := True;
    edaliquota_icms_st.TabOrder := 25;
    edaliquota_icms_st.Text := 'edaliquota_icms_st';
    edaliquota_icms_st.DataField := 'aliquota_icms_st';
    edaliquota_icms_st.DataSource := DataSource;
    lbvalor_icms_st.SetParentComponent(Self);
    lbvalor_icms_st.Name := 'lbvalor_icms_st';
    lbvalor_icms_st.Left := 24;
    lbvalor_icms_st.Top := 732;
    lbvalor_icms_st.Width := 14;
    lbvalor_icms_st.Height := 13;
    lbvalor_icms_st.Caption := 'valor_icms_st:';
    lbvalor_icms_st.Transparent := True;
    edvalor_icms_st.SetParentComponent(Self);
    edvalor_icms_st.Name := 'edvalor_icms_st';
    edvalor_icms_st.Left := 221;
    edvalor_icms_st.Top := 729;
    edvalor_icms_st.Width := 200;
    edvalor_icms_st.Height := 21;
    edvalor_icms_st.Enabled := True;
    edvalor_icms_st.TabOrder := 26;
    edvalor_icms_st.Text := 'edvalor_icms_st';
    edvalor_icms_st.DataField := 'valor_icms_st';
    edvalor_icms_st.DataSource := DataSource;
    lbaliquota_ipi.SetParentComponent(Self);
    lbaliquota_ipi.Name := 'lbaliquota_ipi';
    lbaliquota_ipi.Left := 24;
    lbaliquota_ipi.Top := 759;
    lbaliquota_ipi.Width := 14;
    lbaliquota_ipi.Height := 13;
    lbaliquota_ipi.Caption := 'aliquota_ipi:';
    lbaliquota_ipi.Transparent := True;
    edaliquota_ipi.SetParentComponent(Self);
    edaliquota_ipi.Name := 'edaliquota_ipi';
    edaliquota_ipi.Left := 221;
    edaliquota_ipi.Top := 756;
    edaliquota_ipi.Width := 200;
    edaliquota_ipi.Height := 21;
    edaliquota_ipi.Enabled := True;
    edaliquota_ipi.TabOrder := 27;
    edaliquota_ipi.Text := 'edaliquota_ipi';
    edaliquota_ipi.DataField := 'aliquota_ipi';
    edaliquota_ipi.DataSource := DataSource;
    lbvalor_ipi.SetParentComponent(Self);
    lbvalor_ipi.Name := 'lbvalor_ipi';
    lbvalor_ipi.Left := 24;
    lbvalor_ipi.Top := 786;
    lbvalor_ipi.Width := 14;
    lbvalor_ipi.Height := 13;
    lbvalor_ipi.Caption := 'valor_ipi:';
    lbvalor_ipi.Transparent := True;
    edvalor_ipi.SetParentComponent(Self);
    edvalor_ipi.Name := 'edvalor_ipi';
    edvalor_ipi.Left := 221;
    edvalor_ipi.Top := 783;
    edvalor_ipi.Width := 200;
    edvalor_ipi.Height := 21;
    edvalor_ipi.Enabled := True;
    edvalor_ipi.TabOrder := 28;
    edvalor_ipi.Text := 'edvalor_ipi';
    edvalor_ipi.DataField := 'valor_ipi';
    edvalor_ipi.DataSource := DataSource;
    lbvalor_base_calculo_icms.SetParentComponent(Self);
    lbvalor_base_calculo_icms.Name := 'lbvalor_base_calculo_icms';
    lbvalor_base_calculo_icms.Left := 24;
    lbvalor_base_calculo_icms.Top := 813;
    lbvalor_base_calculo_icms.Width := 14;
    lbvalor_base_calculo_icms.Height := 13;
    lbvalor_base_calculo_icms.Caption := 'valor_base_calculo_icms:';
    lbvalor_base_calculo_icms.Transparent := True;
    edvalor_base_calculo_icms.SetParentComponent(Self);
    edvalor_base_calculo_icms.Name := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.Left := 221;
    edvalor_base_calculo_icms.Top := 810;
    edvalor_base_calculo_icms.Width := 200;
    edvalor_base_calculo_icms.Height := 21;
    edvalor_base_calculo_icms.Enabled := True;
    edvalor_base_calculo_icms.TabOrder := 29;
    edvalor_base_calculo_icms.Text := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.DataField := 'valor_base_calculo_icms';
    edvalor_base_calculo_icms.DataSource := DataSource;
    lbvalor_base_calculo_st.SetParentComponent(Self);
    lbvalor_base_calculo_st.Name := 'lbvalor_base_calculo_st';
    lbvalor_base_calculo_st.Left := 24;
    lbvalor_base_calculo_st.Top := 840;
    lbvalor_base_calculo_st.Width := 14;
    lbvalor_base_calculo_st.Height := 13;
    lbvalor_base_calculo_st.Caption := 'valor_base_calculo_st:';
    lbvalor_base_calculo_st.Transparent := True;
    edvalor_base_calculo_st.SetParentComponent(Self);
    edvalor_base_calculo_st.Name := 'edvalor_base_calculo_st';
    edvalor_base_calculo_st.Left := 221;
    edvalor_base_calculo_st.Top := 837;
    edvalor_base_calculo_st.Width := 200;
    edvalor_base_calculo_st.Height := 21;
    edvalor_base_calculo_st.Enabled := True;
    edvalor_base_calculo_st.TabOrder := 30;
    edvalor_base_calculo_st.Text := 'edvalor_base_calculo_st';
    edvalor_base_calculo_st.DataField := 'valor_base_calculo_st';
    edvalor_base_calculo_st.DataSource := DataSource;
    lbcst_id.SetParentComponent(Self);
    lbcst_id.Name := 'lbcst_id';
    lbcst_id.Left := 24;
    lbcst_id.Top := 867;
    lbcst_id.Width := 14;
    lbcst_id.Height := 13;
    lbcst_id.Caption := 'cst_id:';
    lbcst_id.Transparent := True;
    edcst_id.SetParentComponent(Self);
    edcst_id.Name := 'edcst_id';
    edcst_id.Left := 221;
    edcst_id.Top := 864;
    edcst_id.Width := 200;
    edcst_id.Height := 21;
    edcst_id.Enabled := True;
    edcst_id.TabOrder := 31;
    edcst_id.Text := 'edcst_id';
    edcst_id.DataField := 'cst_id';
    edcst_id.DataSource := DataSource;
    lbvalor_frete.SetParentComponent(Self);
    lbvalor_frete.Name := 'lbvalor_frete';
    lbvalor_frete.Left := 24;
    lbvalor_frete.Top := 894;
    lbvalor_frete.Width := 14;
    lbvalor_frete.Height := 13;
    lbvalor_frete.Caption := 'valor_frete:';
    lbvalor_frete.Transparent := True;
    edvalor_frete.SetParentComponent(Self);
    edvalor_frete.Name := 'edvalor_frete';
    edvalor_frete.Left := 221;
    edvalor_frete.Top := 891;
    edvalor_frete.Width := 200;
    edvalor_frete.Height := 21;
    edvalor_frete.Enabled := True;
    edvalor_frete.TabOrder := 32;
    edvalor_frete.Text := 'edvalor_frete';
    edvalor_frete.DataField := 'valor_frete';
    edvalor_frete.DataSource := DataSource;
    lbvalor_seguro.SetParentComponent(Self);
    lbvalor_seguro.Name := 'lbvalor_seguro';
    lbvalor_seguro.Left := 24;
    lbvalor_seguro.Top := 921;
    lbvalor_seguro.Width := 14;
    lbvalor_seguro.Height := 13;
    lbvalor_seguro.Caption := 'valor_seguro:';
    lbvalor_seguro.Transparent := True;
    edvalor_seguro.SetParentComponent(Self);
    edvalor_seguro.Name := 'edvalor_seguro';
    edvalor_seguro.Left := 221;
    edvalor_seguro.Top := 918;
    edvalor_seguro.Width := 200;
    edvalor_seguro.Height := 21;
    edvalor_seguro.Enabled := True;
    edvalor_seguro.TabOrder := 33;
    edvalor_seguro.Text := 'edvalor_seguro';
    edvalor_seguro.DataField := 'valor_seguro';
    edvalor_seguro.DataSource := DataSource;
    lbvalor_despesas_acessorias.SetParentComponent(Self);
    lbvalor_despesas_acessorias.Name := 'lbvalor_despesas_acessorias';
    lbvalor_despesas_acessorias.Left := 24;
    lbvalor_despesas_acessorias.Top := 948;
    lbvalor_despesas_acessorias.Width := 14;
    lbvalor_despesas_acessorias.Height := 13;
    lbvalor_despesas_acessorias.Caption := 'valor_despesas_acessorias:';
    lbvalor_despesas_acessorias.Transparent := True;
    edvalor_despesas_acessorias.SetParentComponent(Self);
    edvalor_despesas_acessorias.Name := 'edvalor_despesas_acessorias';
    edvalor_despesas_acessorias.Left := 221;
    edvalor_despesas_acessorias.Top := 945;
    edvalor_despesas_acessorias.Width := 200;
    edvalor_despesas_acessorias.Height := 21;
    edvalor_despesas_acessorias.Enabled := True;
    edvalor_despesas_acessorias.TabOrder := 34;
    edvalor_despesas_acessorias.Text := 'edvalor_despesas_acessorias';
    edvalor_despesas_acessorias.DataField := 'valor_despesas_acessorias';
    edvalor_despesas_acessorias.DataSource := DataSource;
    lbvalor_outras.SetParentComponent(Self);
    lbvalor_outras.Name := 'lbvalor_outras';
    lbvalor_outras.Left := 24;
    lbvalor_outras.Top := 975;
    lbvalor_outras.Width := 14;
    lbvalor_outras.Height := 13;
    lbvalor_outras.Caption := 'valor_outras:';
    lbvalor_outras.Transparent := True;
    edvalor_outras.SetParentComponent(Self);
    edvalor_outras.Name := 'edvalor_outras';
    edvalor_outras.Left := 221;
    edvalor_outras.Top := 972;
    edvalor_outras.Width := 200;
    edvalor_outras.Height := 21;
    edvalor_outras.Enabled := True;
    edvalor_outras.TabOrder := 35;
    edvalor_outras.Text := 'edvalor_outras';
    edvalor_outras.DataField := 'valor_outras';
    edvalor_outras.DataSource := DataSource;
    lbvalor_base_calculo_ipi.SetParentComponent(Self);
    lbvalor_base_calculo_ipi.Name := 'lbvalor_base_calculo_ipi';
    lbvalor_base_calculo_ipi.Left := 24;
    lbvalor_base_calculo_ipi.Top := 1002;
    lbvalor_base_calculo_ipi.Width := 14;
    lbvalor_base_calculo_ipi.Height := 13;
    lbvalor_base_calculo_ipi.Caption := 'valor_base_calculo_ipi:';
    lbvalor_base_calculo_ipi.Transparent := True;
    edvalor_base_calculo_ipi.SetParentComponent(Self);
    edvalor_base_calculo_ipi.Name := 'edvalor_base_calculo_ipi';
    edvalor_base_calculo_ipi.Left := 221;
    edvalor_base_calculo_ipi.Top := 999;
    edvalor_base_calculo_ipi.Width := 200;
    edvalor_base_calculo_ipi.Height := 21;
    edvalor_base_calculo_ipi.Enabled := True;
    edvalor_base_calculo_ipi.TabOrder := 36;
    edvalor_base_calculo_ipi.Text := 'edvalor_base_calculo_ipi';
    edvalor_base_calculo_ipi.DataField := 'valor_base_calculo_ipi';
    edvalor_base_calculo_ipi.DataSource := DataSource;
    lbvalor_base_calculo_pis.SetParentComponent(Self);
    lbvalor_base_calculo_pis.Name := 'lbvalor_base_calculo_pis';
    lbvalor_base_calculo_pis.Left := 24;
    lbvalor_base_calculo_pis.Top := 1029;
    lbvalor_base_calculo_pis.Width := 14;
    lbvalor_base_calculo_pis.Height := 13;
    lbvalor_base_calculo_pis.Caption := 'valor_base_calculo_pis:';
    lbvalor_base_calculo_pis.Transparent := True;
    edvalor_base_calculo_pis.SetParentComponent(Self);
    edvalor_base_calculo_pis.Name := 'edvalor_base_calculo_pis';
    edvalor_base_calculo_pis.Left := 221;
    edvalor_base_calculo_pis.Top := 1026;
    edvalor_base_calculo_pis.Width := 200;
    edvalor_base_calculo_pis.Height := 21;
    edvalor_base_calculo_pis.Enabled := True;
    edvalor_base_calculo_pis.TabOrder := 37;
    edvalor_base_calculo_pis.Text := 'edvalor_base_calculo_pis';
    edvalor_base_calculo_pis.DataField := 'valor_base_calculo_pis';
    edvalor_base_calculo_pis.DataSource := DataSource;
    lbvalor_pis.SetParentComponent(Self);
    lbvalor_pis.Name := 'lbvalor_pis';
    lbvalor_pis.Left := 24;
    lbvalor_pis.Top := 1056;
    lbvalor_pis.Width := 14;
    lbvalor_pis.Height := 13;
    lbvalor_pis.Caption := 'valor_pis:';
    lbvalor_pis.Transparent := True;
    edvalor_pis.SetParentComponent(Self);
    edvalor_pis.Name := 'edvalor_pis';
    edvalor_pis.Left := 221;
    edvalor_pis.Top := 1053;
    edvalor_pis.Width := 200;
    edvalor_pis.Height := 21;
    edvalor_pis.Enabled := True;
    edvalor_pis.TabOrder := 38;
    edvalor_pis.Text := 'edvalor_pis';
    edvalor_pis.DataField := 'valor_pis';
    edvalor_pis.DataSource := DataSource;
    lbvalor_base_calculo_cofins.SetParentComponent(Self);
    lbvalor_base_calculo_cofins.Name := 'lbvalor_base_calculo_cofins';
    lbvalor_base_calculo_cofins.Left := 24;
    lbvalor_base_calculo_cofins.Top := 1083;
    lbvalor_base_calculo_cofins.Width := 14;
    lbvalor_base_calculo_cofins.Height := 13;
    lbvalor_base_calculo_cofins.Caption := 'valor_base_calculo_cofins:';
    lbvalor_base_calculo_cofins.Transparent := True;
    edvalor_base_calculo_cofins.SetParentComponent(Self);
    edvalor_base_calculo_cofins.Name := 'edvalor_base_calculo_cofins';
    edvalor_base_calculo_cofins.Left := 221;
    edvalor_base_calculo_cofins.Top := 1080;
    edvalor_base_calculo_cofins.Width := 200;
    edvalor_base_calculo_cofins.Height := 21;
    edvalor_base_calculo_cofins.Enabled := True;
    edvalor_base_calculo_cofins.TabOrder := 39;
    edvalor_base_calculo_cofins.Text := 'edvalor_base_calculo_cofins';
    edvalor_base_calculo_cofins.DataField := 'valor_base_calculo_cofins';
    edvalor_base_calculo_cofins.DataSource := DataSource;
    lbvalor_cofins.SetParentComponent(Self);
    lbvalor_cofins.Name := 'lbvalor_cofins';
    lbvalor_cofins.Left := 24;
    lbvalor_cofins.Top := 1110;
    lbvalor_cofins.Width := 14;
    lbvalor_cofins.Height := 13;
    lbvalor_cofins.Caption := 'valor_cofins:';
    lbvalor_cofins.Transparent := True;
    edvalor_cofins.SetParentComponent(Self);
    edvalor_cofins.Name := 'edvalor_cofins';
    edvalor_cofins.Left := 221;
    edvalor_cofins.Top := 1107;
    edvalor_cofins.Width := 200;
    edvalor_cofins.Height := 21;
    edvalor_cofins.Enabled := True;
    edvalor_cofins.TabOrder := 40;
    edvalor_cofins.Text := 'edvalor_cofins';
    edvalor_cofins.DataField := 'valor_cofins';
    edvalor_cofins.DataSource := DataSource;
    lbquantidade_selo_ipi.SetParentComponent(Self);
    lbquantidade_selo_ipi.Name := 'lbquantidade_selo_ipi';
    lbquantidade_selo_ipi.Left := 24;
    lbquantidade_selo_ipi.Top := 1137;
    lbquantidade_selo_ipi.Width := 14;
    lbquantidade_selo_ipi.Height := 13;
    lbquantidade_selo_ipi.Caption := 'quantidade_selo_ipi:';
    lbquantidade_selo_ipi.Transparent := True;
    edquantidade_selo_ipi.SetParentComponent(Self);
    edquantidade_selo_ipi.Name := 'edquantidade_selo_ipi';
    edquantidade_selo_ipi.Left := 221;
    edquantidade_selo_ipi.Top := 1134;
    edquantidade_selo_ipi.Width := 200;
    edquantidade_selo_ipi.Height := 21;
    edquantidade_selo_ipi.Enabled := True;
    edquantidade_selo_ipi.TabOrder := 41;
    edquantidade_selo_ipi.Text := 'edquantidade_selo_ipi';
    edquantidade_selo_ipi.DataField := 'quantidade_selo_ipi';
    edquantidade_selo_ipi.DataSource := DataSource;
    lbcst_ipi_id.SetParentComponent(Self);
    lbcst_ipi_id.Name := 'lbcst_ipi_id';
    lbcst_ipi_id.Left := 24;
    lbcst_ipi_id.Top := 1164;
    lbcst_ipi_id.Width := 14;
    lbcst_ipi_id.Height := 13;
    lbcst_ipi_id.Caption := 'cst_ipi_id:';
    lbcst_ipi_id.Transparent := True;
    edcst_ipi_id.SetParentComponent(Self);
    edcst_ipi_id.Name := 'edcst_ipi_id';
    edcst_ipi_id.Left := 221;
    edcst_ipi_id.Top := 1161;
    edcst_ipi_id.Width := 200;
    edcst_ipi_id.Height := 21;
    edcst_ipi_id.Enabled := True;
    edcst_ipi_id.TabOrder := 42;
    edcst_ipi_id.Text := 'edcst_ipi_id';
    edcst_ipi_id.DataField := 'cst_ipi_id';
    edcst_ipi_id.DataSource := DataSource;
    lbcsosn_id.SetParentComponent(Self);
    lbcsosn_id.Name := 'lbcsosn_id';
    lbcsosn_id.Left := 24;
    lbcsosn_id.Top := 1191;
    lbcsosn_id.Width := 14;
    lbcsosn_id.Height := 13;
    lbcsosn_id.Caption := 'csosn_id:';
    lbcsosn_id.Transparent := True;
    edcsosn_id.SetParentComponent(Self);
    edcsosn_id.Name := 'edcsosn_id';
    edcsosn_id.Left := 221;
    edcsosn_id.Top := 1188;
    edcsosn_id.Width := 200;
    edcsosn_id.Height := 21;
    edcsosn_id.Enabled := True;
    edcsosn_id.TabOrder := 43;
    edcsosn_id.Text := 'edcsosn_id';
    edcsosn_id.DataField := 'csosn_id';
    edcsosn_id.DataSource := DataSource;
    lbvalor_ipi_unitario.SetParentComponent(Self);
    lbvalor_ipi_unitario.Name := 'lbvalor_ipi_unitario';
    lbvalor_ipi_unitario.Left := 24;
    lbvalor_ipi_unitario.Top := 1218;
    lbvalor_ipi_unitario.Width := 14;
    lbvalor_ipi_unitario.Height := 13;
    lbvalor_ipi_unitario.Caption := 'valor_ipi_unitario:';
    lbvalor_ipi_unitario.Transparent := True;
    edvalor_ipi_unitario.SetParentComponent(Self);
    edvalor_ipi_unitario.Name := 'edvalor_ipi_unitario';
    edvalor_ipi_unitario.Left := 221;
    edvalor_ipi_unitario.Top := 1215;
    edvalor_ipi_unitario.Width := 200;
    edvalor_ipi_unitario.Height := 21;
    edvalor_ipi_unitario.Enabled := True;
    edvalor_ipi_unitario.TabOrder := 44;
    edvalor_ipi_unitario.Text := 'edvalor_ipi_unitario';
    edvalor_ipi_unitario.DataField := 'valor_ipi_unitario';
    edvalor_ipi_unitario.DataSource := DataSource;
    lbaliquota_pis.SetParentComponent(Self);
    lbaliquota_pis.Name := 'lbaliquota_pis';
    lbaliquota_pis.Left := 24;
    lbaliquota_pis.Top := 1245;
    lbaliquota_pis.Width := 14;
    lbaliquota_pis.Height := 13;
    lbaliquota_pis.Caption := 'aliquota_pis:';
    lbaliquota_pis.Transparent := True;
    edaliquota_pis.SetParentComponent(Self);
    edaliquota_pis.Name := 'edaliquota_pis';
    edaliquota_pis.Left := 221;
    edaliquota_pis.Top := 1242;
    edaliquota_pis.Width := 200;
    edaliquota_pis.Height := 21;
    edaliquota_pis.Enabled := True;
    edaliquota_pis.TabOrder := 45;
    edaliquota_pis.Text := 'edaliquota_pis';
    edaliquota_pis.DataField := 'aliquota_pis';
    edaliquota_pis.DataSource := DataSource;
    lbaliquota_cofins.SetParentComponent(Self);
    lbaliquota_cofins.Name := 'lbaliquota_cofins';
    lbaliquota_cofins.Left := 24;
    lbaliquota_cofins.Top := 1272;
    lbaliquota_cofins.Width := 14;
    lbaliquota_cofins.Height := 13;
    lbaliquota_cofins.Caption := 'aliquota_cofins:';
    lbaliquota_cofins.Transparent := True;
    edaliquota_cofins.SetParentComponent(Self);
    edaliquota_cofins.Name := 'edaliquota_cofins';
    edaliquota_cofins.Left := 221;
    edaliquota_cofins.Top := 1269;
    edaliquota_cofins.Width := 200;
    edaliquota_cofins.Height := 21;
    edaliquota_cofins.Enabled := True;
    edaliquota_cofins.TabOrder := 46;
    edaliquota_cofins.Text := 'edaliquota_cofins';
    edaliquota_cofins.DataField := 'aliquota_cofins';
    edaliquota_cofins.DataSource := DataSource;
    lbcst_pis_id.SetParentComponent(Self);
    lbcst_pis_id.Name := 'lbcst_pis_id';
    lbcst_pis_id.Left := 24;
    lbcst_pis_id.Top := 1299;
    lbcst_pis_id.Width := 14;
    lbcst_pis_id.Height := 13;
    lbcst_pis_id.Caption := 'cst_pis_id:';
    lbcst_pis_id.Transparent := True;
    edcst_pis_id.SetParentComponent(Self);
    edcst_pis_id.Name := 'edcst_pis_id';
    edcst_pis_id.Left := 221;
    edcst_pis_id.Top := 1296;
    edcst_pis_id.Width := 200;
    edcst_pis_id.Height := 21;
    edcst_pis_id.Enabled := True;
    edcst_pis_id.TabOrder := 47;
    edcst_pis_id.Text := 'edcst_pis_id';
    edcst_pis_id.DataField := 'cst_pis_id';
    edcst_pis_id.DataSource := DataSource;
    lbcst_cofins_id.SetParentComponent(Self);
    lbcst_cofins_id.Name := 'lbcst_cofins_id';
    lbcst_cofins_id.Left := 24;
    lbcst_cofins_id.Top := 1326;
    lbcst_cofins_id.Width := 14;
    lbcst_cofins_id.Height := 13;
    lbcst_cofins_id.Caption := 'cst_cofins_id:';
    lbcst_cofins_id.Transparent := True;
    edcst_cofins_id.SetParentComponent(Self);
    edcst_cofins_id.Name := 'edcst_cofins_id';
    edcst_cofins_id.Left := 221;
    edcst_cofins_id.Top := 1323;
    edcst_cofins_id.Width := 200;
    edcst_cofins_id.Height := 21;
    edcst_cofins_id.Enabled := True;
    edcst_cofins_id.TabOrder := 48;
    edcst_cofins_id.Text := 'edcst_cofins_id';
    edcst_cofins_id.DataField := 'cst_cofins_id';
    edcst_cofins_id.DataSource := DataSource;
    lbvalor_base_calculo_st_retida.SetParentComponent(Self);
    lbvalor_base_calculo_st_retida.Name := 'lbvalor_base_calculo_st_retida';
    lbvalor_base_calculo_st_retida.Left := 24;
    lbvalor_base_calculo_st_retida.Top := 1353;
    lbvalor_base_calculo_st_retida.Width := 14;
    lbvalor_base_calculo_st_retida.Height := 13;
    lbvalor_base_calculo_st_retida.Caption := 'valor_base_calculo_st_retida:';
    lbvalor_base_calculo_st_retida.Transparent := True;
    edvalor_base_calculo_st_retida.SetParentComponent(Self);
    edvalor_base_calculo_st_retida.Name := 'edvalor_base_calculo_st_retida';
    edvalor_base_calculo_st_retida.Left := 221;
    edvalor_base_calculo_st_retida.Top := 1350;
    edvalor_base_calculo_st_retida.Width := 200;
    edvalor_base_calculo_st_retida.Height := 21;
    edvalor_base_calculo_st_retida.Enabled := True;
    edvalor_base_calculo_st_retida.TabOrder := 49;
    edvalor_base_calculo_st_retida.Text := 'edvalor_base_calculo_st_retida';
    edvalor_base_calculo_st_retida.DataField := 'valor_base_calculo_st_retida';
    edvalor_base_calculo_st_retida.DataSource := DataSource;
    lbvalor_st_retida.SetParentComponent(Self);
    lbvalor_st_retida.Name := 'lbvalor_st_retida';
    lbvalor_st_retida.Left := 24;
    lbvalor_st_retida.Top := 1380;
    lbvalor_st_retida.Width := 14;
    lbvalor_st_retida.Height := 13;
    lbvalor_st_retida.Caption := 'valor_st_retida:';
    lbvalor_st_retida.Transparent := True;
    edvalor_st_retida.SetParentComponent(Self);
    edvalor_st_retida.Name := 'edvalor_st_retida';
    edvalor_st_retida.Left := 221;
    edvalor_st_retida.Top := 1377;
    edvalor_st_retida.Width := 200;
    edvalor_st_retida.Height := 21;
    edvalor_st_retida.Enabled := True;
    edvalor_st_retida.TabOrder := 50;
    edvalor_st_retida.Text := 'edvalor_st_retida';
    edvalor_st_retida.DataField := 'valor_st_retida';
    edvalor_st_retida.DataSource := DataSource;
    lbvalor_pis_retido.SetParentComponent(Self);
    lbvalor_pis_retido.Name := 'lbvalor_pis_retido';
    lbvalor_pis_retido.Left := 24;
    lbvalor_pis_retido.Top := 1407;
    lbvalor_pis_retido.Width := 14;
    lbvalor_pis_retido.Height := 13;
    lbvalor_pis_retido.Caption := 'valor_pis_retido:';
    lbvalor_pis_retido.Transparent := True;
    edvalor_pis_retido.SetParentComponent(Self);
    edvalor_pis_retido.Name := 'edvalor_pis_retido';
    edvalor_pis_retido.Left := 221;
    edvalor_pis_retido.Top := 1404;
    edvalor_pis_retido.Width := 200;
    edvalor_pis_retido.Height := 21;
    edvalor_pis_retido.Enabled := True;
    edvalor_pis_retido.TabOrder := 51;
    edvalor_pis_retido.Text := 'edvalor_pis_retido';
    edvalor_pis_retido.DataField := 'valor_pis_retido';
    edvalor_pis_retido.DataSource := DataSource;
    lbvalor_cofins_retido.SetParentComponent(Self);
    lbvalor_cofins_retido.Name := 'lbvalor_cofins_retido';
    lbvalor_cofins_retido.Left := 24;
    lbvalor_cofins_retido.Top := 1434;
    lbvalor_cofins_retido.Width := 14;
    lbvalor_cofins_retido.Height := 13;
    lbvalor_cofins_retido.Caption := 'valor_cofins_retido:';
    lbvalor_cofins_retido.Transparent := True;
    edvalor_cofins_retido.SetParentComponent(Self);
    edvalor_cofins_retido.Name := 'edvalor_cofins_retido';
    edvalor_cofins_retido.Left := 221;
    edvalor_cofins_retido.Top := 1431;
    edvalor_cofins_retido.Width := 200;
    edvalor_cofins_retido.Height := 21;
    edvalor_cofins_retido.Enabled := True;
    edvalor_cofins_retido.TabOrder := 52;
    edvalor_cofins_retido.Text := 'edvalor_cofins_retido';
    edvalor_cofins_retido.DataField := 'valor_cofins_retido';
    edvalor_cofins_retido.DataSource := DataSource;
    lbcodigo_natureza_pis_cofins_id.SetParentComponent(Self);
    lbcodigo_natureza_pis_cofins_id.Name := 'lbcodigo_natureza_pis_cofins_id';
    lbcodigo_natureza_pis_cofins_id.Left := 24;
    lbcodigo_natureza_pis_cofins_id.Top := 1461;
    lbcodigo_natureza_pis_cofins_id.Width := 14;
    lbcodigo_natureza_pis_cofins_id.Height := 13;
    lbcodigo_natureza_pis_cofins_id.Caption := 'codigo_natureza_pis_cofins_id:';
    lbcodigo_natureza_pis_cofins_id.Transparent := True;
    edcodigo_natureza_pis_cofins_id.SetParentComponent(Self);
    edcodigo_natureza_pis_cofins_id.Name := 'edcodigo_natureza_pis_cofins_id';
    edcodigo_natureza_pis_cofins_id.Left := 221;
    edcodigo_natureza_pis_cofins_id.Top := 1458;
    edcodigo_natureza_pis_cofins_id.Width := 200;
    edcodigo_natureza_pis_cofins_id.Height := 21;
    edcodigo_natureza_pis_cofins_id.Enabled := True;
    edcodigo_natureza_pis_cofins_id.TabOrder := 53;
    edcodigo_natureza_pis_cofins_id.Text := 'edcodigo_natureza_pis_cofins_id';
    edcodigo_natureza_pis_cofins_id.DataField := 'codigo_natureza_pis_cofins_id';
    edcodigo_natureza_pis_cofins_id.DataSource := DataSource;
    lbaliquota_id.SetParentComponent(Self);
    lbaliquota_id.Name := 'lbaliquota_id';
    lbaliquota_id.Left := 24;
    lbaliquota_id.Top := 1488;
    lbaliquota_id.Width := 14;
    lbaliquota_id.Height := 13;
    lbaliquota_id.Caption := 'aliquota_id:';
    lbaliquota_id.Transparent := True;
    edaliquota_id.SetParentComponent(Self);
    edaliquota_id.Name := 'edaliquota_id';
    edaliquota_id.Left := 221;
    edaliquota_id.Top := 1485;
    edaliquota_id.Width := 200;
    edaliquota_id.Height := 21;
    edaliquota_id.Enabled := True;
    edaliquota_id.TabOrder := 54;
    edaliquota_id.Text := 'edaliquota_id';
    edaliquota_id.DataField := 'aliquota_id';
    edaliquota_id.DataSource := DataSource;
    lbvalor_isentas.SetParentComponent(Self);
    lbvalor_isentas.Name := 'lbvalor_isentas';
    lbvalor_isentas.Left := 24;
    lbvalor_isentas.Top := 1515;
    lbvalor_isentas.Width := 14;
    lbvalor_isentas.Height := 13;
    lbvalor_isentas.Caption := 'valor_isentas:';
    lbvalor_isentas.Transparent := True;
    edvalor_isentas.SetParentComponent(Self);
    edvalor_isentas.Name := 'edvalor_isentas';
    edvalor_isentas.Left := 221;
    edvalor_isentas.Top := 1512;
    edvalor_isentas.Width := 200;
    edvalor_isentas.Height := 21;
    edvalor_isentas.Enabled := True;
    edvalor_isentas.TabOrder := 55;
    edvalor_isentas.Text := 'edvalor_isentas';
    edvalor_isentas.DataField := 'valor_isentas';
    edvalor_isentas.DataSource := DataSource;
    lbproduto_preco_custo.SetParentComponent(Self);
    lbproduto_preco_custo.Name := 'lbproduto_preco_custo';
    lbproduto_preco_custo.Left := 24;
    lbproduto_preco_custo.Top := 1542;
    lbproduto_preco_custo.Width := 14;
    lbproduto_preco_custo.Height := 13;
    lbproduto_preco_custo.Caption := 'produto_preco_custo:';
    lbproduto_preco_custo.Transparent := True;
    edproduto_preco_custo.SetParentComponent(Self);
    edproduto_preco_custo.Name := 'edproduto_preco_custo';
    edproduto_preco_custo.Left := 221;
    edproduto_preco_custo.Top := 1539;
    edproduto_preco_custo.Width := 200;
    edproduto_preco_custo.Height := 21;
    edproduto_preco_custo.Enabled := True;
    edproduto_preco_custo.TabOrder := 56;
    edproduto_preco_custo.Text := 'edproduto_preco_custo';
    edproduto_preco_custo.DataField := 'produto_preco_custo';
    edproduto_preco_custo.DataSource := DataSource;
    lbcodigo_produto_movimenta_estoque.SetParentComponent(Self);
    lbcodigo_produto_movimenta_estoque.Name := 'lbcodigo_produto_movimenta_estoque';
    lbcodigo_produto_movimenta_estoque.Left := 24;
    lbcodigo_produto_movimenta_estoque.Top := 1569;
    lbcodigo_produto_movimenta_estoque.Width := 14;
    lbcodigo_produto_movimenta_estoque.Height := 13;
    lbcodigo_produto_movimenta_estoque.Caption := 'codigo_produto_movimenta_estoque:';
    lbcodigo_produto_movimenta_estoque.Transparent := True;
    edcodigo_produto_movimenta_estoque.SetParentComponent(Self);
    edcodigo_produto_movimenta_estoque.Name := 'edcodigo_produto_movimenta_estoque';
    edcodigo_produto_movimenta_estoque.Left := 221;
    edcodigo_produto_movimenta_estoque.Top := 1566;
    edcodigo_produto_movimenta_estoque.Width := 200;
    edcodigo_produto_movimenta_estoque.Height := 21;
    edcodigo_produto_movimenta_estoque.Enabled := True;
    edcodigo_produto_movimenta_estoque.TabOrder := 57;
    edcodigo_produto_movimenta_estoque.Text := 'edcodigo_produto_movimenta_estoque';
    edcodigo_produto_movimenta_estoque.DataField := 'codigo_produto_movimenta_estoque';
    edcodigo_produto_movimenta_estoque.DataSource := DataSource;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 24;
    lbfuncionario_id.Top := 1596;
    lbfuncionario_id.Width := 14;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'funcionario_id:';
    lbfuncionario_id.Transparent := True;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 221;
    edfuncionario_id.Top := 1593;
    edfuncionario_id.Width := 200;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := True;
    edfuncionario_id.TabOrder := 58;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.DataField := 'funcionario_id';
    edfuncionario_id.DataSource := DataSource;
    lbvalor_total_impostos.SetParentComponent(Self);
    lbvalor_total_impostos.Name := 'lbvalor_total_impostos';
    lbvalor_total_impostos.Left := 24;
    lbvalor_total_impostos.Top := 1623;
    lbvalor_total_impostos.Width := 14;
    lbvalor_total_impostos.Height := 13;
    lbvalor_total_impostos.Caption := 'valor_total_impostos:';
    lbvalor_total_impostos.Transparent := True;
    edvalor_total_impostos.SetParentComponent(Self);
    edvalor_total_impostos.Name := 'edvalor_total_impostos';
    edvalor_total_impostos.Left := 221;
    edvalor_total_impostos.Top := 1620;
    edvalor_total_impostos.Width := 200;
    edvalor_total_impostos.Height := 21;
    edvalor_total_impostos.Enabled := True;
    edvalor_total_impostos.TabOrder := 59;
    edvalor_total_impostos.Text := 'edvalor_total_impostos';
    edvalor_total_impostos.DataField := 'valor_total_impostos';
    edvalor_total_impostos.DataSource := DataSource;
    lbquantidade_embalagem.SetParentComponent(Self);
    lbquantidade_embalagem.Name := 'lbquantidade_embalagem';
    lbquantidade_embalagem.Left := 24;
    lbquantidade_embalagem.Top := 1650;
    lbquantidade_embalagem.Width := 14;
    lbquantidade_embalagem.Height := 13;
    lbquantidade_embalagem.Caption := 'quantidade_embalagem:';
    lbquantidade_embalagem.Transparent := True;
    edquantidade_embalagem.SetParentComponent(Self);
    edquantidade_embalagem.Name := 'edquantidade_embalagem';
    edquantidade_embalagem.Left := 221;
    edquantidade_embalagem.Top := 1647;
    edquantidade_embalagem.Width := 200;
    edquantidade_embalagem.Height := 21;
    edquantidade_embalagem.Enabled := True;
    edquantidade_embalagem.TabOrder := 60;
    edquantidade_embalagem.Text := 'edquantidade_embalagem';
    edquantidade_embalagem.DataField := 'quantidade_embalagem';
    edquantidade_embalagem.DataSource := DataSource;
    lbitem_movimenta_estoque.SetParentComponent(Self);
    lbitem_movimenta_estoque.Name := 'lbitem_movimenta_estoque';
    lbitem_movimenta_estoque.Left := 24;
    lbitem_movimenta_estoque.Top := 1677;
    lbitem_movimenta_estoque.Width := 14;
    lbitem_movimenta_estoque.Height := 13;
    lbitem_movimenta_estoque.Caption := 'item_movimenta_estoque:';
    lbitem_movimenta_estoque.Transparent := True;
    editem_movimenta_estoque.SetParentComponent(Self);
    editem_movimenta_estoque.Name := 'editem_movimenta_estoque';
    editem_movimenta_estoque.Left := 221;
    editem_movimenta_estoque.Top := 1674;
    editem_movimenta_estoque.Width := 200;
    editem_movimenta_estoque.Height := 21;
    editem_movimenta_estoque.Enabled := True;
    editem_movimenta_estoque.TabOrder := 61;
    editem_movimenta_estoque.Text := 'editem_movimenta_estoque';
    editem_movimenta_estoque.DataField := 'item_movimenta_estoque';
    editem_movimenta_estoque.DataSource := DataSource;
    lbgrade_produto_id.SetParentComponent(Self);
    lbgrade_produto_id.Name := 'lbgrade_produto_id';
    lbgrade_produto_id.Left := 24;
    lbgrade_produto_id.Top := 1704;
    lbgrade_produto_id.Width := 14;
    lbgrade_produto_id.Height := 13;
    lbgrade_produto_id.Caption := 'grade_produto_id:';
    lbgrade_produto_id.Transparent := True;
    edgrade_produto_id.SetParentComponent(Self);
    edgrade_produto_id.Name := 'edgrade_produto_id';
    edgrade_produto_id.Left := 221;
    edgrade_produto_id.Top := 1701;
    edgrade_produto_id.Width := 200;
    edgrade_produto_id.Height := 21;
    edgrade_produto_id.Enabled := True;
    edgrade_produto_id.TabOrder := 62;
    edgrade_produto_id.Text := 'edgrade_produto_id';
    edgrade_produto_id.DataField := 'grade_produto_id';
    edgrade_produto_id.DataSource := DataSource;
    lbproduto_nome.SetParentComponent(Self);
    lbproduto_nome.Name := 'lbproduto_nome';
    lbproduto_nome.Left := 24;
    lbproduto_nome.Top := 1731;
    lbproduto_nome.Width := 14;
    lbproduto_nome.Height := 13;
    lbproduto_nome.Caption := 'produto_nome:';
    lbproduto_nome.Transparent := True;
    edproduto_nome.SetParentComponent(Self);
    edproduto_nome.Name := 'edproduto_nome';
    edproduto_nome.Left := 221;
    edproduto_nome.Top := 1728;
    edproduto_nome.Width := 200;
    edproduto_nome.Height := 21;
    edproduto_nome.Enabled := True;
    edproduto_nome.TabOrder := 63;
    edproduto_nome.Text := 'edproduto_nome';
    edproduto_nome.DataField := 'produto_nome';
    edproduto_nome.DataSource := DataSource;
    lbaliquota_interna.SetParentComponent(Self);
    lbaliquota_interna.Name := 'lbaliquota_interna';
    lbaliquota_interna.Left := 24;
    lbaliquota_interna.Top := 1758;
    lbaliquota_interna.Width := 14;
    lbaliquota_interna.Height := 13;
    lbaliquota_interna.Caption := 'aliquota_interna:';
    lbaliquota_interna.Transparent := True;
    edaliquota_interna.SetParentComponent(Self);
    edaliquota_interna.Name := 'edaliquota_interna';
    edaliquota_interna.Left := 221;
    edaliquota_interna.Top := 1755;
    edaliquota_interna.Width := 200;
    edaliquota_interna.Height := 21;
    edaliquota_interna.Enabled := True;
    edaliquota_interna.TabOrder := 64;
    edaliquota_interna.Text := 'edaliquota_interna';
    edaliquota_interna.DataField := 'aliquota_interna';
    edaliquota_interna.DataSource := DataSource;
    lbaliquota_interestadual.SetParentComponent(Self);
    lbaliquota_interestadual.Name := 'lbaliquota_interestadual';
    lbaliquota_interestadual.Left := 24;
    lbaliquota_interestadual.Top := 1785;
    lbaliquota_interestadual.Width := 14;
    lbaliquota_interestadual.Height := 13;
    lbaliquota_interestadual.Caption := 'aliquota_interestadual:';
    lbaliquota_interestadual.Transparent := True;
    edaliquota_interestadual.SetParentComponent(Self);
    edaliquota_interestadual.Name := 'edaliquota_interestadual';
    edaliquota_interestadual.Left := 221;
    edaliquota_interestadual.Top := 1782;
    edaliquota_interestadual.Width := 200;
    edaliquota_interestadual.Height := 21;
    edaliquota_interestadual.Enabled := True;
    edaliquota_interestadual.TabOrder := 65;
    edaliquota_interestadual.Text := 'edaliquota_interestadual';
    edaliquota_interestadual.DataField := 'aliquota_interestadual';
    edaliquota_interestadual.DataSource := DataSource;
    lbvalor_base_calculo_icms_interestadual.SetParentComponent(Self);
    lbvalor_base_calculo_icms_interestadual.Name := 'lbvalor_base_calculo_icms_interestadual';
    lbvalor_base_calculo_icms_interestadual.Left := 24;
    lbvalor_base_calculo_icms_interestadual.Top := 1812;
    lbvalor_base_calculo_icms_interestadual.Width := 14;
    lbvalor_base_calculo_icms_interestadual.Height := 13;
    lbvalor_base_calculo_icms_interestadual.Caption := 'valor_base_calculo_icms_interestadual:';
    lbvalor_base_calculo_icms_interestadual.Transparent := True;
    edvalor_base_calculo_icms_interestadual.SetParentComponent(Self);
    edvalor_base_calculo_icms_interestadual.Name := 'edvalor_base_calculo_icms_interestadual';
    edvalor_base_calculo_icms_interestadual.Left := 221;
    edvalor_base_calculo_icms_interestadual.Top := 1809;
    edvalor_base_calculo_icms_interestadual.Width := 200;
    edvalor_base_calculo_icms_interestadual.Height := 21;
    edvalor_base_calculo_icms_interestadual.Enabled := True;
    edvalor_base_calculo_icms_interestadual.TabOrder := 66;
    edvalor_base_calculo_icms_interestadual.Text := 'edvalor_base_calculo_icms_interestadual';
    edvalor_base_calculo_icms_interestadual.DataField := 'valor_base_calculo_icms_interestadual';
    edvalor_base_calculo_icms_interestadual.DataSource := DataSource;
    lbaliquota_icms_interestadual_destino.SetParentComponent(Self);
    lbaliquota_icms_interestadual_destino.Name := 'lbaliquota_icms_interestadual_destino';
    lbaliquota_icms_interestadual_destino.Left := 24;
    lbaliquota_icms_interestadual_destino.Top := 1839;
    lbaliquota_icms_interestadual_destino.Width := 14;
    lbaliquota_icms_interestadual_destino.Height := 13;
    lbaliquota_icms_interestadual_destino.Caption := 'aliquota_icms_interestadual_destino:';
    lbaliquota_icms_interestadual_destino.Transparent := True;
    edaliquota_icms_interestadual_destino.SetParentComponent(Self);
    edaliquota_icms_interestadual_destino.Name := 'edaliquota_icms_interestadual_destino';
    edaliquota_icms_interestadual_destino.Left := 221;
    edaliquota_icms_interestadual_destino.Top := 1836;
    edaliquota_icms_interestadual_destino.Width := 200;
    edaliquota_icms_interestadual_destino.Height := 21;
    edaliquota_icms_interestadual_destino.Enabled := True;
    edaliquota_icms_interestadual_destino.TabOrder := 67;
    edaliquota_icms_interestadual_destino.Text := 'edaliquota_icms_interestadual_destino';
    edaliquota_icms_interestadual_destino.DataField := 'aliquota_icms_interestadual_destino';
    edaliquota_icms_interestadual_destino.DataSource := DataSource;
    lbvalor_icms_interestadual_destino.SetParentComponent(Self);
    lbvalor_icms_interestadual_destino.Name := 'lbvalor_icms_interestadual_destino';
    lbvalor_icms_interestadual_destino.Left := 24;
    lbvalor_icms_interestadual_destino.Top := 1866;
    lbvalor_icms_interestadual_destino.Width := 14;
    lbvalor_icms_interestadual_destino.Height := 13;
    lbvalor_icms_interestadual_destino.Caption := 'valor_icms_interestadual_destino:';
    lbvalor_icms_interestadual_destino.Transparent := True;
    edvalor_icms_interestadual_destino.SetParentComponent(Self);
    edvalor_icms_interestadual_destino.Name := 'edvalor_icms_interestadual_destino';
    edvalor_icms_interestadual_destino.Left := 221;
    edvalor_icms_interestadual_destino.Top := 1863;
    edvalor_icms_interestadual_destino.Width := 200;
    edvalor_icms_interestadual_destino.Height := 21;
    edvalor_icms_interestadual_destino.Enabled := True;
    edvalor_icms_interestadual_destino.TabOrder := 68;
    edvalor_icms_interestadual_destino.Text := 'edvalor_icms_interestadual_destino';
    edvalor_icms_interestadual_destino.DataField := 'valor_icms_interestadual_destino';
    edvalor_icms_interestadual_destino.DataSource := DataSource;
    lbvalor_icms_interestadual_remetente.SetParentComponent(Self);
    lbvalor_icms_interestadual_remetente.Name := 'lbvalor_icms_interestadual_remetente';
    lbvalor_icms_interestadual_remetente.Left := 24;
    lbvalor_icms_interestadual_remetente.Top := 1893;
    lbvalor_icms_interestadual_remetente.Width := 14;
    lbvalor_icms_interestadual_remetente.Height := 13;
    lbvalor_icms_interestadual_remetente.Caption := 'valor_icms_interestadual_remetente:';
    lbvalor_icms_interestadual_remetente.Transparent := True;
    edvalor_icms_interestadual_remetente.SetParentComponent(Self);
    edvalor_icms_interestadual_remetente.Name := 'edvalor_icms_interestadual_remetente';
    edvalor_icms_interestadual_remetente.Left := 221;
    edvalor_icms_interestadual_remetente.Top := 1890;
    edvalor_icms_interestadual_remetente.Width := 200;
    edvalor_icms_interestadual_remetente.Height := 21;
    edvalor_icms_interestadual_remetente.Enabled := True;
    edvalor_icms_interestadual_remetente.TabOrder := 69;
    edvalor_icms_interestadual_remetente.Text := 'edvalor_icms_interestadual_remetente';
    edvalor_icms_interestadual_remetente.DataField := 'valor_icms_interestadual_remetente';
    edvalor_icms_interestadual_remetente.DataSource := DataSource;
    lbaliquota_fcp.SetParentComponent(Self);
    lbaliquota_fcp.Name := 'lbaliquota_fcp';
    lbaliquota_fcp.Left := 24;
    lbaliquota_fcp.Top := 1920;
    lbaliquota_fcp.Width := 14;
    lbaliquota_fcp.Height := 13;
    lbaliquota_fcp.Caption := 'aliquota_fcp:';
    lbaliquota_fcp.Transparent := True;
    edaliquota_fcp.SetParentComponent(Self);
    edaliquota_fcp.Name := 'edaliquota_fcp';
    edaliquota_fcp.Left := 221;
    edaliquota_fcp.Top := 1917;
    edaliquota_fcp.Width := 200;
    edaliquota_fcp.Height := 21;
    edaliquota_fcp.Enabled := True;
    edaliquota_fcp.TabOrder := 70;
    edaliquota_fcp.Text := 'edaliquota_fcp';
    edaliquota_fcp.DataField := 'aliquota_fcp';
    edaliquota_fcp.DataSource := DataSource;
    lbvalor_fcp.SetParentComponent(Self);
    lbvalor_fcp.Name := 'lbvalor_fcp';
    lbvalor_fcp.Left := 24;
    lbvalor_fcp.Top := 1947;
    lbvalor_fcp.Width := 14;
    lbvalor_fcp.Height := 13;
    lbvalor_fcp.Caption := 'valor_fcp:';
    lbvalor_fcp.Transparent := True;
    edvalor_fcp.SetParentComponent(Self);
    edvalor_fcp.Name := 'edvalor_fcp';
    edvalor_fcp.Left := 221;
    edvalor_fcp.Top := 1944;
    edvalor_fcp.Width := 200;
    edvalor_fcp.Height := 21;
    edvalor_fcp.Enabled := True;
    edvalor_fcp.TabOrder := 71;
    edvalor_fcp.Text := 'edvalor_fcp';
    edvalor_fcp.DataField := 'valor_fcp';
    edvalor_fcp.DataSource := DataSource;
    lbnumero_pedido_compra.SetParentComponent(Self);
    lbnumero_pedido_compra.Name := 'lbnumero_pedido_compra';
    lbnumero_pedido_compra.Left := 24;
    lbnumero_pedido_compra.Top := 1974;
    lbnumero_pedido_compra.Width := 14;
    lbnumero_pedido_compra.Height := 13;
    lbnumero_pedido_compra.Caption := 'numero_pedido_compra:';
    lbnumero_pedido_compra.Transparent := True;
    ednumero_pedido_compra.SetParentComponent(Self);
    ednumero_pedido_compra.Name := 'ednumero_pedido_compra';
    ednumero_pedido_compra.Left := 221;
    ednumero_pedido_compra.Top := 1971;
    ednumero_pedido_compra.Width := 200;
    ednumero_pedido_compra.Height := 21;
    ednumero_pedido_compra.Enabled := True;
    ednumero_pedido_compra.TabOrder := 72;
    ednumero_pedido_compra.Text := 'ednumero_pedido_compra';
    ednumero_pedido_compra.DataField := 'numero_pedido_compra';
    ednumero_pedido_compra.DataSource := DataSource;
    lbitem_pedido_compra.SetParentComponent(Self);
    lbitem_pedido_compra.Name := 'lbitem_pedido_compra';
    lbitem_pedido_compra.Left := 24;
    lbitem_pedido_compra.Top := 2001;
    lbitem_pedido_compra.Width := 14;
    lbitem_pedido_compra.Height := 13;
    lbitem_pedido_compra.Caption := 'item_pedido_compra:';
    lbitem_pedido_compra.Transparent := True;
    editem_pedido_compra.SetParentComponent(Self);
    editem_pedido_compra.Name := 'editem_pedido_compra';
    editem_pedido_compra.Left := 221;
    editem_pedido_compra.Top := 1998;
    editem_pedido_compra.Width := 200;
    editem_pedido_compra.Height := 21;
    editem_pedido_compra.Enabled := True;
    editem_pedido_compra.TabOrder := 73;
    editem_pedido_compra.Text := 'editem_pedido_compra';
    editem_pedido_compra.DataField := 'item_pedido_compra';
    editem_pedido_compra.DataSource := DataSource;
    lbitem_quantidade_movimenta_estoque.SetParentComponent(Self);
    lbitem_quantidade_movimenta_estoque.Name := 'lbitem_quantidade_movimenta_estoque';
    lbitem_quantidade_movimenta_estoque.Left := 24;
    lbitem_quantidade_movimenta_estoque.Top := 2028;
    lbitem_quantidade_movimenta_estoque.Width := 14;
    lbitem_quantidade_movimenta_estoque.Height := 13;
    lbitem_quantidade_movimenta_estoque.Caption := 'item_quantidade_movimenta_estoque:';
    lbitem_quantidade_movimenta_estoque.Transparent := True;
    editem_quantidade_movimenta_estoque.SetParentComponent(Self);
    editem_quantidade_movimenta_estoque.Name := 'editem_quantidade_movimenta_estoque';
    editem_quantidade_movimenta_estoque.Left := 221;
    editem_quantidade_movimenta_estoque.Top := 2025;
    editem_quantidade_movimenta_estoque.Width := 200;
    editem_quantidade_movimenta_estoque.Height := 21;
    editem_quantidade_movimenta_estoque.Enabled := True;
    editem_quantidade_movimenta_estoque.TabOrder := 74;
    editem_quantidade_movimenta_estoque.Text := 'editem_quantidade_movimenta_estoque';
    editem_quantidade_movimenta_estoque.DataField := 'item_quantidade_movimenta_estoque';
    editem_quantidade_movimenta_estoque.DataSource := DataSource;
    lbicms_st_recuperado.SetParentComponent(Self);
    lbicms_st_recuperado.Name := 'lbicms_st_recuperado';
    lbicms_st_recuperado.Left := 24;
    lbicms_st_recuperado.Top := 2055;
    lbicms_st_recuperado.Width := 14;
    lbicms_st_recuperado.Height := 13;
    lbicms_st_recuperado.Caption := 'icms_st_recuperado:';
    lbicms_st_recuperado.Transparent := True;
    edicms_st_recuperado.SetParentComponent(Self);
    edicms_st_recuperado.Name := 'edicms_st_recuperado';
    edicms_st_recuperado.Left := 221;
    edicms_st_recuperado.Top := 2052;
    edicms_st_recuperado.Width := 200;
    edicms_st_recuperado.Height := 21;
    edicms_st_recuperado.Enabled := True;
    edicms_st_recuperado.TabOrder := 75;
    edicms_st_recuperado.Text := 'edicms_st_recuperado';
    edicms_st_recuperado.DataField := 'icms_st_recuperado';
    edicms_st_recuperado.DataSource := DataSource;
    lborigem_csosn_id.SetParentComponent(Self);
    lborigem_csosn_id.Name := 'lborigem_csosn_id';
    lborigem_csosn_id.Left := 24;
    lborigem_csosn_id.Top := 2082;
    lborigem_csosn_id.Width := 14;
    lborigem_csosn_id.Height := 13;
    lborigem_csosn_id.Caption := 'origem_csosn_id:';
    lborigem_csosn_id.Transparent := True;
    edorigem_csosn_id.SetParentComponent(Self);
    edorigem_csosn_id.Name := 'edorigem_csosn_id';
    edorigem_csosn_id.Left := 221;
    edorigem_csosn_id.Top := 2079;
    edorigem_csosn_id.Width := 200;
    edorigem_csosn_id.Height := 21;
    edorigem_csosn_id.Enabled := True;
    edorigem_csosn_id.TabOrder := 76;
    edorigem_csosn_id.Text := 'edorigem_csosn_id';
    edorigem_csosn_id.DataField := 'origem_csosn_id';
    edorigem_csosn_id.DataSource := DataSource;
    lbpercentual_gnn.SetParentComponent(Self);
    lbpercentual_gnn.Name := 'lbpercentual_gnn';
    lbpercentual_gnn.Left := 24;
    lbpercentual_gnn.Top := 2109;
    lbpercentual_gnn.Width := 14;
    lbpercentual_gnn.Height := 13;
    lbpercentual_gnn.Caption := 'percentual_gnn:';
    lbpercentual_gnn.Transparent := True;
    edpercentual_gnn.SetParentComponent(Self);
    edpercentual_gnn.Name := 'edpercentual_gnn';
    edpercentual_gnn.Left := 221;
    edpercentual_gnn.Top := 2106;
    edpercentual_gnn.Width := 200;
    edpercentual_gnn.Height := 21;
    edpercentual_gnn.Enabled := True;
    edpercentual_gnn.TabOrder := 77;
    edpercentual_gnn.Text := 'edpercentual_gnn';
    edpercentual_gnn.DataField := 'percentual_gnn';
    edpercentual_gnn.DataSource := DataSource;
    lbpercentual_gni.SetParentComponent(Self);
    lbpercentual_gni.Name := 'lbpercentual_gni';
    lbpercentual_gni.Left := 24;
    lbpercentual_gni.Top := 2136;
    lbpercentual_gni.Width := 14;
    lbpercentual_gni.Height := 13;
    lbpercentual_gni.Caption := 'percentual_gni:';
    lbpercentual_gni.Transparent := True;
    edpercentual_gni.SetParentComponent(Self);
    edpercentual_gni.Name := 'edpercentual_gni';
    edpercentual_gni.Left := 221;
    edpercentual_gni.Top := 2133;
    edpercentual_gni.Width := 200;
    edpercentual_gni.Height := 21;
    edpercentual_gni.Enabled := True;
    edpercentual_gni.TabOrder := 78;
    edpercentual_gni.Text := 'edpercentual_gni';
    edpercentual_gni.DataField := 'percentual_gni';
    edpercentual_gni.DataSource := DataSource;
    lbpercentual_glp.SetParentComponent(Self);
    lbpercentual_glp.Name := 'lbpercentual_glp';
    lbpercentual_glp.Left := 24;
    lbpercentual_glp.Top := 2163;
    lbpercentual_glp.Width := 14;
    lbpercentual_glp.Height := 13;
    lbpercentual_glp.Caption := 'percentual_glp:';
    lbpercentual_glp.Transparent := True;
    edpercentual_glp.SetParentComponent(Self);
    edpercentual_glp.Name := 'edpercentual_glp';
    edpercentual_glp.Left := 221;
    edpercentual_glp.Top := 2160;
    edpercentual_glp.Width := 200;
    edpercentual_glp.Height := 21;
    edpercentual_glp.Enabled := True;
    edpercentual_glp.TabOrder := 79;
    edpercentual_glp.Text := 'edpercentual_glp';
    edpercentual_glp.DataField := 'percentual_glp';
    edpercentual_glp.DataSource := DataSource;
    lbvalor_partida.SetParentComponent(Self);
    lbvalor_partida.Name := 'lbvalor_partida';
    lbvalor_partida.Left := 24;
    lbvalor_partida.Top := 2190;
    lbvalor_partida.Width := 14;
    lbvalor_partida.Height := 13;
    lbvalor_partida.Caption := 'valor_partida:';
    lbvalor_partida.Transparent := True;
    edvalor_partida.SetParentComponent(Self);
    edvalor_partida.Name := 'edvalor_partida';
    edvalor_partida.Left := 221;
    edvalor_partida.Top := 2187;
    edvalor_partida.Width := 200;
    edvalor_partida.Height := 21;
    edvalor_partida.Enabled := True;
    edvalor_partida.TabOrder := 80;
    edvalor_partida.Text := 'edvalor_partida';
    edvalor_partida.DataField := 'valor_partida';
    edvalor_partida.DataSource := DataSource;
    lbaliquota_st.SetParentComponent(Self);
    lbaliquota_st.Name := 'lbaliquota_st';
    lbaliquota_st.Left := 24;
    lbaliquota_st.Top := 2217;
    lbaliquota_st.Width := 14;
    lbaliquota_st.Height := 13;
    lbaliquota_st.Caption := 'aliquota_st:';
    lbaliquota_st.Transparent := True;
    edaliquota_st.SetParentComponent(Self);
    edaliquota_st.Name := 'edaliquota_st';
    edaliquota_st.Left := 221;
    edaliquota_st.Top := 2214;
    edaliquota_st.Width := 200;
    edaliquota_st.Height := 21;
    edaliquota_st.Enabled := True;
    edaliquota_st.TabOrder := 81;
    edaliquota_st.Text := 'edaliquota_st';
    edaliquota_st.DataField := 'aliquota_st';
    edaliquota_st.DataSource := DataSource;
    lbvalor_icms_st_reducao.SetParentComponent(Self);
    lbvalor_icms_st_reducao.Name := 'lbvalor_icms_st_reducao';
    lbvalor_icms_st_reducao.Left := 24;
    lbvalor_icms_st_reducao.Top := 2244;
    lbvalor_icms_st_reducao.Width := 14;
    lbvalor_icms_st_reducao.Height := 13;
    lbvalor_icms_st_reducao.Caption := 'valor_icms_st_reducao:';
    lbvalor_icms_st_reducao.Transparent := True;
    edvalor_icms_st_reducao.SetParentComponent(Self);
    edvalor_icms_st_reducao.Name := 'edvalor_icms_st_reducao';
    edvalor_icms_st_reducao.Left := 221;
    edvalor_icms_st_reducao.Top := 2241;
    edvalor_icms_st_reducao.Width := 200;
    edvalor_icms_st_reducao.Height := 21;
    edvalor_icms_st_reducao.Enabled := True;
    edvalor_icms_st_reducao.TabOrder := 82;
    edvalor_icms_st_reducao.Text := 'edvalor_icms_st_reducao';
    edvalor_icms_st_reducao.DataField := 'valor_icms_st_reducao';
    edvalor_icms_st_reducao.DataSource := DataSource;
    lbaliquota_st_retida.SetParentComponent(Self);
    lbaliquota_st_retida.Name := 'lbaliquota_st_retida';
    lbaliquota_st_retida.Left := 24;
    lbaliquota_st_retida.Top := 2271;
    lbaliquota_st_retida.Width := 14;
    lbaliquota_st_retida.Height := 13;
    lbaliquota_st_retida.Caption := 'aliquota_st_retida:';
    lbaliquota_st_retida.Transparent := True;
    edaliquota_st_retida.SetParentComponent(Self);
    edaliquota_st_retida.Name := 'edaliquota_st_retida';
    edaliquota_st_retida.Left := 221;
    edaliquota_st_retida.Top := 2268;
    edaliquota_st_retida.Width := 200;
    edaliquota_st_retida.Height := 21;
    edaliquota_st_retida.Enabled := True;
    edaliquota_st_retida.TabOrder := 83;
    edaliquota_st_retida.Text := 'edaliquota_st_retida';
    edaliquota_st_retida.DataField := 'aliquota_st_retida';
    edaliquota_st_retida.DataSource := DataSource;
    lbvalor_icms_proprio.SetParentComponent(Self);
    lbvalor_icms_proprio.Name := 'lbvalor_icms_proprio';
    lbvalor_icms_proprio.Left := 24;
    lbvalor_icms_proprio.Top := 2298;
    lbvalor_icms_proprio.Width := 14;
    lbvalor_icms_proprio.Height := 13;
    lbvalor_icms_proprio.Caption := 'valor_icms_proprio:';
    lbvalor_icms_proprio.Transparent := True;
    edvalor_icms_proprio.SetParentComponent(Self);
    edvalor_icms_proprio.Name := 'edvalor_icms_proprio';
    edvalor_icms_proprio.Left := 221;
    edvalor_icms_proprio.Top := 2295;
    edvalor_icms_proprio.Width := 200;
    edvalor_icms_proprio.Height := 21;
    edvalor_icms_proprio.Enabled := True;
    edvalor_icms_proprio.TabOrder := 84;
    edvalor_icms_proprio.Text := 'edvalor_icms_proprio';
    edvalor_icms_proprio.DataField := 'valor_icms_proprio';
    edvalor_icms_proprio.DataSource := DataSource;
    lbaliquota_icms_simples_nacional.SetParentComponent(Self);
    lbaliquota_icms_simples_nacional.Name := 'lbaliquota_icms_simples_nacional';
    lbaliquota_icms_simples_nacional.Left := 24;
    lbaliquota_icms_simples_nacional.Top := 2325;
    lbaliquota_icms_simples_nacional.Width := 14;
    lbaliquota_icms_simples_nacional.Height := 13;
    lbaliquota_icms_simples_nacional.Caption := 'aliquota_icms_simples_nacional:';
    lbaliquota_icms_simples_nacional.Transparent := True;
    edaliquota_icms_simples_nacional.SetParentComponent(Self);
    edaliquota_icms_simples_nacional.Name := 'edaliquota_icms_simples_nacional';
    edaliquota_icms_simples_nacional.Left := 221;
    edaliquota_icms_simples_nacional.Top := 2322;
    edaliquota_icms_simples_nacional.Width := 200;
    edaliquota_icms_simples_nacional.Height := 21;
    edaliquota_icms_simples_nacional.Enabled := True;
    edaliquota_icms_simples_nacional.TabOrder := 85;
    edaliquota_icms_simples_nacional.Text := 'edaliquota_icms_simples_nacional';
    edaliquota_icms_simples_nacional.DataField := 'aliquota_icms_simples_nacional';
    edaliquota_icms_simples_nacional.DataSource := DataSource;
    lbvalor_icms_simples_nacional.SetParentComponent(Self);
    lbvalor_icms_simples_nacional.Name := 'lbvalor_icms_simples_nacional';
    lbvalor_icms_simples_nacional.Left := 24;
    lbvalor_icms_simples_nacional.Top := 2352;
    lbvalor_icms_simples_nacional.Width := 14;
    lbvalor_icms_simples_nacional.Height := 13;
    lbvalor_icms_simples_nacional.Caption := 'valor_icms_simples_nacional:';
    lbvalor_icms_simples_nacional.Transparent := True;
    edvalor_icms_simples_nacional.SetParentComponent(Self);
    edvalor_icms_simples_nacional.Name := 'edvalor_icms_simples_nacional';
    edvalor_icms_simples_nacional.Left := 221;
    edvalor_icms_simples_nacional.Top := 2349;
    edvalor_icms_simples_nacional.Width := 200;
    edvalor_icms_simples_nacional.Height := 21;
    edvalor_icms_simples_nacional.Enabled := True;
    edvalor_icms_simples_nacional.TabOrder := 86;
    edvalor_icms_simples_nacional.Text := 'edvalor_icms_simples_nacional';
    edvalor_icms_simples_nacional.DataField := 'valor_icms_simples_nacional';
    edvalor_icms_simples_nacional.DataSource := DataSource;
    lbvalor_icms_desonerado.SetParentComponent(Self);
    lbvalor_icms_desonerado.Name := 'lbvalor_icms_desonerado';
    lbvalor_icms_desonerado.Left := 24;
    lbvalor_icms_desonerado.Top := 2379;
    lbvalor_icms_desonerado.Width := 14;
    lbvalor_icms_desonerado.Height := 13;
    lbvalor_icms_desonerado.Caption := 'valor_icms_desonerado:';
    lbvalor_icms_desonerado.Transparent := True;
    edvalor_icms_desonerado.SetParentComponent(Self);
    edvalor_icms_desonerado.Name := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.Left := 221;
    edvalor_icms_desonerado.Top := 2376;
    edvalor_icms_desonerado.Width := 200;
    edvalor_icms_desonerado.Height := 21;
    edvalor_icms_desonerado.Enabled := True;
    edvalor_icms_desonerado.TabOrder := 87;
    edvalor_icms_desonerado.Text := 'edvalor_icms_desonerado';
    edvalor_icms_desonerado.DataField := 'valor_icms_desonerado';
    edvalor_icms_desonerado.DataSource := DataSource;
    lbdesoneracao_icms_id.SetParentComponent(Self);
    lbdesoneracao_icms_id.Name := 'lbdesoneracao_icms_id';
    lbdesoneracao_icms_id.Left := 24;
    lbdesoneracao_icms_id.Top := 2406;
    lbdesoneracao_icms_id.Width := 14;
    lbdesoneracao_icms_id.Height := 13;
    lbdesoneracao_icms_id.Caption := 'desoneracao_icms_id:';
    lbdesoneracao_icms_id.Transparent := True;
    eddesoneracao_icms_id.SetParentComponent(Self);
    eddesoneracao_icms_id.Name := 'eddesoneracao_icms_id';
    eddesoneracao_icms_id.Left := 221;
    eddesoneracao_icms_id.Top := 2403;
    eddesoneracao_icms_id.Width := 200;
    eddesoneracao_icms_id.Height := 21;
    eddesoneracao_icms_id.Enabled := True;
    eddesoneracao_icms_id.TabOrder := 88;
    eddesoneracao_icms_id.Text := 'eddesoneracao_icms_id';
    eddesoneracao_icms_id.DataField := 'desoneracao_icms_id';
    eddesoneracao_icms_id.DataSource := DataSource;
    lbaliquota_ipi_devolvido.SetParentComponent(Self);
    lbaliquota_ipi_devolvido.Name := 'lbaliquota_ipi_devolvido';
    lbaliquota_ipi_devolvido.Left := 24;
    lbaliquota_ipi_devolvido.Top := 2433;
    lbaliquota_ipi_devolvido.Width := 14;
    lbaliquota_ipi_devolvido.Height := 13;
    lbaliquota_ipi_devolvido.Caption := 'aliquota_ipi_devolvido:';
    lbaliquota_ipi_devolvido.Transparent := True;
    edaliquota_ipi_devolvido.SetParentComponent(Self);
    edaliquota_ipi_devolvido.Name := 'edaliquota_ipi_devolvido';
    edaliquota_ipi_devolvido.Left := 221;
    edaliquota_ipi_devolvido.Top := 2430;
    edaliquota_ipi_devolvido.Width := 200;
    edaliquota_ipi_devolvido.Height := 21;
    edaliquota_ipi_devolvido.Enabled := True;
    edaliquota_ipi_devolvido.TabOrder := 89;
    edaliquota_ipi_devolvido.Text := 'edaliquota_ipi_devolvido';
    edaliquota_ipi_devolvido.DataField := 'aliquota_ipi_devolvido';
    edaliquota_ipi_devolvido.DataSource := DataSource;
    lbvalor_ipi_devolvido.SetParentComponent(Self);
    lbvalor_ipi_devolvido.Name := 'lbvalor_ipi_devolvido';
    lbvalor_ipi_devolvido.Left := 24;
    lbvalor_ipi_devolvido.Top := 2460;
    lbvalor_ipi_devolvido.Width := 14;
    lbvalor_ipi_devolvido.Height := 13;
    lbvalor_ipi_devolvido.Caption := 'valor_ipi_devolvido:';
    lbvalor_ipi_devolvido.Transparent := True;
    edvalor_ipi_devolvido.SetParentComponent(Self);
    edvalor_ipi_devolvido.Name := 'edvalor_ipi_devolvido';
    edvalor_ipi_devolvido.Left := 221;
    edvalor_ipi_devolvido.Top := 2457;
    edvalor_ipi_devolvido.Width := 200;
    edvalor_ipi_devolvido.Height := 21;
    edvalor_ipi_devolvido.Enabled := True;
    edvalor_ipi_devolvido.TabOrder := 90;
    edvalor_ipi_devolvido.Text := 'edvalor_ipi_devolvido';
    edvalor_ipi_devolvido.DataField := 'valor_ipi_devolvido';
    edvalor_ipi_devolvido.DataSource := DataSource;
    lbmotivo_devolucao_ipi.SetParentComponent(Self);
    lbmotivo_devolucao_ipi.Name := 'lbmotivo_devolucao_ipi';
    lbmotivo_devolucao_ipi.Left := 24;
    lbmotivo_devolucao_ipi.Top := 2487;
    lbmotivo_devolucao_ipi.Width := 14;
    lbmotivo_devolucao_ipi.Height := 13;
    lbmotivo_devolucao_ipi.Caption := 'motivo_devolucao_ipi:';
    lbmotivo_devolucao_ipi.Transparent := True;
    edmotivo_devolucao_ipi.SetParentComponent(Self);
    edmotivo_devolucao_ipi.Name := 'edmotivo_devolucao_ipi';
    edmotivo_devolucao_ipi.Left := 221;
    edmotivo_devolucao_ipi.Top := 2484;
    edmotivo_devolucao_ipi.Width := 200;
    edmotivo_devolucao_ipi.Height := 21;
    edmotivo_devolucao_ipi.Enabled := True;
    edmotivo_devolucao_ipi.TabOrder := 91;
    edmotivo_devolucao_ipi.Text := 'edmotivo_devolucao_ipi';
    edmotivo_devolucao_ipi.DataField := 'motivo_devolucao_ipi';
    edmotivo_devolucao_ipi.DataSource := DataSource;
    lbdesoneracao_icms_st_id.SetParentComponent(Self);
    lbdesoneracao_icms_st_id.Name := 'lbdesoneracao_icms_st_id';
    lbdesoneracao_icms_st_id.Left := 24;
    lbdesoneracao_icms_st_id.Top := 2514;
    lbdesoneracao_icms_st_id.Width := 14;
    lbdesoneracao_icms_st_id.Height := 13;
    lbdesoneracao_icms_st_id.Caption := 'desoneracao_icms_st_id:';
    lbdesoneracao_icms_st_id.Transparent := True;
    eddesoneracao_icms_st_id.SetParentComponent(Self);
    eddesoneracao_icms_st_id.Name := 'eddesoneracao_icms_st_id';
    eddesoneracao_icms_st_id.Left := 221;
    eddesoneracao_icms_st_id.Top := 2511;
    eddesoneracao_icms_st_id.Width := 200;
    eddesoneracao_icms_st_id.Height := 21;
    eddesoneracao_icms_st_id.Enabled := True;
    eddesoneracao_icms_st_id.TabOrder := 92;
    eddesoneracao_icms_st_id.Text := 'eddesoneracao_icms_st_id';
    eddesoneracao_icms_st_id.DataField := 'desoneracao_icms_st_id';
    eddesoneracao_icms_st_id.DataSource := DataSource;
    lbvalor_icms_st_desonerado.SetParentComponent(Self);
    lbvalor_icms_st_desonerado.Name := 'lbvalor_icms_st_desonerado';
    lbvalor_icms_st_desonerado.Left := 24;
    lbvalor_icms_st_desonerado.Top := 2541;
    lbvalor_icms_st_desonerado.Width := 14;
    lbvalor_icms_st_desonerado.Height := 13;
    lbvalor_icms_st_desonerado.Caption := 'valor_icms_st_desonerado:';
    lbvalor_icms_st_desonerado.Transparent := True;
    edvalor_icms_st_desonerado.SetParentComponent(Self);
    edvalor_icms_st_desonerado.Name := 'edvalor_icms_st_desonerado';
    edvalor_icms_st_desonerado.Left := 221;
    edvalor_icms_st_desonerado.Top := 2538;
    edvalor_icms_st_desonerado.Width := 200;
    edvalor_icms_st_desonerado.Height := 21;
    edvalor_icms_st_desonerado.Enabled := True;
    edvalor_icms_st_desonerado.TabOrder := 93;
    edvalor_icms_st_desonerado.Text := 'edvalor_icms_st_desonerado';
    edvalor_icms_st_desonerado.DataField := 'valor_icms_st_desonerado';
    edvalor_icms_st_desonerado.DataSource := DataSource;
    lbobservacoes_contribuinte_identificacao.SetParentComponent(Self);
    lbobservacoes_contribuinte_identificacao.Name := 'lbobservacoes_contribuinte_identificacao';
    lbobservacoes_contribuinte_identificacao.Left := 24;
    lbobservacoes_contribuinte_identificacao.Top := 2568;
    lbobservacoes_contribuinte_identificacao.Width := 14;
    lbobservacoes_contribuinte_identificacao.Height := 13;
    lbobservacoes_contribuinte_identificacao.Caption := 'observacoes_contribuinte_identificacao:';
    lbobservacoes_contribuinte_identificacao.Transparent := True;
    edobservacoes_contribuinte_identificacao.SetParentComponent(Self);
    edobservacoes_contribuinte_identificacao.Name := 'edobservacoes_contribuinte_identificacao';
    edobservacoes_contribuinte_identificacao.Left := 221;
    edobservacoes_contribuinte_identificacao.Top := 2565;
    edobservacoes_contribuinte_identificacao.Width := 200;
    edobservacoes_contribuinte_identificacao.Height := 21;
    edobservacoes_contribuinte_identificacao.Enabled := True;
    edobservacoes_contribuinte_identificacao.TabOrder := 94;
    edobservacoes_contribuinte_identificacao.Text := 'edobservacoes_contribuinte_identificacao';
    edobservacoes_contribuinte_identificacao.DataField := 'observacoes_contribuinte_identificacao';
    edobservacoes_contribuinte_identificacao.DataSource := DataSource;
    lbobservacoes_contribuinte.SetParentComponent(Self);
    lbobservacoes_contribuinte.Name := 'lbobservacoes_contribuinte';
    lbobservacoes_contribuinte.Left := 24;
    lbobservacoes_contribuinte.Top := 2595;
    lbobservacoes_contribuinte.Width := 14;
    lbobservacoes_contribuinte.Height := 13;
    lbobservacoes_contribuinte.Caption := 'observacoes_contribuinte:';
    lbobservacoes_contribuinte.Transparent := True;
    edobservacoes_contribuinte.SetParentComponent(Self);
    edobservacoes_contribuinte.Name := 'edobservacoes_contribuinte';
    edobservacoes_contribuinte.Left := 221;
    edobservacoes_contribuinte.Top := 2592;
    edobservacoes_contribuinte.Width := 200;
    edobservacoes_contribuinte.Height := 21;
    edobservacoes_contribuinte.Enabled := True;
    edobservacoes_contribuinte.TabOrder := 95;
    edobservacoes_contribuinte.Text := 'edobservacoes_contribuinte';
    edobservacoes_contribuinte.DataField := 'observacoes_contribuinte';
    edobservacoes_contribuinte.DataSource := DataSource;
    lbobservacoes_fisco_identificacao.SetParentComponent(Self);
    lbobservacoes_fisco_identificacao.Name := 'lbobservacoes_fisco_identificacao';
    lbobservacoes_fisco_identificacao.Left := 24;
    lbobservacoes_fisco_identificacao.Top := 2622;
    lbobservacoes_fisco_identificacao.Width := 14;
    lbobservacoes_fisco_identificacao.Height := 13;
    lbobservacoes_fisco_identificacao.Caption := 'observacoes_fisco_identificacao:';
    lbobservacoes_fisco_identificacao.Transparent := True;
    edobservacoes_fisco_identificacao.SetParentComponent(Self);
    edobservacoes_fisco_identificacao.Name := 'edobservacoes_fisco_identificacao';
    edobservacoes_fisco_identificacao.Left := 221;
    edobservacoes_fisco_identificacao.Top := 2619;
    edobservacoes_fisco_identificacao.Width := 200;
    edobservacoes_fisco_identificacao.Height := 21;
    edobservacoes_fisco_identificacao.Enabled := True;
    edobservacoes_fisco_identificacao.TabOrder := 96;
    edobservacoes_fisco_identificacao.Text := 'edobservacoes_fisco_identificacao';
    edobservacoes_fisco_identificacao.DataField := 'observacoes_fisco_identificacao';
    edobservacoes_fisco_identificacao.DataSource := DataSource;
    lbobservacoes_fisco.SetParentComponent(Self);
    lbobservacoes_fisco.Name := 'lbobservacoes_fisco';
    lbobservacoes_fisco.Left := 24;
    lbobservacoes_fisco.Top := 2649;
    lbobservacoes_fisco.Width := 14;
    lbobservacoes_fisco.Height := 13;
    lbobservacoes_fisco.Caption := 'observacoes_fisco:';
    lbobservacoes_fisco.Transparent := True;
    edobservacoes_fisco.SetParentComponent(Self);
    edobservacoes_fisco.Name := 'edobservacoes_fisco';
    edobservacoes_fisco.Left := 221;
    edobservacoes_fisco.Top := 2646;
    edobservacoes_fisco.Width := 200;
    edobservacoes_fisco.Height := 21;
    edobservacoes_fisco.Enabled := True;
    edobservacoes_fisco.TabOrder := 97;
    edobservacoes_fisco.Text := 'edobservacoes_fisco';
    edobservacoes_fisco.DataField := 'observacoes_fisco';
    edobservacoes_fisco.DataSource := DataSource;
    lbcodigo_produto_anvisa.SetParentComponent(Self);
    lbcodigo_produto_anvisa.Name := 'lbcodigo_produto_anvisa';
    lbcodigo_produto_anvisa.Left := 24;
    lbcodigo_produto_anvisa.Top := 2676;
    lbcodigo_produto_anvisa.Width := 14;
    lbcodigo_produto_anvisa.Height := 13;
    lbcodigo_produto_anvisa.Caption := 'codigo_produto_anvisa:';
    lbcodigo_produto_anvisa.Transparent := True;
    edcodigo_produto_anvisa.SetParentComponent(Self);
    edcodigo_produto_anvisa.Name := 'edcodigo_produto_anvisa';
    edcodigo_produto_anvisa.Left := 221;
    edcodigo_produto_anvisa.Top := 2673;
    edcodigo_produto_anvisa.Width := 200;
    edcodigo_produto_anvisa.Height := 21;
    edcodigo_produto_anvisa.Enabled := True;
    edcodigo_produto_anvisa.TabOrder := 98;
    edcodigo_produto_anvisa.Text := 'edcodigo_produto_anvisa';
    edcodigo_produto_anvisa.DataField := 'codigo_produto_anvisa';
    edcodigo_produto_anvisa.DataSource := DataSource;
    lbmotivo_isencao_anvisa.SetParentComponent(Self);
    lbmotivo_isencao_anvisa.Name := 'lbmotivo_isencao_anvisa';
    lbmotivo_isencao_anvisa.Left := 24;
    lbmotivo_isencao_anvisa.Top := 2703;
    lbmotivo_isencao_anvisa.Width := 14;
    lbmotivo_isencao_anvisa.Height := 13;
    lbmotivo_isencao_anvisa.Caption := 'motivo_isencao_anvisa:';
    lbmotivo_isencao_anvisa.Transparent := True;
    edmotivo_isencao_anvisa.SetParentComponent(Self);
    edmotivo_isencao_anvisa.Name := 'edmotivo_isencao_anvisa';
    edmotivo_isencao_anvisa.Left := 221;
    edmotivo_isencao_anvisa.Top := 2700;
    edmotivo_isencao_anvisa.Width := 200;
    edmotivo_isencao_anvisa.Height := 21;
    edmotivo_isencao_anvisa.Enabled := True;
    edmotivo_isencao_anvisa.TabOrder := 99;
    edmotivo_isencao_anvisa.Text := 'edmotivo_isencao_anvisa';
    edmotivo_isencao_anvisa.DataField := 'motivo_isencao_anvisa';
    edmotivo_isencao_anvisa.DataSource := DataSource;
    lbpreco_maximo_consumidor.SetParentComponent(Self);
    lbpreco_maximo_consumidor.Name := 'lbpreco_maximo_consumidor';
    lbpreco_maximo_consumidor.Left := 24;
    lbpreco_maximo_consumidor.Top := 2730;
    lbpreco_maximo_consumidor.Width := 14;
    lbpreco_maximo_consumidor.Height := 13;
    lbpreco_maximo_consumidor.Caption := 'preco_maximo_consumidor:';
    lbpreco_maximo_consumidor.Transparent := True;
    edpreco_maximo_consumidor.SetParentComponent(Self);
    edpreco_maximo_consumidor.Name := 'edpreco_maximo_consumidor';
    edpreco_maximo_consumidor.Left := 221;
    edpreco_maximo_consumidor.Top := 2727;
    edpreco_maximo_consumidor.Width := 200;
    edpreco_maximo_consumidor.Height := 21;
    edpreco_maximo_consumidor.Enabled := True;
    edpreco_maximo_consumidor.TabOrder := 100;
    edpreco_maximo_consumidor.Text := 'edpreco_maximo_consumidor';
    edpreco_maximo_consumidor.DataField := 'preco_maximo_consumidor';
    edpreco_maximo_consumidor.DataSource := DataSource;
    lbrastreabilidade_numero_lote.SetParentComponent(Self);
    lbrastreabilidade_numero_lote.Name := 'lbrastreabilidade_numero_lote';
    lbrastreabilidade_numero_lote.Left := 24;
    lbrastreabilidade_numero_lote.Top := 2757;
    lbrastreabilidade_numero_lote.Width := 14;
    lbrastreabilidade_numero_lote.Height := 13;
    lbrastreabilidade_numero_lote.Caption := 'rastreabilidade_numero_lote:';
    lbrastreabilidade_numero_lote.Transparent := True;
    edrastreabilidade_numero_lote.SetParentComponent(Self);
    edrastreabilidade_numero_lote.Name := 'edrastreabilidade_numero_lote';
    edrastreabilidade_numero_lote.Left := 221;
    edrastreabilidade_numero_lote.Top := 2754;
    edrastreabilidade_numero_lote.Width := 200;
    edrastreabilidade_numero_lote.Height := 21;
    edrastreabilidade_numero_lote.Enabled := True;
    edrastreabilidade_numero_lote.TabOrder := 101;
    edrastreabilidade_numero_lote.Text := 'edrastreabilidade_numero_lote';
    edrastreabilidade_numero_lote.DataField := 'rastreabilidade_numero_lote';
    edrastreabilidade_numero_lote.DataSource := DataSource;
    lbrastreabilidade_data_fabricacao.SetParentComponent(Self);
    lbrastreabilidade_data_fabricacao.Name := 'lbrastreabilidade_data_fabricacao';
    lbrastreabilidade_data_fabricacao.Left := 24;
    lbrastreabilidade_data_fabricacao.Top := 2784;
    lbrastreabilidade_data_fabricacao.Width := 14;
    lbrastreabilidade_data_fabricacao.Height := 13;
    lbrastreabilidade_data_fabricacao.Caption := 'rastreabilidade_data_fabricacao:';
    lbrastreabilidade_data_fabricacao.Transparent := True;
    edrastreabilidade_data_fabricacao.SetParentComponent(Self);
    edrastreabilidade_data_fabricacao.Name := 'edrastreabilidade_data_fabricacao';
    edrastreabilidade_data_fabricacao.Left := 221;
    edrastreabilidade_data_fabricacao.Top := 2781;
    edrastreabilidade_data_fabricacao.Width := 200;
    edrastreabilidade_data_fabricacao.Height := 21;
    edrastreabilidade_data_fabricacao.Enabled := True;
    edrastreabilidade_data_fabricacao.TabOrder := 102;
    edrastreabilidade_data_fabricacao.Text := 'edrastreabilidade_data_fabricacao';
    edrastreabilidade_data_fabricacao.DataField := 'rastreabilidade_data_fabricacao';
    edrastreabilidade_data_fabricacao.DataSource := DataSource;
    lbrastreabilidade_data_validade.SetParentComponent(Self);
    lbrastreabilidade_data_validade.Name := 'lbrastreabilidade_data_validade';
    lbrastreabilidade_data_validade.Left := 24;
    lbrastreabilidade_data_validade.Top := 2811;
    lbrastreabilidade_data_validade.Width := 14;
    lbrastreabilidade_data_validade.Height := 13;
    lbrastreabilidade_data_validade.Caption := 'rastreabilidade_data_validade:';
    lbrastreabilidade_data_validade.Transparent := True;
    edrastreabilidade_data_validade.SetParentComponent(Self);
    edrastreabilidade_data_validade.Name := 'edrastreabilidade_data_validade';
    edrastreabilidade_data_validade.Left := 221;
    edrastreabilidade_data_validade.Top := 2808;
    edrastreabilidade_data_validade.Width := 200;
    edrastreabilidade_data_validade.Height := 21;
    edrastreabilidade_data_validade.Enabled := True;
    edrastreabilidade_data_validade.TabOrder := 103;
    edrastreabilidade_data_validade.Text := 'edrastreabilidade_data_validade';
    edrastreabilidade_data_validade.DataField := 'rastreabilidade_data_validade';
    edrastreabilidade_data_validade.DataSource := DataSource;
    lbrastreabilidade_codigo_agregacao.SetParentComponent(Self);
    lbrastreabilidade_codigo_agregacao.Name := 'lbrastreabilidade_codigo_agregacao';
    lbrastreabilidade_codigo_agregacao.Left := 24;
    lbrastreabilidade_codigo_agregacao.Top := 2838;
    lbrastreabilidade_codigo_agregacao.Width := 14;
    lbrastreabilidade_codigo_agregacao.Height := 13;
    lbrastreabilidade_codigo_agregacao.Caption := 'rastreabilidade_codigo_agregacao:';
    lbrastreabilidade_codigo_agregacao.Transparent := True;
    edrastreabilidade_codigo_agregacao.SetParentComponent(Self);
    edrastreabilidade_codigo_agregacao.Name := 'edrastreabilidade_codigo_agregacao';
    edrastreabilidade_codigo_agregacao.Left := 221;
    edrastreabilidade_codigo_agregacao.Top := 2835;
    edrastreabilidade_codigo_agregacao.Width := 200;
    edrastreabilidade_codigo_agregacao.Height := 21;
    edrastreabilidade_codigo_agregacao.Enabled := True;
    edrastreabilidade_codigo_agregacao.TabOrder := 104;
    edrastreabilidade_codigo_agregacao.Text := 'edrastreabilidade_codigo_agregacao';
    edrastreabilidade_codigo_agregacao.DataField := 'rastreabilidade_codigo_agregacao';
    edrastreabilidade_codigo_agregacao.DataSource := DataSource;
    lbvalor_base_calculo_fcp_icms.SetParentComponent(Self);
    lbvalor_base_calculo_fcp_icms.Name := 'lbvalor_base_calculo_fcp_icms';
    lbvalor_base_calculo_fcp_icms.Left := 24;
    lbvalor_base_calculo_fcp_icms.Top := 2865;
    lbvalor_base_calculo_fcp_icms.Width := 14;
    lbvalor_base_calculo_fcp_icms.Height := 13;
    lbvalor_base_calculo_fcp_icms.Caption := 'valor_base_calculo_fcp_icms:';
    lbvalor_base_calculo_fcp_icms.Transparent := True;
    edvalor_base_calculo_fcp_icms.SetParentComponent(Self);
    edvalor_base_calculo_fcp_icms.Name := 'edvalor_base_calculo_fcp_icms';
    edvalor_base_calculo_fcp_icms.Left := 221;
    edvalor_base_calculo_fcp_icms.Top := 2862;
    edvalor_base_calculo_fcp_icms.Width := 200;
    edvalor_base_calculo_fcp_icms.Height := 21;
    edvalor_base_calculo_fcp_icms.Enabled := True;
    edvalor_base_calculo_fcp_icms.TabOrder := 105;
    edvalor_base_calculo_fcp_icms.Text := 'edvalor_base_calculo_fcp_icms';
    edvalor_base_calculo_fcp_icms.DataField := 'valor_base_calculo_fcp_icms';
    edvalor_base_calculo_fcp_icms.DataSource := DataSource;
    lbaliquota_fcp_icms.SetParentComponent(Self);
    lbaliquota_fcp_icms.Name := 'lbaliquota_fcp_icms';
    lbaliquota_fcp_icms.Left := 24;
    lbaliquota_fcp_icms.Top := 2892;
    lbaliquota_fcp_icms.Width := 14;
    lbaliquota_fcp_icms.Height := 13;
    lbaliquota_fcp_icms.Caption := 'aliquota_fcp_icms:';
    lbaliquota_fcp_icms.Transparent := True;
    edaliquota_fcp_icms.SetParentComponent(Self);
    edaliquota_fcp_icms.Name := 'edaliquota_fcp_icms';
    edaliquota_fcp_icms.Left := 221;
    edaliquota_fcp_icms.Top := 2889;
    edaliquota_fcp_icms.Width := 200;
    edaliquota_fcp_icms.Height := 21;
    edaliquota_fcp_icms.Enabled := True;
    edaliquota_fcp_icms.TabOrder := 106;
    edaliquota_fcp_icms.Text := 'edaliquota_fcp_icms';
    edaliquota_fcp_icms.DataField := 'aliquota_fcp_icms';
    edaliquota_fcp_icms.DataSource := DataSource;
    lbvalor_fcp_icms.SetParentComponent(Self);
    lbvalor_fcp_icms.Name := 'lbvalor_fcp_icms';
    lbvalor_fcp_icms.Left := 24;
    lbvalor_fcp_icms.Top := 2919;
    lbvalor_fcp_icms.Width := 14;
    lbvalor_fcp_icms.Height := 13;
    lbvalor_fcp_icms.Caption := 'valor_fcp_icms:';
    lbvalor_fcp_icms.Transparent := True;
    edvalor_fcp_icms.SetParentComponent(Self);
    edvalor_fcp_icms.Name := 'edvalor_fcp_icms';
    edvalor_fcp_icms.Left := 221;
    edvalor_fcp_icms.Top := 2916;
    edvalor_fcp_icms.Width := 200;
    edvalor_fcp_icms.Height := 21;
    edvalor_fcp_icms.Enabled := True;
    edvalor_fcp_icms.TabOrder := 107;
    edvalor_fcp_icms.Text := 'edvalor_fcp_icms';
    edvalor_fcp_icms.DataField := 'valor_fcp_icms';
    edvalor_fcp_icms.DataSource := DataSource;
    lbvalor_base_calculo_fcp_st.SetParentComponent(Self);
    lbvalor_base_calculo_fcp_st.Name := 'lbvalor_base_calculo_fcp_st';
    lbvalor_base_calculo_fcp_st.Left := 24;
    lbvalor_base_calculo_fcp_st.Top := 2946;
    lbvalor_base_calculo_fcp_st.Width := 14;
    lbvalor_base_calculo_fcp_st.Height := 13;
    lbvalor_base_calculo_fcp_st.Caption := 'valor_base_calculo_fcp_st:';
    lbvalor_base_calculo_fcp_st.Transparent := True;
    edvalor_base_calculo_fcp_st.SetParentComponent(Self);
    edvalor_base_calculo_fcp_st.Name := 'edvalor_base_calculo_fcp_st';
    edvalor_base_calculo_fcp_st.Left := 221;
    edvalor_base_calculo_fcp_st.Top := 2943;
    edvalor_base_calculo_fcp_st.Width := 200;
    edvalor_base_calculo_fcp_st.Height := 21;
    edvalor_base_calculo_fcp_st.Enabled := True;
    edvalor_base_calculo_fcp_st.TabOrder := 108;
    edvalor_base_calculo_fcp_st.Text := 'edvalor_base_calculo_fcp_st';
    edvalor_base_calculo_fcp_st.DataField := 'valor_base_calculo_fcp_st';
    edvalor_base_calculo_fcp_st.DataSource := DataSource;
    lbaliquota_fcp_st.SetParentComponent(Self);
    lbaliquota_fcp_st.Name := 'lbaliquota_fcp_st';
    lbaliquota_fcp_st.Left := 24;
    lbaliquota_fcp_st.Top := 2973;
    lbaliquota_fcp_st.Width := 14;
    lbaliquota_fcp_st.Height := 13;
    lbaliquota_fcp_st.Caption := 'aliquota_fcp_st:';
    lbaliquota_fcp_st.Transparent := True;
    edaliquota_fcp_st.SetParentComponent(Self);
    edaliquota_fcp_st.Name := 'edaliquota_fcp_st';
    edaliquota_fcp_st.Left := 221;
    edaliquota_fcp_st.Top := 2970;
    edaliquota_fcp_st.Width := 200;
    edaliquota_fcp_st.Height := 21;
    edaliquota_fcp_st.Enabled := True;
    edaliquota_fcp_st.TabOrder := 109;
    edaliquota_fcp_st.Text := 'edaliquota_fcp_st';
    edaliquota_fcp_st.DataField := 'aliquota_fcp_st';
    edaliquota_fcp_st.DataSource := DataSource;
    lbvalor_fcp_st.SetParentComponent(Self);
    lbvalor_fcp_st.Name := 'lbvalor_fcp_st';
    lbvalor_fcp_st.Left := 24;
    lbvalor_fcp_st.Top := 3000;
    lbvalor_fcp_st.Width := 14;
    lbvalor_fcp_st.Height := 13;
    lbvalor_fcp_st.Caption := 'valor_fcp_st:';
    lbvalor_fcp_st.Transparent := True;
    edvalor_fcp_st.SetParentComponent(Self);
    edvalor_fcp_st.Name := 'edvalor_fcp_st';
    edvalor_fcp_st.Left := 221;
    edvalor_fcp_st.Top := 2997;
    edvalor_fcp_st.Width := 200;
    edvalor_fcp_st.Height := 21;
    edvalor_fcp_st.Enabled := True;
    edvalor_fcp_st.TabOrder := 110;
    edvalor_fcp_st.Text := 'edvalor_fcp_st';
    edvalor_fcp_st.DataField := 'valor_fcp_st';
    edvalor_fcp_st.DataSource := DataSource;
    lbvalor_base_calculo_fcp_retida.SetParentComponent(Self);
    lbvalor_base_calculo_fcp_retida.Name := 'lbvalor_base_calculo_fcp_retida';
    lbvalor_base_calculo_fcp_retida.Left := 24;
    lbvalor_base_calculo_fcp_retida.Top := 3027;
    lbvalor_base_calculo_fcp_retida.Width := 14;
    lbvalor_base_calculo_fcp_retida.Height := 13;
    lbvalor_base_calculo_fcp_retida.Caption := 'valor_base_calculo_fcp_retida:';
    lbvalor_base_calculo_fcp_retida.Transparent := True;
    edvalor_base_calculo_fcp_retida.SetParentComponent(Self);
    edvalor_base_calculo_fcp_retida.Name := 'edvalor_base_calculo_fcp_retida';
    edvalor_base_calculo_fcp_retida.Left := 221;
    edvalor_base_calculo_fcp_retida.Top := 3024;
    edvalor_base_calculo_fcp_retida.Width := 200;
    edvalor_base_calculo_fcp_retida.Height := 21;
    edvalor_base_calculo_fcp_retida.Enabled := True;
    edvalor_base_calculo_fcp_retida.TabOrder := 111;
    edvalor_base_calculo_fcp_retida.Text := 'edvalor_base_calculo_fcp_retida';
    edvalor_base_calculo_fcp_retida.DataField := 'valor_base_calculo_fcp_retida';
    edvalor_base_calculo_fcp_retida.DataSource := DataSource;
    lbaliquota_fcp_retida.SetParentComponent(Self);
    lbaliquota_fcp_retida.Name := 'lbaliquota_fcp_retida';
    lbaliquota_fcp_retida.Left := 24;
    lbaliquota_fcp_retida.Top := 3054;
    lbaliquota_fcp_retida.Width := 14;
    lbaliquota_fcp_retida.Height := 13;
    lbaliquota_fcp_retida.Caption := 'aliquota_fcp_retida:';
    lbaliquota_fcp_retida.Transparent := True;
    edaliquota_fcp_retida.SetParentComponent(Self);
    edaliquota_fcp_retida.Name := 'edaliquota_fcp_retida';
    edaliquota_fcp_retida.Left := 221;
    edaliquota_fcp_retida.Top := 3051;
    edaliquota_fcp_retida.Width := 200;
    edaliquota_fcp_retida.Height := 21;
    edaliquota_fcp_retida.Enabled := True;
    edaliquota_fcp_retida.TabOrder := 112;
    edaliquota_fcp_retida.Text := 'edaliquota_fcp_retida';
    edaliquota_fcp_retida.DataField := 'aliquota_fcp_retida';
    edaliquota_fcp_retida.DataSource := DataSource;
    lbvalor_fcp_retida.SetParentComponent(Self);
    lbvalor_fcp_retida.Name := 'lbvalor_fcp_retida';
    lbvalor_fcp_retida.Left := 24;
    lbvalor_fcp_retida.Top := 3081;
    lbvalor_fcp_retida.Width := 14;
    lbvalor_fcp_retida.Height := 13;
    lbvalor_fcp_retida.Caption := 'valor_fcp_retida:';
    lbvalor_fcp_retida.Transparent := True;
    edvalor_fcp_retida.SetParentComponent(Self);
    edvalor_fcp_retida.Name := 'edvalor_fcp_retida';
    edvalor_fcp_retida.Left := 221;
    edvalor_fcp_retida.Top := 3078;
    edvalor_fcp_retida.Width := 200;
    edvalor_fcp_retida.Height := 21;
    edvalor_fcp_retida.Enabled := True;
    edvalor_fcp_retida.TabOrder := 113;
    edvalor_fcp_retida.Text := 'edvalor_fcp_retida';
    edvalor_fcp_retida.DataField := 'valor_fcp_retida';
    edvalor_fcp_retida.DataSource := DataSource;
    lbinformacoes_adicionais.SetParentComponent(Self);
    lbinformacoes_adicionais.Name := 'lbinformacoes_adicionais';
    lbinformacoes_adicionais.Left := 24;
    lbinformacoes_adicionais.Top := 3108;
    lbinformacoes_adicionais.Width := 14;
    lbinformacoes_adicionais.Height := 13;
    lbinformacoes_adicionais.Caption := 'informacoes_adicionais:';
    lbinformacoes_adicionais.Transparent := True;
    edinformacoes_adicionais.SetParentComponent(Self);
    edinformacoes_adicionais.Name := 'edinformacoes_adicionais';
    edinformacoes_adicionais.Left := 221;
    edinformacoes_adicionais.Top := 3105;
    edinformacoes_adicionais.Width := 200;
    edinformacoes_adicionais.Height := 21;
    edinformacoes_adicionais.Enabled := True;
    edinformacoes_adicionais.TabOrder := 114;
    edinformacoes_adicionais.Text := 'edinformacoes_adicionais';
    edinformacoes_adicionais.DataField := 'informacoes_adicionais';
    edinformacoes_adicionais.DataSource := DataSource;
    lbquantidade_monofasica.SetParentComponent(Self);
    lbquantidade_monofasica.Name := 'lbquantidade_monofasica';
    lbquantidade_monofasica.Left := 24;
    lbquantidade_monofasica.Top := 3135;
    lbquantidade_monofasica.Width := 14;
    lbquantidade_monofasica.Height := 13;
    lbquantidade_monofasica.Caption := 'quantidade_monofasica:';
    lbquantidade_monofasica.Transparent := True;
    edquantidade_monofasica.SetParentComponent(Self);
    edquantidade_monofasica.Name := 'edquantidade_monofasica';
    edquantidade_monofasica.Left := 221;
    edquantidade_monofasica.Top := 3132;
    edquantidade_monofasica.Width := 200;
    edquantidade_monofasica.Height := 21;
    edquantidade_monofasica.Enabled := True;
    edquantidade_monofasica.TabOrder := 115;
    edquantidade_monofasica.Text := 'edquantidade_monofasica';
    edquantidade_monofasica.DataField := 'quantidade_monofasica';
    edquantidade_monofasica.DataSource := DataSource;
    lbaliquota_ad_rem.SetParentComponent(Self);
    lbaliquota_ad_rem.Name := 'lbaliquota_ad_rem';
    lbaliquota_ad_rem.Left := 24;
    lbaliquota_ad_rem.Top := 3162;
    lbaliquota_ad_rem.Width := 14;
    lbaliquota_ad_rem.Height := 13;
    lbaliquota_ad_rem.Caption := 'aliquota_ad_rem:';
    lbaliquota_ad_rem.Transparent := True;
    edaliquota_ad_rem.SetParentComponent(Self);
    edaliquota_ad_rem.Name := 'edaliquota_ad_rem';
    edaliquota_ad_rem.Left := 221;
    edaliquota_ad_rem.Top := 3159;
    edaliquota_ad_rem.Width := 200;
    edaliquota_ad_rem.Height := 21;
    edaliquota_ad_rem.Enabled := True;
    edaliquota_ad_rem.TabOrder := 116;
    edaliquota_ad_rem.Text := 'edaliquota_ad_rem';
    edaliquota_ad_rem.DataField := 'aliquota_ad_rem';
    edaliquota_ad_rem.DataSource := DataSource;
    lbvalor_icms_monofasico.SetParentComponent(Self);
    lbvalor_icms_monofasico.Name := 'lbvalor_icms_monofasico';
    lbvalor_icms_monofasico.Left := 24;
    lbvalor_icms_monofasico.Top := 3189;
    lbvalor_icms_monofasico.Width := 14;
    lbvalor_icms_monofasico.Height := 13;
    lbvalor_icms_monofasico.Caption := 'valor_icms_monofasico:';
    lbvalor_icms_monofasico.Transparent := True;
    edvalor_icms_monofasico.SetParentComponent(Self);
    edvalor_icms_monofasico.Name := 'edvalor_icms_monofasico';
    edvalor_icms_monofasico.Left := 221;
    edvalor_icms_monofasico.Top := 3186;
    edvalor_icms_monofasico.Width := 200;
    edvalor_icms_monofasico.Height := 21;
    edvalor_icms_monofasico.Enabled := True;
    edvalor_icms_monofasico.TabOrder := 117;
    edvalor_icms_monofasico.Text := 'edvalor_icms_monofasico';
    edvalor_icms_monofasico.DataField := 'valor_icms_monofasico';
    edvalor_icms_monofasico.DataSource := DataSource;
    lbquantidade_monofasica_retida.SetParentComponent(Self);
    lbquantidade_monofasica_retida.Name := 'lbquantidade_monofasica_retida';
    lbquantidade_monofasica_retida.Left := 24;
    lbquantidade_monofasica_retida.Top := 3216;
    lbquantidade_monofasica_retida.Width := 14;
    lbquantidade_monofasica_retida.Height := 13;
    lbquantidade_monofasica_retida.Caption := 'quantidade_monofasica_retida:';
    lbquantidade_monofasica_retida.Transparent := True;
    edquantidade_monofasica_retida.SetParentComponent(Self);
    edquantidade_monofasica_retida.Name := 'edquantidade_monofasica_retida';
    edquantidade_monofasica_retida.Left := 221;
    edquantidade_monofasica_retida.Top := 3213;
    edquantidade_monofasica_retida.Width := 200;
    edquantidade_monofasica_retida.Height := 21;
    edquantidade_monofasica_retida.Enabled := True;
    edquantidade_monofasica_retida.TabOrder := 118;
    edquantidade_monofasica_retida.Text := 'edquantidade_monofasica_retida';
    edquantidade_monofasica_retida.DataField := 'quantidade_monofasica_retida';
    edquantidade_monofasica_retida.DataSource := DataSource;
    lbaliquota_ad_rem_retida.SetParentComponent(Self);
    lbaliquota_ad_rem_retida.Name := 'lbaliquota_ad_rem_retida';
    lbaliquota_ad_rem_retida.Left := 24;
    lbaliquota_ad_rem_retida.Top := 3243;
    lbaliquota_ad_rem_retida.Width := 14;
    lbaliquota_ad_rem_retida.Height := 13;
    lbaliquota_ad_rem_retida.Caption := 'aliquota_ad_rem_retida:';
    lbaliquota_ad_rem_retida.Transparent := True;
    edaliquota_ad_rem_retida.SetParentComponent(Self);
    edaliquota_ad_rem_retida.Name := 'edaliquota_ad_rem_retida';
    edaliquota_ad_rem_retida.Left := 221;
    edaliquota_ad_rem_retida.Top := 3240;
    edaliquota_ad_rem_retida.Width := 200;
    edaliquota_ad_rem_retida.Height := 21;
    edaliquota_ad_rem_retida.Enabled := True;
    edaliquota_ad_rem_retida.TabOrder := 119;
    edaliquota_ad_rem_retida.Text := 'edaliquota_ad_rem_retida';
    edaliquota_ad_rem_retida.DataField := 'aliquota_ad_rem_retida';
    edaliquota_ad_rem_retida.DataSource := DataSource;
    lbvalor_icms_monofasico_retido.SetParentComponent(Self);
    lbvalor_icms_monofasico_retido.Name := 'lbvalor_icms_monofasico_retido';
    lbvalor_icms_monofasico_retido.Left := 24;
    lbvalor_icms_monofasico_retido.Top := 3270;
    lbvalor_icms_monofasico_retido.Width := 14;
    lbvalor_icms_monofasico_retido.Height := 13;
    lbvalor_icms_monofasico_retido.Caption := 'valor_icms_monofasico_retido:';
    lbvalor_icms_monofasico_retido.Transparent := True;
    edvalor_icms_monofasico_retido.SetParentComponent(Self);
    edvalor_icms_monofasico_retido.Name := 'edvalor_icms_monofasico_retido';
    edvalor_icms_monofasico_retido.Left := 221;
    edvalor_icms_monofasico_retido.Top := 3267;
    edvalor_icms_monofasico_retido.Width := 200;
    edvalor_icms_monofasico_retido.Height := 21;
    edvalor_icms_monofasico_retido.Enabled := True;
    edvalor_icms_monofasico_retido.TabOrder := 120;
    edvalor_icms_monofasico_retido.Text := 'edvalor_icms_monofasico_retido';
    edvalor_icms_monofasico_retido.DataField := 'valor_icms_monofasico_retido';
    edvalor_icms_monofasico_retido.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 3297;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 3294;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 121;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 3324;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 3321;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 122;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 3351;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 3348;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 123;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 3378;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 3375;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 124;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 3405;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 3402;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 125;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Itens_SaidaDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Itens_SaidaDataset.SetParentComponent(Self);
    Itens_SaidaDataset.Name := 'Itens_SaidaDataset';
    Itens_SaidaDataset.AfterApplyUpdates := Itens_SaidaDatasetAfterApplyUpdates;
    Itens_SaidaDataset.EntitySetName := 'Itens_Saida';
    Itens_SaidaDataset.Connection := DMConnection.ApiConnection;
    Itens_SaidaDataset.Left := 176;
    Itens_SaidaDataset.Top := 8;
    Itens_SaidaDatasetid.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetid.Name := 'Itens_SaidaDatasetid';
    Itens_SaidaDatasetid.FieldName := 'id';
    Itens_SaidaDatasetid.Required := True;
    Itens_SaidaDatasetaliado_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliado_id.Name := 'Itens_SaidaDatasetaliado_id';
    Itens_SaidaDatasetaliado_id.FieldName := 'aliado_id';
    Itens_SaidaDatasetaliado_id.Required := True;
    Itens_SaidaDatasetdata_base_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetdata_base_id.Name := 'Itens_SaidaDatasetdata_base_id';
    Itens_SaidaDatasetdata_base_id.FieldName := 'data_base_id';
    Itens_SaidaDatasetdata_base_id.Required := True;
    Itens_SaidaDatasetvenda_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvenda_id.Name := 'Itens_SaidaDatasetvenda_id';
    Itens_SaidaDatasetvenda_id.FieldName := 'venda_id';
    Itens_SaidaDatasetvenda_id.Required := True;
    Itens_SaidaDatasetproduto_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_id.Name := 'Itens_SaidaDatasetproduto_id';
    Itens_SaidaDatasetproduto_id.FieldName := 'produto_id';
    Itens_SaidaDatasetproduto_id.Required := True;
    Itens_SaidaDatasetunidade_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetunidade_id.Name := 'Itens_SaidaDatasetunidade_id';
    Itens_SaidaDatasetunidade_id.FieldName := 'unidade_id';
    Itens_SaidaDatasetunidade_id.Required := False;
    Itens_SaidaDatasetitem.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem.Name := 'Itens_SaidaDatasetitem';
    Itens_SaidaDatasetitem.FieldName := 'item';
    Itens_SaidaDatasetitem.Required := False;
    Itens_SaidaDatasetcfop_cfop.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcfop_cfop.Name := 'Itens_SaidaDatasetcfop_cfop';
    Itens_SaidaDatasetcfop_cfop.FieldName := 'cfop_cfop';
    Itens_SaidaDatasetcfop_cfop.Required := True;
    Itens_SaidaDatasetcfop_cfop.Size := 255;
    Itens_SaidaDatasetquantidade.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade.Name := 'Itens_SaidaDatasetquantidade';
    Itens_SaidaDatasetquantidade.FieldName := 'quantidade';
    Itens_SaidaDatasetquantidade.Required := False;
    Itens_SaidaDatasetproduto_preco.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_preco.Name := 'Itens_SaidaDatasetproduto_preco';
    Itens_SaidaDatasetproduto_preco.FieldName := 'produto_preco';
    Itens_SaidaDatasetproduto_preco.Required := False;
    Itens_SaidaDatasetmargem_acrescimo.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmargem_acrescimo.Name := 'Itens_SaidaDatasetmargem_acrescimo';
    Itens_SaidaDatasetmargem_acrescimo.FieldName := 'margem_acrescimo';
    Itens_SaidaDatasetmargem_acrescimo.Required := False;
    Itens_SaidaDatasetvalor_acrescimo.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_acrescimo.Name := 'Itens_SaidaDatasetvalor_acrescimo';
    Itens_SaidaDatasetvalor_acrescimo.FieldName := 'valor_acrescimo';
    Itens_SaidaDatasetvalor_acrescimo.Required := False;
    Itens_SaidaDatasetmargem_desconto.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmargem_desconto.Name := 'Itens_SaidaDatasetmargem_desconto';
    Itens_SaidaDatasetmargem_desconto.FieldName := 'margem_desconto';
    Itens_SaidaDatasetmargem_desconto.Required := False;
    Itens_SaidaDatasetvalor_desconto.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_desconto.Name := 'Itens_SaidaDatasetvalor_desconto';
    Itens_SaidaDatasetvalor_desconto.FieldName := 'valor_desconto';
    Itens_SaidaDatasetvalor_desconto.Required := False;
    Itens_SaidaDatasetvalor_total.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_total.Name := 'Itens_SaidaDatasetvalor_total';
    Itens_SaidaDatasetvalor_total.FieldName := 'valor_total';
    Itens_SaidaDatasetvalor_total.Required := True;
    Itens_SaidaDatasetaliquota_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms.Name := 'Itens_SaidaDatasetaliquota_icms';
    Itens_SaidaDatasetaliquota_icms.FieldName := 'aliquota_icms';
    Itens_SaidaDatasetaliquota_icms.Required := False;
    Itens_SaidaDatasetvalor_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms.Name := 'Itens_SaidaDatasetvalor_icms';
    Itens_SaidaDatasetvalor_icms.FieldName := 'valor_icms';
    Itens_SaidaDatasetvalor_icms.Required := False;
    Itens_SaidaDatasetaliquota_icms_red.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_red.Name := 'Itens_SaidaDatasetaliquota_icms_red';
    Itens_SaidaDatasetaliquota_icms_red.FieldName := 'aliquota_icms_red';
    Itens_SaidaDatasetaliquota_icms_red.Required := False;
    Itens_SaidaDatasetvalor_icms_red.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_red.Name := 'Itens_SaidaDatasetvalor_icms_red';
    Itens_SaidaDatasetvalor_icms_red.FieldName := 'valor_icms_red';
    Itens_SaidaDatasetvalor_icms_red.Required := False;
    Itens_SaidaDatasetaliquota_icms_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_st.Name := 'Itens_SaidaDatasetaliquota_icms_st';
    Itens_SaidaDatasetaliquota_icms_st.FieldName := 'aliquota_icms_st';
    Itens_SaidaDatasetaliquota_icms_st.Required := False;
    Itens_SaidaDatasetvalor_icms_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_st.Name := 'Itens_SaidaDatasetvalor_icms_st';
    Itens_SaidaDatasetvalor_icms_st.FieldName := 'valor_icms_st';
    Itens_SaidaDatasetvalor_icms_st.Required := False;
    Itens_SaidaDatasetaliquota_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ipi.Name := 'Itens_SaidaDatasetaliquota_ipi';
    Itens_SaidaDatasetaliquota_ipi.FieldName := 'aliquota_ipi';
    Itens_SaidaDatasetaliquota_ipi.Required := False;
    Itens_SaidaDatasetvalor_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_ipi.Name := 'Itens_SaidaDatasetvalor_ipi';
    Itens_SaidaDatasetvalor_ipi.FieldName := 'valor_ipi';
    Itens_SaidaDatasetvalor_ipi.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_icms.Name := 'Itens_SaidaDatasetvalor_base_calculo_icms';
    Itens_SaidaDatasetvalor_base_calculo_icms.FieldName := 'valor_base_calculo_icms';
    Itens_SaidaDatasetvalor_base_calculo_icms.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_st.Name := 'Itens_SaidaDatasetvalor_base_calculo_st';
    Itens_SaidaDatasetvalor_base_calculo_st.FieldName := 'valor_base_calculo_st';
    Itens_SaidaDatasetvalor_base_calculo_st.Required := False;
    Itens_SaidaDatasetcst_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_id.Name := 'Itens_SaidaDatasetcst_id';
    Itens_SaidaDatasetcst_id.FieldName := 'cst_id';
    Itens_SaidaDatasetcst_id.Required := False;
    Itens_SaidaDatasetcst_id.Size := 255;
    Itens_SaidaDatasetvalor_frete.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_frete.Name := 'Itens_SaidaDatasetvalor_frete';
    Itens_SaidaDatasetvalor_frete.FieldName := 'valor_frete';
    Itens_SaidaDatasetvalor_frete.Required := False;
    Itens_SaidaDatasetvalor_seguro.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_seguro.Name := 'Itens_SaidaDatasetvalor_seguro';
    Itens_SaidaDatasetvalor_seguro.FieldName := 'valor_seguro';
    Itens_SaidaDatasetvalor_seguro.Required := False;
    Itens_SaidaDatasetvalor_despesas_acessorias.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_despesas_acessorias.Name := 'Itens_SaidaDatasetvalor_despesas_acessorias';
    Itens_SaidaDatasetvalor_despesas_acessorias.FieldName := 'valor_despesas_acessorias';
    Itens_SaidaDatasetvalor_despesas_acessorias.Required := False;
    Itens_SaidaDatasetvalor_outras.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_outras.Name := 'Itens_SaidaDatasetvalor_outras';
    Itens_SaidaDatasetvalor_outras.FieldName := 'valor_outras';
    Itens_SaidaDatasetvalor_outras.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_ipi.Name := 'Itens_SaidaDatasetvalor_base_calculo_ipi';
    Itens_SaidaDatasetvalor_base_calculo_ipi.FieldName := 'valor_base_calculo_ipi';
    Itens_SaidaDatasetvalor_base_calculo_ipi.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_pis.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_pis.Name := 'Itens_SaidaDatasetvalor_base_calculo_pis';
    Itens_SaidaDatasetvalor_base_calculo_pis.FieldName := 'valor_base_calculo_pis';
    Itens_SaidaDatasetvalor_base_calculo_pis.Required := False;
    Itens_SaidaDatasetvalor_pis.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_pis.Name := 'Itens_SaidaDatasetvalor_pis';
    Itens_SaidaDatasetvalor_pis.FieldName := 'valor_pis';
    Itens_SaidaDatasetvalor_pis.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_cofins.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_cofins.Name := 'Itens_SaidaDatasetvalor_base_calculo_cofins';
    Itens_SaidaDatasetvalor_base_calculo_cofins.FieldName := 'valor_base_calculo_cofins';
    Itens_SaidaDatasetvalor_base_calculo_cofins.Required := False;
    Itens_SaidaDatasetvalor_cofins.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_cofins.Name := 'Itens_SaidaDatasetvalor_cofins';
    Itens_SaidaDatasetvalor_cofins.FieldName := 'valor_cofins';
    Itens_SaidaDatasetvalor_cofins.Required := False;
    Itens_SaidaDatasetquantidade_selo_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_selo_ipi.Name := 'Itens_SaidaDatasetquantidade_selo_ipi';
    Itens_SaidaDatasetquantidade_selo_ipi.FieldName := 'quantidade_selo_ipi';
    Itens_SaidaDatasetquantidade_selo_ipi.Required := False;
    Itens_SaidaDatasetcst_ipi_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_ipi_id.Name := 'Itens_SaidaDatasetcst_ipi_id';
    Itens_SaidaDatasetcst_ipi_id.FieldName := 'cst_ipi_id';
    Itens_SaidaDatasetcst_ipi_id.Required := False;
    Itens_SaidaDatasetcst_ipi_id.Size := 255;
    Itens_SaidaDatasetcsosn_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcsosn_id.Name := 'Itens_SaidaDatasetcsosn_id';
    Itens_SaidaDatasetcsosn_id.FieldName := 'csosn_id';
    Itens_SaidaDatasetcsosn_id.Required := False;
    Itens_SaidaDatasetcsosn_id.Size := 255;
    Itens_SaidaDatasetvalor_ipi_unitario.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_ipi_unitario.Name := 'Itens_SaidaDatasetvalor_ipi_unitario';
    Itens_SaidaDatasetvalor_ipi_unitario.FieldName := 'valor_ipi_unitario';
    Itens_SaidaDatasetvalor_ipi_unitario.Required := False;
    Itens_SaidaDatasetaliquota_pis.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_pis.Name := 'Itens_SaidaDatasetaliquota_pis';
    Itens_SaidaDatasetaliquota_pis.FieldName := 'aliquota_pis';
    Itens_SaidaDatasetaliquota_pis.Required := False;
    Itens_SaidaDatasetaliquota_cofins.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_cofins.Name := 'Itens_SaidaDatasetaliquota_cofins';
    Itens_SaidaDatasetaliquota_cofins.FieldName := 'aliquota_cofins';
    Itens_SaidaDatasetaliquota_cofins.Required := False;
    Itens_SaidaDatasetcst_pis_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_pis_id.Name := 'Itens_SaidaDatasetcst_pis_id';
    Itens_SaidaDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Itens_SaidaDatasetcst_pis_id.Required := False;
    Itens_SaidaDatasetcst_pis_id.Size := 255;
    Itens_SaidaDatasetcst_cofins_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcst_cofins_id.Name := 'Itens_SaidaDatasetcst_cofins_id';
    Itens_SaidaDatasetcst_cofins_id.FieldName := 'cst_cofins_id';
    Itens_SaidaDatasetcst_cofins_id.Required := False;
    Itens_SaidaDatasetcst_cofins_id.Size := 255;
    Itens_SaidaDatasetvalor_base_calculo_st_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_st_retida.Name := 'Itens_SaidaDatasetvalor_base_calculo_st_retida';
    Itens_SaidaDatasetvalor_base_calculo_st_retida.FieldName := 'valor_base_calculo_st_retida';
    Itens_SaidaDatasetvalor_base_calculo_st_retida.Required := False;
    Itens_SaidaDatasetvalor_st_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_st_retida.Name := 'Itens_SaidaDatasetvalor_st_retida';
    Itens_SaidaDatasetvalor_st_retida.FieldName := 'valor_st_retida';
    Itens_SaidaDatasetvalor_st_retida.Required := False;
    Itens_SaidaDatasetvalor_pis_retido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_pis_retido.Name := 'Itens_SaidaDatasetvalor_pis_retido';
    Itens_SaidaDatasetvalor_pis_retido.FieldName := 'valor_pis_retido';
    Itens_SaidaDatasetvalor_pis_retido.Required := False;
    Itens_SaidaDatasetvalor_cofins_retido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_cofins_retido.Name := 'Itens_SaidaDatasetvalor_cofins_retido';
    Itens_SaidaDatasetvalor_cofins_retido.FieldName := 'valor_cofins_retido';
    Itens_SaidaDatasetvalor_cofins_retido.Required := False;
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.Name := 'Itens_SaidaDatasetcodigo_natureza_pis_cofins_id';
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.FieldName := 'codigo_natureza_pis_cofins_id';
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.Required := False;
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.Size := 255;
    Itens_SaidaDatasetaliquota_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_id.Name := 'Itens_SaidaDatasetaliquota_id';
    Itens_SaidaDatasetaliquota_id.FieldName := 'aliquota_id';
    Itens_SaidaDatasetaliquota_id.Required := False;
    Itens_SaidaDatasetvalor_isentas.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_isentas.Name := 'Itens_SaidaDatasetvalor_isentas';
    Itens_SaidaDatasetvalor_isentas.FieldName := 'valor_isentas';
    Itens_SaidaDatasetvalor_isentas.Required := False;
    Itens_SaidaDatasetproduto_preco_custo.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_preco_custo.Name := 'Itens_SaidaDatasetproduto_preco_custo';
    Itens_SaidaDatasetproduto_preco_custo.FieldName := 'produto_preco_custo';
    Itens_SaidaDatasetproduto_preco_custo.Required := False;
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.Name := 'Itens_SaidaDatasetcodigo_produto_movimenta_estoque';
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.FieldName := 'codigo_produto_movimenta_estoque';
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.Required := False;
    Itens_SaidaDatasetfuncionario_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetfuncionario_id.Name := 'Itens_SaidaDatasetfuncionario_id';
    Itens_SaidaDatasetfuncionario_id.FieldName := 'funcionario_id';
    Itens_SaidaDatasetfuncionario_id.Required := False;
    Itens_SaidaDatasetvalor_total_impostos.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_total_impostos.Name := 'Itens_SaidaDatasetvalor_total_impostos';
    Itens_SaidaDatasetvalor_total_impostos.FieldName := 'valor_total_impostos';
    Itens_SaidaDatasetvalor_total_impostos.Required := False;
    Itens_SaidaDatasetquantidade_embalagem.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_embalagem.Name := 'Itens_SaidaDatasetquantidade_embalagem';
    Itens_SaidaDatasetquantidade_embalagem.FieldName := 'quantidade_embalagem';
    Itens_SaidaDatasetquantidade_embalagem.Required := False;
    Itens_SaidaDatasetitem_movimenta_estoque.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem_movimenta_estoque.Name := 'Itens_SaidaDatasetitem_movimenta_estoque';
    Itens_SaidaDatasetitem_movimenta_estoque.FieldName := 'item_movimenta_estoque';
    Itens_SaidaDatasetitem_movimenta_estoque.Required := True;
    Itens_SaidaDatasetgrade_produto_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetgrade_produto_id.Name := 'Itens_SaidaDatasetgrade_produto_id';
    Itens_SaidaDatasetgrade_produto_id.FieldName := 'grade_produto_id';
    Itens_SaidaDatasetgrade_produto_id.Required := False;
    Itens_SaidaDatasetproduto_nome.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetproduto_nome.Name := 'Itens_SaidaDatasetproduto_nome';
    Itens_SaidaDatasetproduto_nome.FieldName := 'produto_nome';
    Itens_SaidaDatasetproduto_nome.Required := False;
    Itens_SaidaDatasetproduto_nome.Size := 255;
    Itens_SaidaDatasetaliquota_interna.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_interna.Name := 'Itens_SaidaDatasetaliquota_interna';
    Itens_SaidaDatasetaliquota_interna.FieldName := 'aliquota_interna';
    Itens_SaidaDatasetaliquota_interna.Required := False;
    Itens_SaidaDatasetaliquota_interestadual.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_interestadual.Name := 'Itens_SaidaDatasetaliquota_interestadual';
    Itens_SaidaDatasetaliquota_interestadual.FieldName := 'aliquota_interestadual';
    Itens_SaidaDatasetaliquota_interestadual.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.Name := 'Itens_SaidaDatasetvalor_base_calculo_icms_interestadual';
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.FieldName := 'valor_base_calculo_icms_interestadual';
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.Required := False;
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.Name := 'Itens_SaidaDatasetaliquota_icms_interestadual_destino';
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.FieldName := 'aliquota_icms_interestadual_destino';
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.Required := False;
    Itens_SaidaDatasetvalor_icms_interestadual_destino.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_interestadual_destino.Name := 'Itens_SaidaDatasetvalor_icms_interestadual_destino';
    Itens_SaidaDatasetvalor_icms_interestadual_destino.FieldName := 'valor_icms_interestadual_destino';
    Itens_SaidaDatasetvalor_icms_interestadual_destino.Required := False;
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.Name := 'Itens_SaidaDatasetvalor_icms_interestadual_remetente';
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.FieldName := 'valor_icms_interestadual_remetente';
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.Required := False;
    Itens_SaidaDatasetaliquota_fcp.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp.Name := 'Itens_SaidaDatasetaliquota_fcp';
    Itens_SaidaDatasetaliquota_fcp.FieldName := 'aliquota_fcp';
    Itens_SaidaDatasetaliquota_fcp.Required := False;
    Itens_SaidaDatasetvalor_fcp.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp.Name := 'Itens_SaidaDatasetvalor_fcp';
    Itens_SaidaDatasetvalor_fcp.FieldName := 'valor_fcp';
    Itens_SaidaDatasetvalor_fcp.Required := False;
    Itens_SaidaDatasetnumero_pedido_compra.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetnumero_pedido_compra.Name := 'Itens_SaidaDatasetnumero_pedido_compra';
    Itens_SaidaDatasetnumero_pedido_compra.FieldName := 'numero_pedido_compra';
    Itens_SaidaDatasetnumero_pedido_compra.Required := False;
    Itens_SaidaDatasetnumero_pedido_compra.Size := 255;
    Itens_SaidaDatasetitem_pedido_compra.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem_pedido_compra.Name := 'Itens_SaidaDatasetitem_pedido_compra';
    Itens_SaidaDatasetitem_pedido_compra.FieldName := 'item_pedido_compra';
    Itens_SaidaDatasetitem_pedido_compra.Required := False;
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.Name := 'Itens_SaidaDatasetitem_quantidade_movimenta_estoque';
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.FieldName := 'item_quantidade_movimenta_estoque';
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.Required := False;
    Itens_SaidaDataseticms_st_recuperado.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDataseticms_st_recuperado.Name := 'Itens_SaidaDataseticms_st_recuperado';
    Itens_SaidaDataseticms_st_recuperado.FieldName := 'icms_st_recuperado';
    Itens_SaidaDataseticms_st_recuperado.Required := True;
    Itens_SaidaDatasetorigem_csosn_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetorigem_csosn_id.Name := 'Itens_SaidaDatasetorigem_csosn_id';
    Itens_SaidaDatasetorigem_csosn_id.FieldName := 'origem_csosn_id';
    Itens_SaidaDatasetorigem_csosn_id.Required := False;
    Itens_SaidaDatasetpercentual_gnn.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpercentual_gnn.Name := 'Itens_SaidaDatasetpercentual_gnn';
    Itens_SaidaDatasetpercentual_gnn.FieldName := 'percentual_gnn';
    Itens_SaidaDatasetpercentual_gnn.Required := False;
    Itens_SaidaDatasetpercentual_gni.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpercentual_gni.Name := 'Itens_SaidaDatasetpercentual_gni';
    Itens_SaidaDatasetpercentual_gni.FieldName := 'percentual_gni';
    Itens_SaidaDatasetpercentual_gni.Required := False;
    Itens_SaidaDatasetpercentual_glp.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpercentual_glp.Name := 'Itens_SaidaDatasetpercentual_glp';
    Itens_SaidaDatasetpercentual_glp.FieldName := 'percentual_glp';
    Itens_SaidaDatasetpercentual_glp.Required := False;
    Itens_SaidaDatasetvalor_partida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_partida.Name := 'Itens_SaidaDatasetvalor_partida';
    Itens_SaidaDatasetvalor_partida.FieldName := 'valor_partida';
    Itens_SaidaDatasetvalor_partida.Required := False;
    Itens_SaidaDatasetaliquota_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_st.Name := 'Itens_SaidaDatasetaliquota_st';
    Itens_SaidaDatasetaliquota_st.FieldName := 'aliquota_st';
    Itens_SaidaDatasetaliquota_st.Required := False;
    Itens_SaidaDatasetvalor_icms_st_reducao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_st_reducao.Name := 'Itens_SaidaDatasetvalor_icms_st_reducao';
    Itens_SaidaDatasetvalor_icms_st_reducao.FieldName := 'valor_icms_st_reducao';
    Itens_SaidaDatasetvalor_icms_st_reducao.Required := False;
    Itens_SaidaDatasetaliquota_st_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_st_retida.Name := 'Itens_SaidaDatasetaliquota_st_retida';
    Itens_SaidaDatasetaliquota_st_retida.FieldName := 'aliquota_st_retida';
    Itens_SaidaDatasetaliquota_st_retida.Required := False;
    Itens_SaidaDatasetvalor_icms_proprio.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_proprio.Name := 'Itens_SaidaDatasetvalor_icms_proprio';
    Itens_SaidaDatasetvalor_icms_proprio.FieldName := 'valor_icms_proprio';
    Itens_SaidaDatasetvalor_icms_proprio.Required := False;
    Itens_SaidaDatasetaliquota_icms_simples_nacional.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_icms_simples_nacional.Name := 'Itens_SaidaDatasetaliquota_icms_simples_nacional';
    Itens_SaidaDatasetaliquota_icms_simples_nacional.FieldName := 'aliquota_icms_simples_nacional';
    Itens_SaidaDatasetaliquota_icms_simples_nacional.Required := False;
    Itens_SaidaDatasetvalor_icms_simples_nacional.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_simples_nacional.Name := 'Itens_SaidaDatasetvalor_icms_simples_nacional';
    Itens_SaidaDatasetvalor_icms_simples_nacional.FieldName := 'valor_icms_simples_nacional';
    Itens_SaidaDatasetvalor_icms_simples_nacional.Required := False;
    Itens_SaidaDatasetvalor_icms_desonerado.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_desonerado.Name := 'Itens_SaidaDatasetvalor_icms_desonerado';
    Itens_SaidaDatasetvalor_icms_desonerado.FieldName := 'valor_icms_desonerado';
    Itens_SaidaDatasetvalor_icms_desonerado.Required := False;
    Itens_SaidaDatasetdesoneracao_icms_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetdesoneracao_icms_id.Name := 'Itens_SaidaDatasetdesoneracao_icms_id';
    Itens_SaidaDatasetdesoneracao_icms_id.FieldName := 'desoneracao_icms_id';
    Itens_SaidaDatasetdesoneracao_icms_id.Required := False;
    Itens_SaidaDatasetaliquota_ipi_devolvido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ipi_devolvido.Name := 'Itens_SaidaDatasetaliquota_ipi_devolvido';
    Itens_SaidaDatasetaliquota_ipi_devolvido.FieldName := 'aliquota_ipi_devolvido';
    Itens_SaidaDatasetaliquota_ipi_devolvido.Required := False;
    Itens_SaidaDatasetvalor_ipi_devolvido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_ipi_devolvido.Name := 'Itens_SaidaDatasetvalor_ipi_devolvido';
    Itens_SaidaDatasetvalor_ipi_devolvido.FieldName := 'valor_ipi_devolvido';
    Itens_SaidaDatasetvalor_ipi_devolvido.Required := False;
    Itens_SaidaDatasetmotivo_devolucao_ipi.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmotivo_devolucao_ipi.Name := 'Itens_SaidaDatasetmotivo_devolucao_ipi';
    Itens_SaidaDatasetmotivo_devolucao_ipi.FieldName := 'motivo_devolucao_ipi';
    Itens_SaidaDatasetmotivo_devolucao_ipi.Required := False;
    Itens_SaidaDatasetmotivo_devolucao_ipi.Size := 255;
    Itens_SaidaDatasetdesoneracao_icms_st_id.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetdesoneracao_icms_st_id.Name := 'Itens_SaidaDatasetdesoneracao_icms_st_id';
    Itens_SaidaDatasetdesoneracao_icms_st_id.FieldName := 'desoneracao_icms_st_id';
    Itens_SaidaDatasetdesoneracao_icms_st_id.Required := False;
    Itens_SaidaDatasetvalor_icms_st_desonerado.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_st_desonerado.Name := 'Itens_SaidaDatasetvalor_icms_st_desonerado';
    Itens_SaidaDatasetvalor_icms_st_desonerado.FieldName := 'valor_icms_st_desonerado';
    Itens_SaidaDatasetvalor_icms_st_desonerado.Required := False;
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.Name := 'Itens_SaidaDatasetobservacoes_contribuinte_identificacao';
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.FieldName := 'observacoes_contribuinte_identificacao';
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.Required := False;
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.Size := 255;
    Itens_SaidaDatasetobservacoes_contribuinte.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_contribuinte.Name := 'Itens_SaidaDatasetobservacoes_contribuinte';
    Itens_SaidaDatasetobservacoes_contribuinte.FieldName := 'observacoes_contribuinte';
    Itens_SaidaDatasetobservacoes_contribuinte.Required := False;
    Itens_SaidaDatasetobservacoes_contribuinte.Size := 255;
    Itens_SaidaDatasetobservacoes_fisco_identificacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_fisco_identificacao.Name := 'Itens_SaidaDatasetobservacoes_fisco_identificacao';
    Itens_SaidaDatasetobservacoes_fisco_identificacao.FieldName := 'observacoes_fisco_identificacao';
    Itens_SaidaDatasetobservacoes_fisco_identificacao.Required := False;
    Itens_SaidaDatasetobservacoes_fisco_identificacao.Size := 255;
    Itens_SaidaDatasetobservacoes_fisco.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetobservacoes_fisco.Name := 'Itens_SaidaDatasetobservacoes_fisco';
    Itens_SaidaDatasetobservacoes_fisco.FieldName := 'observacoes_fisco';
    Itens_SaidaDatasetobservacoes_fisco.Required := False;
    Itens_SaidaDatasetobservacoes_fisco.Size := 255;
    Itens_SaidaDatasetcodigo_produto_anvisa.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_produto_anvisa.Name := 'Itens_SaidaDatasetcodigo_produto_anvisa';
    Itens_SaidaDatasetcodigo_produto_anvisa.FieldName := 'codigo_produto_anvisa';
    Itens_SaidaDatasetcodigo_produto_anvisa.Required := False;
    Itens_SaidaDatasetcodigo_produto_anvisa.Size := 255;
    Itens_SaidaDatasetmotivo_isencao_anvisa.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetmotivo_isencao_anvisa.Name := 'Itens_SaidaDatasetmotivo_isencao_anvisa';
    Itens_SaidaDatasetmotivo_isencao_anvisa.FieldName := 'motivo_isencao_anvisa';
    Itens_SaidaDatasetmotivo_isencao_anvisa.Required := False;
    Itens_SaidaDatasetmotivo_isencao_anvisa.Size := 255;
    Itens_SaidaDatasetpreco_maximo_consumidor.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetpreco_maximo_consumidor.Name := 'Itens_SaidaDatasetpreco_maximo_consumidor';
    Itens_SaidaDatasetpreco_maximo_consumidor.FieldName := 'preco_maximo_consumidor';
    Itens_SaidaDatasetpreco_maximo_consumidor.Required := False;
    Itens_SaidaDatasetrastreabilidade_numero_lote.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_numero_lote.Name := 'Itens_SaidaDatasetrastreabilidade_numero_lote';
    Itens_SaidaDatasetrastreabilidade_numero_lote.FieldName := 'rastreabilidade_numero_lote';
    Itens_SaidaDatasetrastreabilidade_numero_lote.Required := False;
    Itens_SaidaDatasetrastreabilidade_numero_lote.Size := 255;
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.Name := 'Itens_SaidaDatasetrastreabilidade_data_fabricacao';
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.FieldName := 'rastreabilidade_data_fabricacao';
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.Required := False;
    Itens_SaidaDatasetrastreabilidade_data_validade.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_data_validade.Name := 'Itens_SaidaDatasetrastreabilidade_data_validade';
    Itens_SaidaDatasetrastreabilidade_data_validade.FieldName := 'rastreabilidade_data_validade';
    Itens_SaidaDatasetrastreabilidade_data_validade.Required := False;
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.Name := 'Itens_SaidaDatasetrastreabilidade_codigo_agregacao';
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.FieldName := 'rastreabilidade_codigo_agregacao';
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.Required := False;
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.Size := 255;
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.Name := 'Itens_SaidaDatasetvalor_base_calculo_fcp_icms';
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.FieldName := 'valor_base_calculo_fcp_icms';
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.Required := False;
    Itens_SaidaDatasetaliquota_fcp_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp_icms.Name := 'Itens_SaidaDatasetaliquota_fcp_icms';
    Itens_SaidaDatasetaliquota_fcp_icms.FieldName := 'aliquota_fcp_icms';
    Itens_SaidaDatasetaliquota_fcp_icms.Required := False;
    Itens_SaidaDatasetvalor_fcp_icms.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp_icms.Name := 'Itens_SaidaDatasetvalor_fcp_icms';
    Itens_SaidaDatasetvalor_fcp_icms.FieldName := 'valor_fcp_icms';
    Itens_SaidaDatasetvalor_fcp_icms.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.Name := 'Itens_SaidaDatasetvalor_base_calculo_fcp_st';
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.FieldName := 'valor_base_calculo_fcp_st';
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.Required := False;
    Itens_SaidaDatasetaliquota_fcp_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp_st.Name := 'Itens_SaidaDatasetaliquota_fcp_st';
    Itens_SaidaDatasetaliquota_fcp_st.FieldName := 'aliquota_fcp_st';
    Itens_SaidaDatasetaliquota_fcp_st.Required := False;
    Itens_SaidaDatasetvalor_fcp_st.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp_st.Name := 'Itens_SaidaDatasetvalor_fcp_st';
    Itens_SaidaDatasetvalor_fcp_st.FieldName := 'valor_fcp_st';
    Itens_SaidaDatasetvalor_fcp_st.Required := False;
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.Name := 'Itens_SaidaDatasetvalor_base_calculo_fcp_retida';
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.FieldName := 'valor_base_calculo_fcp_retida';
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.Required := False;
    Itens_SaidaDatasetaliquota_fcp_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_fcp_retida.Name := 'Itens_SaidaDatasetaliquota_fcp_retida';
    Itens_SaidaDatasetaliquota_fcp_retida.FieldName := 'aliquota_fcp_retida';
    Itens_SaidaDatasetaliquota_fcp_retida.Required := False;
    Itens_SaidaDatasetvalor_fcp_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_fcp_retida.Name := 'Itens_SaidaDatasetvalor_fcp_retida';
    Itens_SaidaDatasetvalor_fcp_retida.FieldName := 'valor_fcp_retida';
    Itens_SaidaDatasetvalor_fcp_retida.Required := False;
    Itens_SaidaDatasetinformacoes_adicionais.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetinformacoes_adicionais.Name := 'Itens_SaidaDatasetinformacoes_adicionais';
    Itens_SaidaDatasetinformacoes_adicionais.FieldName := 'informacoes_adicionais';
    Itens_SaidaDatasetinformacoes_adicionais.Required := False;
    Itens_SaidaDatasetinformacoes_adicionais.Size := 255;
    Itens_SaidaDatasetquantidade_monofasica.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_monofasica.Name := 'Itens_SaidaDatasetquantidade_monofasica';
    Itens_SaidaDatasetquantidade_monofasica.FieldName := 'quantidade_monofasica';
    Itens_SaidaDatasetquantidade_monofasica.Required := False;
    Itens_SaidaDatasetaliquota_ad_rem.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ad_rem.Name := 'Itens_SaidaDatasetaliquota_ad_rem';
    Itens_SaidaDatasetaliquota_ad_rem.FieldName := 'aliquota_ad_rem';
    Itens_SaidaDatasetaliquota_ad_rem.Required := False;
    Itens_SaidaDatasetvalor_icms_monofasico.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_monofasico.Name := 'Itens_SaidaDatasetvalor_icms_monofasico';
    Itens_SaidaDatasetvalor_icms_monofasico.FieldName := 'valor_icms_monofasico';
    Itens_SaidaDatasetvalor_icms_monofasico.Required := False;
    Itens_SaidaDatasetquantidade_monofasica_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetquantidade_monofasica_retida.Name := 'Itens_SaidaDatasetquantidade_monofasica_retida';
    Itens_SaidaDatasetquantidade_monofasica_retida.FieldName := 'quantidade_monofasica_retida';
    Itens_SaidaDatasetquantidade_monofasica_retida.Required := False;
    Itens_SaidaDatasetaliquota_ad_rem_retida.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetaliquota_ad_rem_retida.Name := 'Itens_SaidaDatasetaliquota_ad_rem_retida';
    Itens_SaidaDatasetaliquota_ad_rem_retida.FieldName := 'aliquota_ad_rem_retida';
    Itens_SaidaDatasetaliquota_ad_rem_retida.Required := False;
    Itens_SaidaDatasetvalor_icms_monofasico_retido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetvalor_icms_monofasico_retido.Name := 'Itens_SaidaDatasetvalor_icms_monofasico_retido';
    Itens_SaidaDatasetvalor_icms_monofasico_retido.FieldName := 'valor_icms_monofasico_retido';
    Itens_SaidaDatasetvalor_icms_monofasico_retido.Required := False;
    Itens_SaidaDatasetcodigo_interno.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetcodigo_interno.Name := 'Itens_SaidaDatasetcodigo_interno';
    Itens_SaidaDatasetcodigo_interno.FieldName := 'codigo_interno';
    Itens_SaidaDatasetcodigo_interno.Required := True;
    Itens_SaidaDatasetexcluido.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetexcluido.Name := 'Itens_SaidaDatasetexcluido';
    Itens_SaidaDatasetexcluido.FieldName := 'excluido';
    Itens_SaidaDatasetexcluido.Required := False;
    Itens_SaidaDatasetinclusao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetinclusao.Name := 'Itens_SaidaDatasetinclusao';
    Itens_SaidaDatasetinclusao.FieldName := 'inclusao';
    Itens_SaidaDatasetinclusao.Required := False;
    Itens_SaidaDatasetalteracao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetalteracao.Name := 'Itens_SaidaDatasetalteracao';
    Itens_SaidaDatasetalteracao.FieldName := 'alteracao';
    Itens_SaidaDatasetalteracao.Required := False;
    Itens_SaidaDatasetexclusao.SetParentComponent(Itens_SaidaDataset);
    Itens_SaidaDatasetexclusao.Name := 'Itens_SaidaDatasetexclusao';
    Itens_SaidaDatasetexclusao.FieldName := 'exclusao';
    Itens_SaidaDatasetexclusao.Required := False;
    XDataClientItens_SaidaGet.SetParentComponent(Self);
    XDataClientItens_SaidaGet.Name := 'XDataClientItens_SaidaGet';
    XDataClientItens_SaidaGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientItens_SaidaGet, Self, 'OnLoad', 'XDataClientItens_SaidaGetLoad');
    XDataClientItens_SaidaGet.Left := 64;
    XDataClientItens_SaidaGet.Top := 8;
    XDataClientItens_SaidaDelete.SetParentComponent(Self);
    XDataClientItens_SaidaDelete.Name := 'XDataClientItens_SaidaDelete';
    XDataClientItens_SaidaDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientItens_SaidaDelete, Self, 'OnLoad', 'XDataClientItens_SaidaDeleteLoad');
    SetEvent(XDataClientItens_SaidaDelete, Self, 'OnError', 'XDataClientItens_SaidaDeleteError');
    XDataClientItens_SaidaDelete.Left := 64;
    XDataClientItens_SaidaDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbvenda_id.AfterLoadDFMValues;
    edvenda_id.AfterLoadDFMValues;
    lbproduto_id.AfterLoadDFMValues;
    edproduto_id.AfterLoadDFMValues;
    lbunidade_id.AfterLoadDFMValues;
    edunidade_id.AfterLoadDFMValues;
    lbitem.AfterLoadDFMValues;
    editem.AfterLoadDFMValues;
    lbcfop_cfop.AfterLoadDFMValues;
    edcfop_cfop.AfterLoadDFMValues;
    lbquantidade.AfterLoadDFMValues;
    edquantidade.AfterLoadDFMValues;
    lbproduto_preco.AfterLoadDFMValues;
    edproduto_preco.AfterLoadDFMValues;
    lbmargem_acrescimo.AfterLoadDFMValues;
    edmargem_acrescimo.AfterLoadDFMValues;
    lbvalor_acrescimo.AfterLoadDFMValues;
    edvalor_acrescimo.AfterLoadDFMValues;
    lbmargem_desconto.AfterLoadDFMValues;
    edmargem_desconto.AfterLoadDFMValues;
    lbvalor_desconto.AfterLoadDFMValues;
    edvalor_desconto.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    lbaliquota_icms.AfterLoadDFMValues;
    edaliquota_icms.AfterLoadDFMValues;
    lbvalor_icms.AfterLoadDFMValues;
    edvalor_icms.AfterLoadDFMValues;
    lbaliquota_icms_red.AfterLoadDFMValues;
    edaliquota_icms_red.AfterLoadDFMValues;
    lbvalor_icms_red.AfterLoadDFMValues;
    edvalor_icms_red.AfterLoadDFMValues;
    lbaliquota_icms_st.AfterLoadDFMValues;
    edaliquota_icms_st.AfterLoadDFMValues;
    lbvalor_icms_st.AfterLoadDFMValues;
    edvalor_icms_st.AfterLoadDFMValues;
    lbaliquota_ipi.AfterLoadDFMValues;
    edaliquota_ipi.AfterLoadDFMValues;
    lbvalor_ipi.AfterLoadDFMValues;
    edvalor_ipi.AfterLoadDFMValues;
    lbvalor_base_calculo_icms.AfterLoadDFMValues;
    edvalor_base_calculo_icms.AfterLoadDFMValues;
    lbvalor_base_calculo_st.AfterLoadDFMValues;
    edvalor_base_calculo_st.AfterLoadDFMValues;
    lbcst_id.AfterLoadDFMValues;
    edcst_id.AfterLoadDFMValues;
    lbvalor_frete.AfterLoadDFMValues;
    edvalor_frete.AfterLoadDFMValues;
    lbvalor_seguro.AfterLoadDFMValues;
    edvalor_seguro.AfterLoadDFMValues;
    lbvalor_despesas_acessorias.AfterLoadDFMValues;
    edvalor_despesas_acessorias.AfterLoadDFMValues;
    lbvalor_outras.AfterLoadDFMValues;
    edvalor_outras.AfterLoadDFMValues;
    lbvalor_base_calculo_ipi.AfterLoadDFMValues;
    edvalor_base_calculo_ipi.AfterLoadDFMValues;
    lbvalor_base_calculo_pis.AfterLoadDFMValues;
    edvalor_base_calculo_pis.AfterLoadDFMValues;
    lbvalor_pis.AfterLoadDFMValues;
    edvalor_pis.AfterLoadDFMValues;
    lbvalor_base_calculo_cofins.AfterLoadDFMValues;
    edvalor_base_calculo_cofins.AfterLoadDFMValues;
    lbvalor_cofins.AfterLoadDFMValues;
    edvalor_cofins.AfterLoadDFMValues;
    lbquantidade_selo_ipi.AfterLoadDFMValues;
    edquantidade_selo_ipi.AfterLoadDFMValues;
    lbcst_ipi_id.AfterLoadDFMValues;
    edcst_ipi_id.AfterLoadDFMValues;
    lbcsosn_id.AfterLoadDFMValues;
    edcsosn_id.AfterLoadDFMValues;
    lbvalor_ipi_unitario.AfterLoadDFMValues;
    edvalor_ipi_unitario.AfterLoadDFMValues;
    lbaliquota_pis.AfterLoadDFMValues;
    edaliquota_pis.AfterLoadDFMValues;
    lbaliquota_cofins.AfterLoadDFMValues;
    edaliquota_cofins.AfterLoadDFMValues;
    lbcst_pis_id.AfterLoadDFMValues;
    edcst_pis_id.AfterLoadDFMValues;
    lbcst_cofins_id.AfterLoadDFMValues;
    edcst_cofins_id.AfterLoadDFMValues;
    lbvalor_base_calculo_st_retida.AfterLoadDFMValues;
    edvalor_base_calculo_st_retida.AfterLoadDFMValues;
    lbvalor_st_retida.AfterLoadDFMValues;
    edvalor_st_retida.AfterLoadDFMValues;
    lbvalor_pis_retido.AfterLoadDFMValues;
    edvalor_pis_retido.AfterLoadDFMValues;
    lbvalor_cofins_retido.AfterLoadDFMValues;
    edvalor_cofins_retido.AfterLoadDFMValues;
    lbcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    edcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    lbaliquota_id.AfterLoadDFMValues;
    edaliquota_id.AfterLoadDFMValues;
    lbvalor_isentas.AfterLoadDFMValues;
    edvalor_isentas.AfterLoadDFMValues;
    lbproduto_preco_custo.AfterLoadDFMValues;
    edproduto_preco_custo.AfterLoadDFMValues;
    lbcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    edcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    lbvalor_total_impostos.AfterLoadDFMValues;
    edvalor_total_impostos.AfterLoadDFMValues;
    lbquantidade_embalagem.AfterLoadDFMValues;
    edquantidade_embalagem.AfterLoadDFMValues;
    lbitem_movimenta_estoque.AfterLoadDFMValues;
    editem_movimenta_estoque.AfterLoadDFMValues;
    lbgrade_produto_id.AfterLoadDFMValues;
    edgrade_produto_id.AfterLoadDFMValues;
    lbproduto_nome.AfterLoadDFMValues;
    edproduto_nome.AfterLoadDFMValues;
    lbaliquota_interna.AfterLoadDFMValues;
    edaliquota_interna.AfterLoadDFMValues;
    lbaliquota_interestadual.AfterLoadDFMValues;
    edaliquota_interestadual.AfterLoadDFMValues;
    lbvalor_base_calculo_icms_interestadual.AfterLoadDFMValues;
    edvalor_base_calculo_icms_interestadual.AfterLoadDFMValues;
    lbaliquota_icms_interestadual_destino.AfterLoadDFMValues;
    edaliquota_icms_interestadual_destino.AfterLoadDFMValues;
    lbvalor_icms_interestadual_destino.AfterLoadDFMValues;
    edvalor_icms_interestadual_destino.AfterLoadDFMValues;
    lbvalor_icms_interestadual_remetente.AfterLoadDFMValues;
    edvalor_icms_interestadual_remetente.AfterLoadDFMValues;
    lbaliquota_fcp.AfterLoadDFMValues;
    edaliquota_fcp.AfterLoadDFMValues;
    lbvalor_fcp.AfterLoadDFMValues;
    edvalor_fcp.AfterLoadDFMValues;
    lbnumero_pedido_compra.AfterLoadDFMValues;
    ednumero_pedido_compra.AfterLoadDFMValues;
    lbitem_pedido_compra.AfterLoadDFMValues;
    editem_pedido_compra.AfterLoadDFMValues;
    lbitem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    editem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    lbicms_st_recuperado.AfterLoadDFMValues;
    edicms_st_recuperado.AfterLoadDFMValues;
    lborigem_csosn_id.AfterLoadDFMValues;
    edorigem_csosn_id.AfterLoadDFMValues;
    lbpercentual_gnn.AfterLoadDFMValues;
    edpercentual_gnn.AfterLoadDFMValues;
    lbpercentual_gni.AfterLoadDFMValues;
    edpercentual_gni.AfterLoadDFMValues;
    lbpercentual_glp.AfterLoadDFMValues;
    edpercentual_glp.AfterLoadDFMValues;
    lbvalor_partida.AfterLoadDFMValues;
    edvalor_partida.AfterLoadDFMValues;
    lbaliquota_st.AfterLoadDFMValues;
    edaliquota_st.AfterLoadDFMValues;
    lbvalor_icms_st_reducao.AfterLoadDFMValues;
    edvalor_icms_st_reducao.AfterLoadDFMValues;
    lbaliquota_st_retida.AfterLoadDFMValues;
    edaliquota_st_retida.AfterLoadDFMValues;
    lbvalor_icms_proprio.AfterLoadDFMValues;
    edvalor_icms_proprio.AfterLoadDFMValues;
    lbaliquota_icms_simples_nacional.AfterLoadDFMValues;
    edaliquota_icms_simples_nacional.AfterLoadDFMValues;
    lbvalor_icms_simples_nacional.AfterLoadDFMValues;
    edvalor_icms_simples_nacional.AfterLoadDFMValues;
    lbvalor_icms_desonerado.AfterLoadDFMValues;
    edvalor_icms_desonerado.AfterLoadDFMValues;
    lbdesoneracao_icms_id.AfterLoadDFMValues;
    eddesoneracao_icms_id.AfterLoadDFMValues;
    lbaliquota_ipi_devolvido.AfterLoadDFMValues;
    edaliquota_ipi_devolvido.AfterLoadDFMValues;
    lbvalor_ipi_devolvido.AfterLoadDFMValues;
    edvalor_ipi_devolvido.AfterLoadDFMValues;
    lbmotivo_devolucao_ipi.AfterLoadDFMValues;
    edmotivo_devolucao_ipi.AfterLoadDFMValues;
    lbdesoneracao_icms_st_id.AfterLoadDFMValues;
    eddesoneracao_icms_st_id.AfterLoadDFMValues;
    lbvalor_icms_st_desonerado.AfterLoadDFMValues;
    edvalor_icms_st_desonerado.AfterLoadDFMValues;
    lbobservacoes_contribuinte_identificacao.AfterLoadDFMValues;
    edobservacoes_contribuinte_identificacao.AfterLoadDFMValues;
    lbobservacoes_contribuinte.AfterLoadDFMValues;
    edobservacoes_contribuinte.AfterLoadDFMValues;
    lbobservacoes_fisco_identificacao.AfterLoadDFMValues;
    edobservacoes_fisco_identificacao.AfterLoadDFMValues;
    lbobservacoes_fisco.AfterLoadDFMValues;
    edobservacoes_fisco.AfterLoadDFMValues;
    lbcodigo_produto_anvisa.AfterLoadDFMValues;
    edcodigo_produto_anvisa.AfterLoadDFMValues;
    lbmotivo_isencao_anvisa.AfterLoadDFMValues;
    edmotivo_isencao_anvisa.AfterLoadDFMValues;
    lbpreco_maximo_consumidor.AfterLoadDFMValues;
    edpreco_maximo_consumidor.AfterLoadDFMValues;
    lbrastreabilidade_numero_lote.AfterLoadDFMValues;
    edrastreabilidade_numero_lote.AfterLoadDFMValues;
    lbrastreabilidade_data_fabricacao.AfterLoadDFMValues;
    edrastreabilidade_data_fabricacao.AfterLoadDFMValues;
    lbrastreabilidade_data_validade.AfterLoadDFMValues;
    edrastreabilidade_data_validade.AfterLoadDFMValues;
    lbrastreabilidade_codigo_agregacao.AfterLoadDFMValues;
    edrastreabilidade_codigo_agregacao.AfterLoadDFMValues;
    lbvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    edvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    lbaliquota_fcp_icms.AfterLoadDFMValues;
    edaliquota_fcp_icms.AfterLoadDFMValues;
    lbvalor_fcp_icms.AfterLoadDFMValues;
    edvalor_fcp_icms.AfterLoadDFMValues;
    lbvalor_base_calculo_fcp_st.AfterLoadDFMValues;
    edvalor_base_calculo_fcp_st.AfterLoadDFMValues;
    lbaliquota_fcp_st.AfterLoadDFMValues;
    edaliquota_fcp_st.AfterLoadDFMValues;
    lbvalor_fcp_st.AfterLoadDFMValues;
    edvalor_fcp_st.AfterLoadDFMValues;
    lbvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    edvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    lbaliquota_fcp_retida.AfterLoadDFMValues;
    edaliquota_fcp_retida.AfterLoadDFMValues;
    lbvalor_fcp_retida.AfterLoadDFMValues;
    edvalor_fcp_retida.AfterLoadDFMValues;
    lbinformacoes_adicionais.AfterLoadDFMValues;
    edinformacoes_adicionais.AfterLoadDFMValues;
    lbquantidade_monofasica.AfterLoadDFMValues;
    edquantidade_monofasica.AfterLoadDFMValues;
    lbaliquota_ad_rem.AfterLoadDFMValues;
    edaliquota_ad_rem.AfterLoadDFMValues;
    lbvalor_icms_monofasico.AfterLoadDFMValues;
    edvalor_icms_monofasico.AfterLoadDFMValues;
    lbquantidade_monofasica_retida.AfterLoadDFMValues;
    edquantidade_monofasica_retida.AfterLoadDFMValues;
    lbaliquota_ad_rem_retida.AfterLoadDFMValues;
    edaliquota_ad_rem_retida.AfterLoadDFMValues;
    lbvalor_icms_monofasico_retido.AfterLoadDFMValues;
    edvalor_icms_monofasico_retido.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Itens_SaidaDataset.AfterLoadDFMValues;
    Itens_SaidaDatasetid.AfterLoadDFMValues;
    Itens_SaidaDatasetaliado_id.AfterLoadDFMValues;
    Itens_SaidaDatasetdata_base_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvenda_id.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_id.AfterLoadDFMValues;
    Itens_SaidaDatasetunidade_id.AfterLoadDFMValues;
    Itens_SaidaDatasetitem.AfterLoadDFMValues;
    Itens_SaidaDatasetcfop_cfop.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_preco.AfterLoadDFMValues;
    Itens_SaidaDatasetmargem_acrescimo.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_acrescimo.AfterLoadDFMValues;
    Itens_SaidaDatasetmargem_desconto.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_desconto.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_total.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_red.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_red.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_st.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_st.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_frete.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_seguro.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_despesas_acessorias.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_outras.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_pis.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_pis.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_cofins.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_cofins.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_selo_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_ipi_id.AfterLoadDFMValues;
    Itens_SaidaDatasetcsosn_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_ipi_unitario.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_pis.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_cofins.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_pis_id.AfterLoadDFMValues;
    Itens_SaidaDatasetcst_cofins_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_st_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_st_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_pis_retido.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_cofins_retido.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_isentas.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_preco_custo.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    Itens_SaidaDatasetfuncionario_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_total_impostos.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_embalagem.AfterLoadDFMValues;
    Itens_SaidaDatasetitem_movimenta_estoque.AfterLoadDFMValues;
    Itens_SaidaDatasetgrade_produto_id.AfterLoadDFMValues;
    Itens_SaidaDatasetproduto_nome.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_interna.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_interestadual.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_icms_interestadual.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_interestadual_destino.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_interestadual_destino.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_interestadual_remetente.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp.AfterLoadDFMValues;
    Itens_SaidaDatasetnumero_pedido_compra.AfterLoadDFMValues;
    Itens_SaidaDatasetitem_pedido_compra.AfterLoadDFMValues;
    Itens_SaidaDatasetitem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    Itens_SaidaDataseticms_st_recuperado.AfterLoadDFMValues;
    Itens_SaidaDatasetorigem_csosn_id.AfterLoadDFMValues;
    Itens_SaidaDatasetpercentual_gnn.AfterLoadDFMValues;
    Itens_SaidaDatasetpercentual_gni.AfterLoadDFMValues;
    Itens_SaidaDatasetpercentual_glp.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_partida.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_st_reducao.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_st_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_proprio.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_icms_simples_nacional.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_simples_nacional.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_desonerado.AfterLoadDFMValues;
    Itens_SaidaDatasetdesoneracao_icms_id.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ipi_devolvido.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_ipi_devolvido.AfterLoadDFMValues;
    Itens_SaidaDatasetmotivo_devolucao_ipi.AfterLoadDFMValues;
    Itens_SaidaDatasetdesoneracao_icms_st_id.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_st_desonerado.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_contribuinte_identificacao.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_contribuinte.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_fisco_identificacao.AfterLoadDFMValues;
    Itens_SaidaDatasetobservacoes_fisco.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_produto_anvisa.AfterLoadDFMValues;
    Itens_SaidaDatasetmotivo_isencao_anvisa.AfterLoadDFMValues;
    Itens_SaidaDatasetpreco_maximo_consumidor.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_numero_lote.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_data_fabricacao.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_data_validade.AfterLoadDFMValues;
    Itens_SaidaDatasetrastreabilidade_codigo_agregacao.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp_icms.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_fcp_st.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp_st.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_fcp_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_fcp_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetinformacoes_adicionais.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_monofasica.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ad_rem.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_monofasico.AfterLoadDFMValues;
    Itens_SaidaDatasetquantidade_monofasica_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetaliquota_ad_rem_retida.AfterLoadDFMValues;
    Itens_SaidaDatasetvalor_icms_monofasico_retido.AfterLoadDFMValues;
    Itens_SaidaDatasetcodigo_interno.AfterLoadDFMValues;
    Itens_SaidaDatasetexcluido.AfterLoadDFMValues;
    Itens_SaidaDatasetinclusao.AfterLoadDFMValues;
    Itens_SaidaDatasetalteracao.AfterLoadDFMValues;
    Itens_SaidaDatasetexclusao.AfterLoadDFMValues;
    XDataClientItens_SaidaGet.AfterLoadDFMValues;
    XDataClientItens_SaidaDelete.AfterLoadDFMValues;
  end;
end;

end.
